var process = require("../shim/process.js");
const THREE = require("three");
require("../libs/Capsule.js")(THREE);
require("../libs/Raycaster2.js")(THREE);
const map = require("./map.js");
const config = require("../config.js");
const gameModes = require("./gameModes.js");
const medals = require("./medals.js");
const colors = require("./colors.js");
const UTILS = require("../libs/utils.js");
const collisions = new (require("./collisions.js"))(THREE);
const prefabs = new (require("./prefabs.js"))();
const triggers = require("./triggers.js");
const PlayerManager = require("./players.js");
const Player = require("./player.js");
const classes = require("./classes.js");
let version = require("../../version.json");
let vLN02076 = 0;
const mmProps = require("./mmProps.js");
const serverProps = require("./serverProps.js");
const {
  validateMap
} = require("./customGameConfig.js");
const itemTypes = require("./itemTypes.js");
const rarities = require("./rarities.js");
const worldPos = new THREE.Vector3();
const maps = require("./maps.js")();
const BotManager = require("./bots.js");
module.exports = function (isCustom, id, dbClient, RENDER, nftClient, SOUND, PARTICLES, overlay, io, serverIO, serverManager, serverPort, officialConfig, dedicatedConfig, serverHooks, battlePass) {
  Object.defineProperty(this, "isServer", {
    get() {
      if (serverIO) {
        return 1;
      } else {
        return 0;
      }
    }
  });
  this.THREE = THREE;
  this.COLLISIONS = collisions;
  this.isOfficial = officialConfig;
  this.isCustom = !!isCustom;
  this.isDedicated = dedicatedConfig;
  this.isPrimary = id == 0;
  this.playTime = 0;
  this.playCount = 0;
  this.uniquePlays = [];
  this.updatedGameInstance = false;
  this.connectedClients = 0;
  this.bypassedUsers = 0;
  this.password = undefined;
  this.sid = vLN02076++;
  this.gameInstance = null;
  this.initInProgress = false;
  this.isDestroyed = false;
  this.initQueue = [];
  this.gameClosed = false;
  this.experimentalFeatures = false;
  this.map = new map(maps, RENDER, PARTICLES, SOUND);
  this.bots = new BotManager(this);
  this.store = require("./store.js");
  this.badges = require("./badges.js");
  this.flags = require("./flags.js");
  this.weapons = require("./weapons.js");
  this.upgradeWeapons = require("./upgradeWeapons.js");
  this.BUILD_OBJS = require("./buildObjs.js");
  this.buildCount = 0;
  this.attach = require("./attach.js");
  this.challenges = require("./challenges.js");
  this.leaderboard = new (require("./leaderboard.js"))(this, serverIO, dbClient);
  this.classes = classes;
  this.streaks = require("./streaks.js");
  this.effects = require("./effects.js");
  this.airDrop = new (require("./airDrop.js"))(this, serverIO, RENDER, SOUND);
  this.triggers = triggers;
  this.AI = new (require("./AI.js"))(this, RENDER, serverIO);
  this.projectiles = new (require("./projectiles.js"))(this, serverIO);
  this.raycaster = new THREE.Raycaster2();
  this.controls = null;
  this.playerMesh = new (require("./playerMesh.js"))(RENDER, THREE);
  this.players = new PlayerManager(this, RENDER, SOUND, PARTICLES, prefabs, serverIO);
  this.pets = new (require("./pets.js"))(this, RENDER, serverIO);
  this.movement = require("./movement.js");
  this.endData = {
    ed: [],
    vo: null,
    mts: [],
    mdls: []
  };
  this.customGUIs = [];
  this.endTimer = 0;
  this.endIndex = null;
  this.hideWeapon = [false, false, false];
  this.banList = [];
  this.banTempList = [];
  this.voteToKick = null;
  this.voteInitiators = [];
  this.voteToForfeit = null;
  this.forfeitInitiators = [];
  this.teamFlags = [];
  this.teamScoreUpd = [];
  var v12286;
  var v12287;
  var v12288;
  var game = this;
  this.lastAmbS = null;
  this.lastAmbSC = null;
  this.passCode = null;
  this.krRewards = false;
  this.mimicPubs = false;
  this.defaultSetts = false;
  this.leaverTimeout = 120000;
  this.afkTimeout = 300000;
  this.loadedSprays = {};
  this.triggerQueue = [];
  this.playerSounds = [];
  this.globalVals = {};
  this.config = {};
  this.isComp = false;
  this.useLOD = true;
  this.hidePlayers = false;
  this.sendFrequency = config.serverSendFrequency;
  this.tickFrequency = config.serverTickFrequency;
  this.tickRate = 1000 / this.tickFrequency;
  this.syncFrequency = config.serverSyncFrequency;
  this.syncRate = 1000 / this.syncFrequency;
  this.aiSyncT = config.aiSyncT;
  this.leaderOSync = config.leaderOSync;
  this.airDSyncT = config.airDSyncT;
  this.networkData = null;
  this.eventIndex = 0;
  this.eventTimer = 0;
  this.eventTriggered = false;
  this.sessionId = serverIO ? UTILS.generateUUID() : null;
  this.triggerTypes = [];
  this.hostTransfers = 0;
  this.secTimer = 0;
  this.didChecks = false;
  if (!serverIO) {
    var v12289 = window.log || console.log;
  }
  const ksL = serverIO ? {
    log: function (args) {
      if (game && game.broadcast) {
        game.broadcast("ksL", false, args.map(arg => UTILS.logStringify(arg)));
      }
    },
    error: function (args) {
      if (game && game.broadcast) {
        game.broadcast("ksL", true, args.map(arg => UTILS.logStringify(arg)));
      }
    }
  } : {
    log: function (args) {
      v12289("%c[KRUNKSCRIPT] " + args.map(arg => UTILS.logStringify(arg)).join(" "), "color:#00b8d4");
    },
    error: function (args) {
      v12289("%c[KRUNKSCRIPT] " + args.map(arg => UTILS.logStringify(arg)).join(" "), "background:#3a0000;color:#00b8d4");
    }
  };
  const runtime = require("../libs/krunkScriptRuntime.js")(config.sysLibName, ksL, overlay, !RENDER, RENDER ? io : serverIO, this, RENDER, nftClient, SOUND);
  this.mainScript = null;
  this.addScripts = function (scripts, side) {
    if ((side == "client" || config.serverScripting) && config.scriptingEnabled && scripts && scripts[side]) {
      const v12291 = scripts[side].replace(/（/gm, "(").replace(/）/gm, ")");
      this.mainScript = runtime.parse(v12291);
    }
  };
  this.hasHost = function () {
    return !!game.host || !!game.isDedicated;
  };
  this.isPubType = function () {
    return !this.hasHost() || !!this.hasHost() && !!this.mimicPubs;
  };
  this.lobbyPlayers = {};
  this.updLobbyP = function (player, lobbyId, key, value) {
    var v12292 = game.lobbyPlayers[lobbyId];
    if (v12292 && v12292[key] != value && UTILS.isNumber(value)) {
      var v12293 = false;
      if (key == "c") {
        v12293 = true;
        var v12294 = game.config.limitClasses;
        if (v12294) {
          var v12295 = game.config["classLim" + value] || 0;
          var vLN02078 = 0;
          if (v12295) {
            for (var v12299 in game.lobbyPlayers) {
              if (game.lobbyPlayers.hasOwnProperty(v12299)) {
                var v12300 = game.lobbyPlayers[v12299];
                if (v12300 && v12300.t == v12292.t && v12300.c == value && (vLN02078++, vLN02078 >= v12295)) {
                  v12293 = false;
                  break;
                }
              }
            }
          } else {
            v12293 = false;
          }
        }
      }
      if (key == "t" && game.config.selTeam) {
        v12293 = true;
        var v12298 = (game.config.tmSize || 0) + 1;
        var vLN02078 = 0;
        for (var v12299 in game.lobbyPlayers) {
          if (game.lobbyPlayers.hasOwnProperty(v12299)) {
            var v12300 = game.lobbyPlayers[v12299];
            if (v12300 && v12300.a && v12300.t == value && (vLN02078++, vLN02078 >= v12298)) {
              v12293 = false;
              break;
            }
          }
        }
        if (v12293) {
          delete game.lobbyPlayers[lobbyId].c;
        }
      }
      return !!v12293 && (game.lobbyPlayers[lobbyId][key] = value, game.syncLobbyP(player, lobbyId, 0), true);
    }
  };
  this.syncLobbyP = function (player, lobbyId, action) {
    if (game.isComp) {
      if (action == 0) {
        var v12301 = player.account || {};
        var v12302 = !game.lobbyPlayers[lobbyId];
        if (v12302) {
          game.lobbyPlayers[lobbyId] = {};
        }
        if (v12301 || !v12302) {
          game.lobbyPlayers[lobbyId].i = v12301.id || 0;
          game.lobbyPlayers[lobbyId].n = v12301.name || 0;
          game.lobbyPlayers[lobbyId].v = v12301.featured || 0;
          game.lobbyPlayers[lobbyId].cl = v12301.clan || 0;
          game.lobbyPlayers[lobbyId].l = v12301.level || 0;
          game.lobbyPlayers[lobbyId].f = v12301 && v12301.stats && v12301.stats.flg != null ? v12301.stats.flg : -1;
        }
        var v12303 = !game.lobbyPlayers[lobbyId].a;
        game.lobbyPlayers[lobbyId].a = 1;
        if (v12302 || v12303) {
          serverIO.send(player.id, "cd", game.lobbyPlayers);
          game.broadcastEx(player.id, "cda", lobbyId, game.lobbyPlayers[lobbyId]);
        } else {
          game.broadcast("cda", lobbyId, game.lobbyPlayers[lobbyId]);
        }
      } else if (action == 1 && game.lobbyPlayers[lobbyId]) {
        var v12304 = game.lobbyPlayers[lobbyId].a == 1 && game.lobbyPlayers[lobbyId].t != null;
        if (v12304) {
          game.lobbyPlayers[lobbyId].rej = 1;
        }
        game.lobbyPlayers[lobbyId].a = 0;
        delete game.lobbyPlayers[lobbyId].c;
        delete game.lobbyPlayers[lobbyId].t;
        game.broadcast("cda", lobbyId, null);
      }
    }
  };
  this.getLobbyDat = function (key, lobbyId, defaultVal) {
    var v12305 = game.lobbyPlayers[lobbyId];
    if (v12305) {
      if (game.isComp) {
        if (v12305[key] == null) {
          return defaultVal;
        } else {
          return v12305[key] || 0;
        }
      } else {
        return defaultVal;
      }
    } else {
      return defaultVal;
    }
  };
  this.canSpawn = function (playerId) {
    if (game.isComp) {
      var v12306 = game.lobbyPlayers[playerId];
      if (!v12306) {
        return "Missing Sync Data";
      }
      if (!v12306.t) {
        return "Please join a Team to Spawn";
      }
      if (v12306.c == null) {
        return "Please select a Class to Spawn";
      }
    }
    return null;
  };
  this.playAnim = function (obj, clipName, force, raw) {
    if (obj.hasAnim && clipName) {
      if (serverIO) {
        var v12307 = config.clipNames.indexOf(clipName);
        if (raw || v12307 >= 0) {
          for (var vLN02079 = 0; vLN02079 < game.players.list.length; ++vLN02079) {
            v12286 = game.players.list[vLN02079];
            if (v12286.active || v12286.spectating) {
              v12286.send("ana", obj.uid, raw ? clipName : v12307, raw ? 1 : 0, true);
            }
          }
        }
      } else if (obj.meshRef && obj.meshRef.playClip) {
        obj.meshRef.playClip(clipName, force);
      }
    }
  };
  this.servAnim = function (uid, clipIndex, custom) {
    v12286 = game.map.manager.findByUid(uid);
    if (v12286) {
      game.playAnim(v12286, custom ? clipIndex : config.clipNames[clipIndex], 1);
    }
  };
  this.uniquePlay = function (player) {
    if (player && !player.countedPlay) {
      if (this.uniquePlays.indexOf(player.id) < 0) {
        this.uniquePlays.push(player.id);
        this.playCount++;
        player.countedPlay = true;
      } else {
        player.countedPlay = true;
      }
    }
  };
  this.getInfo = function () {
    return this.map.maps[this.mapIndex].name;
  };
  this.applyNetworking = function (networkData) {
    networkData = networkData || {};
    this.sendFrequency = networkData.snf || config.serverSendFrequency;
    this.tickFrequency = networkData.tf || config.serverTickFrequency;
    this.tickRate = 1000 / this.tickFrequency;
    this.syncFrequency = networkData.sf || config.serverSyncFrequency;
    this.syncRate = 1000 / this.syncFrequency;
    this.aiSyncT = networkData.aist || config.aiSyncT;
    this.leaderOSync = networkData.los || config.leaderOSync;
    this.airDSyncT = networkData.adst || config.airDSyncT;
    this.networkData = networkData;
  };
  this.applyNetworking();
  this.resetClasses = function () {
    this.config.classes = [];
    for (var vLN02080 = 0; vLN02080 < this.classConfig.length; vLN02080++) {
      if (!this.classConfig[vLN02080].hide || (this.isSandbox || this.isCustom) && (!this.isOfficial || !this.isOfficial.rotationMaps)) {
        this.config.classes.push(vLN02080);
      }
    }
  };
  this.applyConfig = function (cfg, hostType, hostIndex) {
    cfg = cfg || {};
    var v12308 = config.hostTypes[hostIndex || 0] || {};
    this.config = {
      cost: 0
    };
    this.isComp = !!cfg.isComp;
    this.weaponConfig = UTILS.superClone(this.weapons);
    if (cfg.weps) {
      if (!this.customData) {
        this.customData = {};
      }
      this.customData.weps = cfg.weps;
      var v12330;
      for (var vLN02094 = 0; vLN02094 < config.weaponConfig.length; ++vLN02094) {
        v12330 = config.weaponConfig[vLN02094];
        for (var vLN02088 = 0; vLN02088 < this.weaponConfig.length; vLN02088++) {
          if (cfg.weps[vLN02088] && this.weapons[vLN02088][v12330.varN] != null && cfg.weps[vLN02088][v12330.varN] != null) {
            if (v12330.bool) {
              this.weaponConfig[vLN02088][v12330.varN] = !!cfg.weps[vLN02088][v12330.varN];
            } else if (v12330.input) {
              var v12328 = cfg.weps[vLN02088][v12330.varN];
              if (!UTILS.isString(v12328)) {
                v12328 = this.weapons[vLN02088][v12330.varN] + "";
              }
              if (/[^\w \-\|]+/gmi.test(v12328)) {
                v12328 = this.weapons[vLN02088][v12330.varN] + "";
              }
              if (v12328.length > (v12330.len || 16)) {
                v12328 = this.weapons[vLN02088][v12330.varN] + "";
              }
              this.weaponConfig[vLN02088][v12330.varN] = v12328;
            } else if (v12330.select) {
              var v12328 = cfg.weps[vLN02088][v12330.varN];
              this.weaponConfig[vLN02088][v12330.varN] = v12330.options[v12328] == null ? v12330.def : parseInt(v12328);
            } else {
              var v12328 = cfg.weps[vLN02088][v12330.varN];
              if (!UTILS.isNumber(v12328)) {
                continue;
              }
              if (v12328 != this.weaponConfig[vLN02088][v12330.varN]) {
                this.weaponConfig[vLN02088][v12330.varN] = UTILS.limitMM(v12328, v12330.min, v12330.max);
              }
            }
          }
        }
      }
    }
    for (var vLN02094 = 0; vLN02094 < this.upgradeWeapons.length; vLN02094++) {
      if (this.upgradeWeapons[vLN02094].projectile != null) {
        for (var v12315 in this.upgradeWeapons[vLN02094]) {
          if (v12315.startsWith("pj_")) {
            this.upgradeWeapons[vLN02094].projectile[v12315.replace("pj_", "")] = this.upgradeWeapons[vLN02094][v12315];
          }
        }
        var v12316 = this.upgradeWeapons[vLN02094].projectile.asset ? (this.upgradeWeapons[vLN02094].projectile.asset || "").replace(/[^\d]/g, "") : null;
        if (v12316) {
          this.upgradeWeapons[vLN02094].customProj = {
            s: v12316 + "/model",
            pjA: this.upgradeWeapons[vLN02094].projectile.asset || null,
            pjSp: this.upgradeWeapons[vLN02094].projectile.spd,
            pjG: this.upgradeWeapons[vLN02094].projectile.grav,
            pjSC: this.upgradeWeapons[vLN02094].projectile.scale
          };
        }
      }
    }
    for (var vLN02094 = 0; vLN02094 < this.weaponConfig.length; vLN02094++) {
      if (this.weaponConfig[vLN02094].projectile != null) {
        for (var v12315 in this.weaponConfig[vLN02094]) {
          if (v12315.startsWith("pj_")) {
            this.weaponConfig[vLN02094].projectile[v12315.replace("pj_", "")] = this.weaponConfig[vLN02094][v12315];
          }
        }
        var v12316 = this.weaponConfig[vLN02094].projectile.asset ? (this.weaponConfig[vLN02094].projectile.asset || "").replace(/[^\d]/g, "") : null;
        if (v12316) {
          this.weaponConfig[vLN02094].customProj = {
            s: v12316 + "/model",
            pjA: this.weaponConfig[vLN02094].projectile.asset || null,
            pjSp: this.weaponConfig[vLN02094].projectile.spd,
            pjG: this.weaponConfig[vLN02094].projectile.grav,
            pjSC: this.weaponConfig[vLN02094].projectile.scale
          };
        }
      }
    }
    if (cfg.cls) {
      this.classConfig = UTILS.superClone(this.classes);
      if (!this.customData) {
        this.customData = {};
      }
      this.customData.cls = cfg.cls;
      var v12330;
      for (var vLN02094 = 0; vLN02094 < config.classConfig.length; ++vLN02094) {
        v12330 = config.classConfig[vLN02094];
        for (var vLN02088 = 0; vLN02088 < this.classConfig.length; vLN02088++) {
          if (cfg.cls[vLN02088] && this.classes[vLN02088][v12330.varN] != null && cfg.cls[vLN02088][v12330.varN] != null) {
            if (v12330.bool) {
              this.classConfig[vLN02088][v12330.varN] = !!cfg.cls[vLN02088][v12330.varN];
            } else if (v12330.input) {
              var v12328 = cfg.cls[vLN02088][v12330.varN];
              if (!UTILS.isString(v12328)) {
                v12328 = this.classes[vLN02088][v12330.varN] + "";
              }
              if (/[^\w \-\|]+/gmi.test(v12328)) {
                v12328 = this.classes[vLN02088][v12330.varN] + "";
              }
              if (v12328.length > (v12330.len || 16)) {
                v12328 = this.classes[vLN02088][v12330.varN] + "";
              }
              this.classConfig[vLN02088][v12330.varN] = v12328;
            } else if (v12330.select) {
              var v12328 = cfg.cls[vLN02088][v12330.varN];
              this.classConfig[vLN02088][v12330.varN] = v12330.options[v12328] == null ? v12330.def : parseInt(v12328);
            } else {
              var v12328 = cfg.cls[vLN02088][v12330.varN];
              if (!UTILS.isNumber(v12328)) {
                continue;
              }
              if (v12328 != this.classConfig[vLN02088][v12330.varN]) {
                this.classConfig[vLN02088][v12330.varN] = UTILS.limitMM(v12328, v12330.min, v12330.max);
              }
            }
          }
        }
      }
    } else {
      this.classConfig = this.classes;
    }
    if (cfg.prks) {
      this.effectConfig = UTILS.superClone(this.effects);
      if (!this.customData) {
        this.customData = {};
      }
      this.customData.prks = cfg.prks;
      var v12330;
      for (var vLN02094 = 0; vLN02094 < config.effectConfig.length; ++vLN02094) {
        v12330 = config.effectConfig[vLN02094];
        for (var vLN02088 = 0; vLN02088 < this.effectConfig.length; vLN02088++) {
          if (cfg.prks[vLN02088] && this.effects[vLN02088][v12330.varN] != null && cfg.prks[vLN02088][v12330.varN] != null) {
            if (v12330.bool) {
              this.effectConfig[vLN02088][v12330.varN] = !!cfg.prks[vLN02088][v12330.varN];
            } else if (v12330.input) {
              var v12328 = cfg.prks[vLN02088][v12330.varN];
              if (!UTILS.isString(v12328)) {
                v12328 = this.effects[vLN02088][v12330.varN] + "";
              }
              if (/[^\w \-\|]+/gmi.test(v12328)) {
                v12328 = this.effects[vLN02088][v12330.varN] + "";
              }
              if (v12328.length > (v12330.len || 16)) {
                v12328 = this.effects[vLN02088][v12330.varN] + "";
              }
              this.effectConfig[vLN02088][v12330.varN] = v12328;
            } else if (v12330.select) {
              var v12328 = cfg.prks[vLN02088][v12330.varN];
              this.effectConfig[vLN02088][v12330.varN] = v12330.options[v12328] == null ? v12330.def : parseInt(v12328);
            } else {
              var v12328 = cfg.prks[vLN02088][v12330.varN];
              if (!UTILS.isNumber(v12328)) {
                continue;
              }
              if (v12328 != this.effectConfig[vLN02088][v12330.varN]) {
                this.effectConfig[vLN02088][v12330.varN] = UTILS.limitMM(v12328, v12330.min, v12330.max);
              }
            }
          }
        }
      }
    } else {
      this.effectConfig = this.effects;
    }
    var v12330;
    for (var vLN02094 = 0; vLN02094 < config.serverConfig.length; ++vLN02094) {
      v12330 = config.serverConfig[vLN02094];
      if (v12330.bool) {
        this.config[v12330.varN] = cfg[v12330.varN] == null ? v12308.comp && v12330.defC != null ? v12330.defC : v12330.def : !!cfg[v12330.varN];
      } else if (v12330.input) {
        var v12328 = cfg[v12330.varN];
        if (!UTILS.isString(v12328)) {
          v12328 = v12308.comp && v12330.defC != null ? v12330.defC : v12330.def;
        }
        this.config[v12330.varN] = UTILS.sanitizeStr(v12328);
        if (/[^\w \-\|]+/gmi.test(v12328)) {
          v12328 = v12308.comp && v12330.defC != null ? v12330.defC : v12330.def;
        }
        if (v12328.length > 16) {
          v12328 = v12328.substring(0, 16);
        }
      } else if (v12330.select) {
        var v12328 = cfg[v12330.varN];
        this.config[v12330.varN] = v12330.options[v12328] == null ? v12308.comp && v12330.defC != null ? v12330.defC : v12330.def : parseInt(v12328);
      } else {
        var v12328 = cfg[v12330.varN];
        if (!UTILS.isNumber(v12328)) {
          v12328 = v12308.comp && v12330.defC != null ? v12330.defC : v12330.def;
        }
        var v12329 = v12330.max;
        if (hostType == -2) {
          v12329 = v12330.maxD || v12329;
        } else if (hostType == 3) {
          v12329 = v12330.maxF || v12329;
        } else if (hostType == 2) {
          v12329 = v12330.maxP || v12329;
        } else if (hostType == 0) {
          v12329 = v12330.maxG || v12329;
        }
        this.config[v12330.varN] = UTILS.limitMM(v12328, v12330.min, v12329);
      }
    }
    var v12330;
    for (var vLN02094 = 0; vLN02094 < config.serverUpg.length; ++vLN02094) {
      v12330 = config.serverUpg[vLN02094];
      this.config[v12330.varN] = cfg[v12330.varN] != null && !!cfg[v12330.varN];
      if (v12330.cost && this.config[v12330.varN]) {
        this.config.cost += v12330.cost;
      }
    }
    this.config.maps = cfg.maps;
    if (!UTILS.isArray(this.config.maps) || !this.config.maps.length || this.config.maps.length > this.map.maps.length) {
      this.config.maps = [];
      for (var vLN02094 = 0; vLN02094 < this.map.maps.length; vLN02094++) {
        this.config.maps.push(vLN02094);
      }
    } else {
      for (var vLN02094 = 0; vLN02094 < this.config.maps.length; vLN02094++) {
        if (!this.map.maps[this.config.maps[vLN02094]]) {
          this.config.maps = [0];
          break;
        }
      }
    }
    this.config.modes = cfg.modes;
    if (!UTILS.isArray(this.config.modes) || !this.config.modes.length || this.config.modes.length > this.map.modes.length) {
      this.config.modes = null;
    } else {
      for (var vLN02094 = 0; vLN02094 < this.config.modes.length; vLN02094++) {
        if (!this.map.modes[this.config.modes[vLN02094]]) {
          this.config.modes = null;
          break;
        }
      }
    }
    var v12331 = false;
    this.config.classes = cfg.classes;
    if (!UTILS.isArray(this.config.classes) || !this.config.classes.length || this.config.classes.length > this.classConfig.length) {
      v12331 = true;
    } else {
      for (var vLN02094 = 0; vLN02094 < this.config.classes.length; vLN02094++) {
        if (!this.classConfig[this.config.classes[vLN02094]]) {
          v12331 = true;
          break;
        }
      }
    }
    if (v12331) {
      this.resetClasses();
    }
  };
  this.applyConfig();
  this.prepareGame = function (mapData, mapId, creator, info, accType, skipVal, mapIndex, scriptDecoder, parsedData, encrypted) {
    if (mapData) {
      try {
        mapData = mapData.replace(/\(/gm, "（").replace(/\)/gm, "）");
        if (mapData.indexOf("(") != -1) {
          return "Invalid Map Format.";
        }
        var v12332 = parsedData || JSON.parse(mapData);
        this.mainScript = null;
        if (config.scriptingEnabled && v12332.scripts) {
          if (scriptDecoder || encrypted) {
            for (const v12333 in v12332.scripts) {
              v12332.scripts[v12333] = UTILS.b64d(v12332.scripts[v12333]);
            }
            if (scriptDecoder) {
              v12332.scripts = scriptDecoder(v12332.scripts);
            }
          }
          this.addScripts(v12332.scripts, serverIO ? "server" : "client");
          if (scriptDecoder && v12332.scripts) {
            delete v12332.scripts.server;
            mapData = JSON.stringify(v12332);
          }
        }
        var vO391 = {};
        if (info) {
          try {
            vO391 = JSON.parse(info);
          } catch (e162) {}
        }
        this.customMapData = {
          data: mapData,
          n: v12332.name || "",
          id: mapId,
          accType: accType,
          creator: creator,
          info: info,
          thumb: !!vO391.t,
          hasLM: !!vO391.l
        };
        if (!skipVal) {
          var vI23 = validateMap(v12332, !!creator || !!(accType > 1));
          if (vI23) {
            return vI23;
          }
        }
        for (var vLN02095 = 0; vLN02095 < v12332.objects.length; ++vLN02095) {
          if (!prefabs.prefabs[v12332.objects[vLN02095].i || v12332.objects[vLN02095].id || 0]) {
            return "Object ID error.";
          }
          if (!prefabs.textures[v12332.objects[vLN02095].t || 0]) {
            return "Object Texture error.";
          }
        }
        v12332.creator = creator;
        v12332.hasLM = !!vO391.l;
        v12332.official = this.isOfficial;
        v12332.id = mapId;
        if (this.isOfficial) {
          var vA669 = [];
          vA669[mapIndex] = v12332;
          this.map.setMaps(vA669);
          this.config.maps = [mapIndex];
        } else {
          this.map.setMaps([v12332]);
          this.config.maps = [0];
        }
      } catch (e163) {
        console.log(e163);
        return "Map error occured.";
      }
    }
  };
  this.playerSound = function (sound, sid, x, y, z, vol, rate, maxDist, rolloff, refDist, player, custom) {
    var v12334 = false;
    sound = UTILS.isNumber(sound) && !custom ? config.networkSounds[sound] : sound;
    var v12335 = !!player || this.players.findBySid(sid);
    if (!v12335 || !v12335.isPlayer || !!v12335.isYou || !game.hidePlayers || !!v12335.isBot) {
      var v12336 = Howler.pos();
      if (v12335 && (!maxDist || !(maxDist < (v12335.latestData ? UTILS.getD3D(v12335.x, v12335.y, v12335.z, v12336[0], v12336[1], v12336[2]) : UTILS.getD3D(x, y, z, v12336[0], v12336[1], v12336[2]))))) {
        if (v12335.latestData) {
          SOUND.play3D(sound, v12335.x, v12335.y, v12335.z, vol || 1, rate, rolloff, refDist, custom, v12334);
        } else {
          SOUND.play3D(sound, x, y, z, vol || 1, rate, rolloff, refDist, custom, v12334);
        }
      }
    }
  };
  this.triggerImgSound = function (sound, img, player) {
    if (serverIO) {
      serverIO.send(player.id, "is", sound, img);
    } else {
      if (sound) {
        SOUND.play(sound, 1);
      }
      if (img && imgFlash) {
        imgFlash.style.display = "block";
        imgFlash.style.opacity = 1;
        imgFlash.style.backgroundImage = "url('" + UTILS.assetsUrl("/" + img + ".png") + "')";
      }
    }
  };
  this.playSound = function (sound, vol, sid, x, y, z, forceAll, rate, extra1, extra2, extra3, extra4, custom) {
    if (vol) {
      if (SOUND) {
        SOUND.play(UTILS.isNumber(sound) && !custom ? config.networkSounds[sound] : sound, vol, extra1, rate, undefined, false);
      } else {
        for (var vLN02096 = 0; vLN02096 < this.players.list.length; ++vLN02096) {
          v12286 = this.players.list[vLN02096];
          if ((v12286.active || v12286.spectating) && (sid != v12286.sid || forceAll)) {
            v12286.send("s", sound, sid, Math.round(x), Math.round(y), Math.round(z), vol, rate, extra2, extra3, extra4, custom);
          }
        }
      }
    }
  };
  this.getSoundIndex = function (sound) {
    if (UTILS.isNumber(sound)) {
      return id;
    } else {
      return config.networkSounds.indexOf(sound);
    }
  };
  this.destroyObj = function (uid) {
    for (var vLN02097 = 0; vLN02097 < game.map.manager.objects.length; ++vLN02097) {
      v12286 = game.map.manager.objects[vLN02097];
      if (v12286.uid == uid) {
        v12286.active = false;
        v12286.destroyed = true;
        if (SOUND && v12286.breakSnd) {
          SOUND.play3D(v12286.breakSnd, v12286.x, v12286.y, v12286.z, 1, UTILS.randFloat(0.9, 1));
        }
        if (RENDER) {
          if (v12286.dynamic) {
            RENDER.ShaderMesh.removeBuild(v12286.uid, game.BUILD_OBJS[v12286.buildInd]);
          } else if (v12286.meshRef != null) {
            v12286.meshRef.visible = false;
          }
          RENDER.updateShadowMap();
        }
        break;
      }
    }
  };
  this.buildObj = function (buildInd, x, y, z, w, h, l, dir, uido, grounded, player) {
    var v12337 = game.BUILD_OBJS[buildInd];
    if (v12337) {
      game.buildCount++;
      if (player && game.buildCount >= config.buildMax) {
        player.send("ch", -1, null, "Build limit reached", 2);
        return false;
      }
      if (grounded) {
        y -= (h || v12337.h) / 2;
      }
      var v12338;
      v12338 = v12337.custMod ? v12337.custMod(game.map.manager, x, y, z, w || v12337.w, l || v12337.l, h || v12337.h, dir, serverIO ? undefined : uido) : game.map.manager.addBlock(x, y, z, w || v12337.w, l || v12337.l, h || v12337.h, null, {
        src: v12337.src || "grain_0",
        uido: serverIO ? undefined : uido,
        shaderBased: true,
        colr: v12337.color,
        buildInd: buildInd,
        breakSnd: v12337.breakSnd,
        model: v12337.model,
        health: v12337.health,
        dynamic: true
      });
      v12338.typeInd = buildInd;
      game.map.manager.applyToQuad(v12338);
      if (serverIO) {
        game.broadcast("bo", buildInd, x, y, z, w, h, l, dir, v12338.uid);
      } else if (SOUND && RENDER) {
        RENDER.updateShadowMap();
        if (!grounded) {
          SOUND.play3D("build_0", x, y, z, 1);
        }
      }
      return true;
    }
    return false;
  };
  this.removeBuilds = function () {
    if (RENDER) {
      if (RENDER.ShaderMesh.BUILDS) {
        RENDER.ShaderMesh.BUILDS.clear();
      }
      if (RENDER.ShaderMesh.MODELS) {
        for (var v12339 in RENDER.ShaderMesh.MODELS) {
          if (RENDER.ShaderMesh.MODELS[v12339].mesh) {
            RENDER.ShaderMesh.MODELS[v12339].mesh.clear();
          }
        }
      }
      RENDER.updateShadowMap();
    }
    game.buildCount = 0;
    game.map.manager.removeFromQuad("dynamic", true);
    for (var v12340 = game.map.manager.objects.length - 1; v12340 >= 0; --v12340) {
      if (game.map.manager.objects[v12340].dynamic) {
        game.map.manager.objects.splice(v12340, 1);
      }
    }
  };
  this.moveObj = function (obj, x, y, z, hOffset) {
    hOffset = hOffset || 0;
    obj.x = x;
    obj.y = y;
    obj.z = z;
    if (obj.meshRef && obj.meshRef.position) {
      obj.meshRef.position.set(x, y - hOffset, z);
    }
  };
  this.teleportToNode = function (objIndex, nodeIndex) {
    var v12341 = game.map.manager.pathNodes[nodeIndex];
    if (v12341) {
      var v12342 = game.map.manager.objects[objIndex];
      if (v12342) {
        game.map.manager.removeFromQuad("uid", v12342.uid);
        game.moveObj(v12342, v12341.x, v12341.y + v12342.height, v12341.z, v12342.height);
        if (RENDER) {
          RENDER.updateShadowMap();
        }
        game.map.manager.applyToQuad(v12342);
        var v12343 = game.map.manager.movedObjs.indexOf(v12342.uid);
        if (v12343 > -1) {
          game.map.manager.movedObjs[v12343 + 1] = nodeIndex;
        } else {
          game.map.manager.movedObjs.push(v12342.uid, nodeIndex);
        }
        if (serverIO) {
          game.broadcast("mo", objIndex, nodeIndex);
        }
      }
    }
  };
  this.teleportFromNode = function (objIndex) {
    var v12344 = game.map.manager.objects[objIndex];
    if (v12344) {
      var v12345 = game.map.manager.movedObjs.indexOf(v12344.uid);
      if (v12345 != -1) {
        game.map.manager.removeFromQuad("uid", v12344.uid);
        game.moveObj(v12344, v12344.orgX, v12344.orgY, v12344.orgZ, v12344.height);
        if (RENDER) {
          RENDER.updateShadowMap();
        }
        game.map.manager.applyToQuad(v12344);
        game.map.manager.movedObjs.splice(v12345, 2);
        if (serverIO) {
          game.broadcast("mf", objIndex);
        }
      }
    }
  };
  this.rumble = function (x, y, z, intensity, maxDist) {
    maxDist = maxDist || 1;
    for (var vLN02098 = 0; vLN02098 < this.players.list.length; ++vLN02098) {
      v12286 = this.players.list[vLN02098];
      if (v12286.active || v12286.spectating) {
        var v12346 = UTILS.getD3D(x, y, z, v12286.x, v12286.y, v12286.z);
        if (v12346 > maxDist) {
          continue;
        }
        var vP15234 = intensity;
        if (v12286.active) {
          vP15234 *= 1 - v12346 / maxDist;
        }
        v12286.send("shk", vP15234);
      }
    }
  };
  this.explosion = function (x, y, z, range, dmg, source, data) {
    if (this.mode && this.mode.explSMlt) {
      range *= this.mode.explSMlt;
    }
    for (var vLN02100 = 0; vLN02100 < this.players.list.length; ++vLN02100) {
      v12286 = this.players.list[vLN02100];
      if ((v12286.active || v12286.spectating) && (v12286.send("ex", Math.round(x), Math.round(y), Math.round(z), Math.round(range), data.smCnt, data.lgCnt), !data.aiOnly && v12286.active && !v12286.noPVP && (!source || !source.noPVP) && (v12286.forcePVP && !!source && source.forcePVP || !v12286.forcePVP && (!source || !source.forcePVP)))) {
        if (data.stk != null && source == v12286) {
          continue;
        }
        var v12350 = UTILS.getD3D(x, y, z, v12286.x, v12286.y, v12286.z);
        var v12351 = 1 - v12350 / range;
        if (v12351 > 0) {
          var v12352 = dmg * v12351 * (v12286 == source ? 0.2 : 1);
          if (source && source.smite) {
            v12352 = 10000;
          }
          if (source && source.attributes && source.attributes.dmg) {
            v12352 *= source.attributes.dmg;
          }
          if (this.mode && this.mode.explMlt && v12286 != source) {
            v12352 *= this.mode.explMlt;
          }
          if (this.players.changeHealth(v12286, source, v12352, source == v12286, undefined, {
            wep: data.wId
          })) {
            this.players.kill(v12286, source, {
              dst: v12350,
              wId: data.wId,
              stk: data.stk,
              pkg: data.pkg
            }, false, data.stk != null);
            if (data.stk != null && this.streaks[data.stk] && this.streaks[data.stk].onKill) {
              this.streaks[data.stk].onKill(this, source, serverIO);
            }
          } else if (data.stk != null && this.streaks[data.stk] && this.streaks[data.stk].onCollision) {
            this.streaks[data.stk].onCollision(this, v12286, serverIO);
          }
        }
      }
    }
    for (var vLN02100 = 0; vLN02100 < this.AI.ais.length; ++vLN02100) {
      v12286 = this.AI.ais[vLN02100];
      if (v12286.active && (!v12286.team || !source || v12286.team != source.team)) {
        var v12350 = UTILS.getD3D(x, y, z, v12286.x, v12286.y, v12286.z);
        var v12351 = 1 - v12350 / range;
        if (v12351 > 0 && source) {
          var v12352 = dmg * v12351;
          if (source.smite) {
            v12352 = 10000;
          }
          if (source.attributes && source.attributes.dmg) {
            v12352 *= source.attributes.dmg;
          }
          v12286.changeHealth(-v12352, source);
          if (source && source.isPlayer) {
            if (v12286.killScore && this.mode && this.mode.pointsPerHit) {
              this.players.score(source, Math.ceil(v12352 * this.mode.pointsPerHit), 1);
            }
            if (!v12286.active && v12286.killScore) {
              this.players.score(source, v12286.killScore, 1);
            }
            this.showHit(source, v12286, Math.round(dmg * v12351), false, true, data.noHit);
          }
        }
      }
    }
  };
  this.showHit = function (source, target, dmg, kill, headshot, noHit) {
    for (var vLN02101 = 0; vLN02101 < game.players.list.length; ++vLN02101) {
      if (source && source == game.players.list[vLN02101] || source && game.players.list[vLN02101].specStream == source.sid) {
        game.players.list[vLN02101].send("4", target.sid, Math.round(dmg), kill || false, !target.active, headshot || false, noHit);
      }
    }
  };
  var vA670 = [];
  this.getSpawnPoint = function (team, player, useFirst, compMode) {
    var v12353 = !!this.waitTimers && !!this.waitTimers[0] && !!this.waitTimers[0].comp;
    var vP15249 = team;
    if (team && this.flippedSpawns) {
      if (team == 1) {
        vP15249 = 2;
      } else if (team == 2) {
        vP15249 = 1;
      }
    }
    if (useFirst) {
      return this.map.spawns[0];
    }
    vA670.length = 0;
    var vLN10011 = 100;
    var vLN02102 = 0;
    for (var vLN02105 = 0; vLN02105 < this.map.spawns.length; ++vLN02105) {
      this.map.spawns[vLN02105].dst = 0;
      for (var vLN02106 = 0; vLN02106 < this.players.list.length; ++vLN02106) {
        v12286 = this.players.list[vLN02106];
        if (v12286 && v12286.active && v12286 != player && (!team || v12286.team != team) && !this.canSee(v12286, this.map.spawns[vLN02105].x, this.map.spawns[vLN02105].y + config.playerHeight, this.map.spawns[vLN02105].z)) {
          this.map.spawns[vLN02105].dst++;
          vLN02102++;
        }
      }
    }
    this.map.spawns.sort(UTILS.orderByDst);
    vLN10011 = this.map.spawns[0].dst;
    var v12354 = this.mode && this.mode.teams;
    for (var vLN02105 = 0; vLN02105 < this.map.spawns.length; ++vLN02105) {
      if ((!this.map.spawns[vLN02105].comp || v12353 || compMode) && (!this.map.spawns[vLN02105].teamOnly || this.map.spawns[vLN02105].team == vP15249)) {
        if (v12353 || compMode) {
          if (this.map.spawns[vLN02105].comp && (!v12354 || v12354 && this.map.spawns[vLN02105].team == vP15249)) {
            vA670.push(this.map.spawns[vLN02105]);
            break;
          }
        } else if (this.map.spawns[vLN02105].dst == vLN10011) {
          this.map.spawns[vLN02105].dst = 0;
          for (var vLN02106 = 0; vLN02106 < this.players.list.length; ++vLN02106) {
            v12286 = this.players.list[vLN02106];
            if (v12286.active && v12286 != player && (!team || v12286.team != team)) {
              this.map.spawns[vLN02105].dst += UTILS.getD3D(this.map.spawns[vLN02105].x, this.map.spawns[vLN02105].y, this.map.spawns[vLN02105].z, v12286.x, v12286.y, v12286.z);
            }
          }
          if (this.mode && (this.mode.flags || this.mode.oneflag)) {
            for (var vLN02108 = 0; vLN02108 < this.map.manager.flags.length; ++vLN02108) {
              v12286 = this.map.manager.flags[vLN02108];
              if (!v12286.neutral) {
                if (v12286.team != team) {
                  this.map.spawns[vLN02105].dst += UTILS.getD3D(this.map.spawns[vLN02105].x, this.map.spawns[vLN02105].y, this.map.spawns[vLN02105].z, v12286.x, v12286.y, v12286.z);
                }
              }
            }
          }
          if (this.mode && this.mode.dom) {
            for (var vLN02108 = 0; vLN02108 < this.map.manager.domzones.length; ++vLN02108) {
              v12286 = this.map.manager.domzones[vLN02108];
              if (v12286.capturedBy && v12286.capturedBy != team) {
                this.map.spawns[vLN02105].dst += UTILS.getD3D(this.map.spawns[vLN02105].x, this.map.spawns[vLN02105].y, this.map.spawns[vLN02105].z, v12286.x, v12286.y, v12286.z);
              }
            }
          }
          if (vP15249 && this.map.spawns[vLN02105].team == vP15249 || !this.map.spawns[vLN02105].team) {
            vA670.push(this.map.spawns[vLN02105]);
          }
        }
      }
    }
    vA670.sort(UTILS.orderByDst);
    vA670.reverse();
    var v12355 = vA670[0] || this.map.spawns[0];
    if (v12353) {
      return this.getPointSpread(v12355.x, v12355.z, v12355.y, 40, v12355.dir);
    } else if (v12355.spread) {
      return this.getPointSpread(v12355.x, v12355.z, v12355.y, v12355.spread + 7, v12355.dir);
    } else {
      return v12355;
    }
  };
  this.getPointSpread = function (x, z, y, spread, dir) {
    var v12356 = UTILS.randFloat(-Math.PI, Math.PI);
    var v12357 = 1 / (spread * Math.sin(v12356 + Math.PI));
    var v12358 = 1 / (spread * Math.cos(v12356 + Math.PI));
    var vLN1159 = 1;
    for (var vLN02109 = 0; vLN02109 < this.map.manager.objects.length; ++vLN02109) {
      v12287 = this.map.manager.objects[vLN02109];
      if (v12287.active) {
        var v12359 = UTILS.lineInRect(x, z, y + 1, v12357, v12358, 1, v12287.x - v12287.width, v12287.z - v12287.length, v12287.y - v12287.height, v12287.x + v12287.width, v12287.z + v12287.length, v12287.y + v12287.height);
        if (v12359 && v12359 <= vLN1159) {
          vLN1159 = v12359;
        }
      }
    }
    spread -= 10;
    return {
      dir: dir,
      x: Math.round(x + spread * vLN1159 * Math.sin(v12356 + Math.PI)),
      z: Math.round(z + spread * vLN1159 * Math.cos(v12356 + Math.PI)),
      y: y
    };
  };
  this.updateAccounts = function () {
    var vA671 = [];
    for (var vLN02110 = 0; vLN02110 < this.players.list.length; ++vLN02110) {
      v12286 = this.players.list[vLN02110];
      if (v12286.account && !v12286.account.hack && !v12286.kpdData && this.endIndex != 3) {
        if (!v12286.playTimeUpdated) {
          v12286.account.timePlayed += v12286.playTime || 0;
          v12286.account.lastPlayTime = v12286.playTime || 0;
          v12286.playTimeUpdated = true;
        }
        this.players.saveClassScores(v12286);
        this.players.saveWeaponStats(v12286);
        this.checkBadges(v12286);
        this.transferStats(v12286);
        if (this.isPubType() && (!this.mode || !this.mode.noReward)) {
          var v12360 = v12286.score;
          if (v12286.account.BP && v12286.tmpBPData && v12286.tmpBPData.gn) {
            battlePass.progress(v12286, v12286.tmpBPData.gn);
          }
          v12286.account.games++;
          v12286.account.kills += v12286.kills;
          v12286.account.deaths += v12286.deaths;
          if (v12286.didWin) {
            v12286.account.wins++;
          }
          v12286.account.score += v12360;
          vA671.push(v12286);
        }
        v12286.send("ua", v12286.account.getData());
      }
    }
    if (vA671.length) {
      this.saveRewards(vA671);
    }
  };
  this.saveRewards = function (players) {
    var vLS111 = "";
    var vLS112 = "";
    for (var vLN02111 = 0; vLN02111 < players.length; ++vLN02111) {
      if (players[vLN02111] && players[vLN02111].account && players[vLN02111].reward && players[vLN02111].ipAddress) {
        vLS111 += (vLS111.length ? "," : "") + players[vLN02111].account.id + "," + players[vLN02111].reward;
        vLS112 += (vLS112.length ? "," : "") + players[vLN02111].ipAddress;
      }
    }
    if (vLS111.length) {
      dbClient.call(20, [vLS111], function (err, result) {
        if (result && result[0] && result[0][0] && (result = result[0][0].result, result)) {
          try {
            result = result.split(",");
            var v12361;
            for (var vLN02112 = 0; vLN02112 < result.length; ++vLN02112) {
              v12361 = parseInt(result[vLN02112]);
              if (v12361 && players[vLN02112]) {
                players[vLN02112].account.funds = v12361;
                players[vLN02112].send("uf", v12361);
              }
            }
          } catch (e164) {}
        }
      });
    }
  };
  this.incStat = function (stat, player) {
    if (!game || !game.mode || !game.mode.skipStats || !(game.mode.skipStats.indexOf(stat) >= 0)) {
      if (player && player.account && this.isPubType()) {
        if (!player.tmpStats[stat]) {
          player.tmpStats[stat] = 0;
        }
        player.tmpStats[stat]++;
      }
    }
  };
  this.incMedal = function (medal, player) {
    if (player && (game.isSandbox || player.account) && game.isPubType()) {
      if (!player.medals[medal]) {
        player.medals[medal] = 0;
      }
      player.medals[medal]++;
    }
  };
  this.transferStats = function (player) {
    if (player) {
      if (player.account && this.isPubType()) {
        for (var v12362 in player.tmpStats) {
          if (!player.account.stats[v12362]) {
            player.account.stats[v12362] = 0;
          }
          player.account.stats[v12362] += player.tmpStats[v12362];
        }
      }
      player.tmpStats = {};
    }
  };
  this.checkLeave = function (player, didLeave) {
    if (player) {
      if (!didLeave) {
        this.removePlayerSound(player.sid, null, true);
      }
      if (player.account && !this.endTimer && this.isPubType() && !this.isOfficial && player.affectStats) {
        player.account.games = (player.account.games || 0) + 1;
        if (didLeave) {
          player.account.deaths = (player.account.deaths || 0) + 1;
        }
      }
      if (!didLeave && player.account && !player.playTimeUpdated) {
        player.account.timePlayed += player.playTime || 0;
        player.playTimeUpdated = true;
      }
    }
  };
  this.checkChallenges = function (player, quit) {
    if (dbClient && player && player.account && this.isPubType() && player.account.level >= config.minChalLevel) {
      this.challenges.finalize(player, dbClient, serverIO, quit, battlePass);
    }
  };
  this.storageUpdt = function (name, data, type, scope, cb, raw) {
    if (!dbClient) {
      return cb(null, "Error");
    }
    if (!this.defaultSetts && config.isProd) {
      return cb(null, "Storage only supported on published maps");
    }
    if (!this.customMapData || !this.customMapData.n) {
      return cb(null, "Missing map data");
    }
    scope = scope == "global" ? 1 : 0;
    name += "";
    var vLS113 = "";
    var vLN02113 = 0;
    if (raw) {
      vLS113 = raw;
    } else {
      if (!data || typeof data != "object") {
        return cb(null, "Missing storage data");
      }
      for (var v12363 in data) {
        if (data.hasOwnProperty(v12363)) {
          vLN02113++;
          var v12364 = (v12363 + "").replace(/[,'"]/g, "");
          if (v12364.length > 20) {
            return cb(null, "Key too long");
          }
          var v12365 = (data[v12363] + "").replace(/[,'"]/g, "");
          if (v12365.length > 100) {
            return cb(null, "Value too long");
          }
          if (vLS113 != "") {
            vLS113 += ",";
          }
          vLS113 += v12364 + "," + v12365;
        }
      }
      if (vLN02113 > 30) {
        return cb(null, "Too many keys: max 30");
      }
    }
    type = parseInt(type) || 0;
    if (type < 0 || type > 5) {
      return cb(null, "Invalid storage type");
    }
    var v12366 = this.players.findByName(name);
    if (v12366) {
      dbClient.call(154, [name, this.customMapData.n, type, scope, vLS113], function (err, result) {
        result = result && result[0] ? result[0] : null;
        cb(result, err);
      });
      return;
    } else {
      return cb(null, "Player not connected");
    }
  };
  this.getStoragePlayer = function (name, mapName, cb) {
    if (dbClient) {
      if (!this.defaultSetts && config.isProd) {
        return cb(null, "Storage only supported on published maps");
      } else {
        if (!this.customMapData || !this.customMapData.n || !this.customMapData.creator) {
          cb(null, "Missing map data");
        }
        mapName = mapName || this.customMapData.n;
        dbClient.call(163, [mapName + "", name + "", this.customMapData.creator], function (err, result) {
          result = result && result[0] ? result[0] : null;
          if (err || !result) {
            cb(null, "No data found");
          } else {
            cb(result);
          }
        });
        return;
      }
    } else {
      return undefined;
    }
  };
  this.savePlayerData = function (player, region) {
    if (dbClient && player.account) {
      if (this.isPubType()) {
        var vLN02114 = 0;
        var vLN02115 = 0;
        var vLN02116 = 0;
        for (var v12367 in config.regionIND) {
          if (v12367 == region) {
            vLN02114 = config.regionIND[v12367];
            break;
          }
        }
        if (vLN02114) {
          for (var vLN1160 = 1; vLN1160 < 6; ++vLN1160) {
            if (vLN02114 == vLN1160) {
              if (!player.account.stats["r" + vLN1160]) {
                player.account.stats["r" + vLN1160] = 0;
              }
              player.account.stats["r" + vLN1160]++;
            }
            if (player.account.stats["r" + vLN1160] && player.account.stats["r" + vLN1160] >= vLN02116) {
              vLN02116 = player.account.stats["r" + vLN1160];
              vLN02115 = vLN1160;
            }
          }
        }
        if (vLN02115) {
          player.account.regionInd = vLN02115;
        }
      }
      var v12368 = this.customMapData ? this.customMapData.id : 0;
      var v12369 = player.account;
      if (v12369) {
        dbClient.call(2, [v12369.id, v12369.kills, v12369.wins, v12369.games, v12369.deaths, v12369.score, v12369.clan, v12369.timePlayed, JSON.stringify(v12369.stats), v12369.regionInd, v12368, v12369.clanKills, v12369.clanDeaths, v12369.clanTime]);
        if (v12369 && !v12369.hack && !player.kpdData) {
          this.checkChallenges(player, true);
        }
      }
    }
  };
  this.lockPlayer = function (player, locked) {
    player.locked = locked;
    player.send("lock", locked);
  };
  this.lockMove = function (player, x, y, z, dir) {
    game.moveLock = true;
    if (!serverIO) {
      if (player) {
        player.resetPosition(x, y, z, dir);
      }
      return;
    }
    var v12370;
    for (var vLN02117 = 0; vLN02117 < this.players.list.length; vLN02117++) {
      v12370 = this.players.list[vLN02117];
      if (!v12370.spectating && v12370.active) {
        v12370.send("lm", v12370.x, v12370.y, v12370.z, v12370.xDire);
      }
    }
  };
  this.unlockMove = function () {
    game.moveLock = false;
    if (serverIO) {
      game.broadcast("ulm");
    }
  };
  this.warmupReset = function () {
    var v12371;
    for (var vLN02118 = 0; vLN02118 < this.players.list.length; vLN02118++) {
      v12371 = this.players.list[vLN02118];
      if (!v12371.spectating && v12371.active) {
        var v12372 = this.getSpawnPoint(v12371.team, v12371, false, true);
        v12371.resetPosition(v12372.x, v12372.y, v12372.z, -((v12372.dir || 0) + 1) * Math.PI / 2);
      }
    }
  };
  this.updateTeam = function (player, team) {
    player.team = team;
    for (var vLN02119 = 0; vLN02119 < player.sentTo.length; ++vLN02119) {
      serverIO.send(player.sentTo[vLN02119], "tm", player.sid, team);
    }
    this.players.syncLeaders(true);
  };
  this.plantBomb = function (player) {
    if (this.map.manager.sites.length && this.mode && this.mode.site && game.isServer) {
      this.incMedal("Bomb Planted", player);
      player.send("am", [19, 200, 0, 1]);
      this.players.score(player, 200, 2);
      var v12373 = this.players.dropWeapon(player, false, 17, false) || {};
      this.activeBomb = {
        team: player.team,
        tick: 2000,
        time: 40000,
        x: v12373.x,
        y: v12373.y,
        z: v12373.z
      };
      this.broadcast("gmsg", "BOMB PLANTED");
      this.broadcast("so", "bo_plant", 1, 1);
    }
  };
  this.diffuseBomb = function (player) {
    if (!!this.map.manager.sites.length && !!this.mode && !!this.mode.site) {
      if (serverIO && this.activeBomb && player) {
        this.activeBomb = null;
        player.diffuses++;
        this.broadcast("so", "bo_diff", 1, 1);
      }
    }
  };
  this.claimAirDrop = function (player, airDrop) {
    if (serverIO && airDrop && player) {
      airDrop.claim(player);
    }
  };
  this.resetStreaks = function () {
    for (var vLN02120 = 0; vLN02120 < game.streaks.length; vLN02120++) {
      if (game.streaks[vLN02120].reset) {
        game.streaks[vLN02120].reset(game);
      }
    }
  };
  this.updateStreaks = function (delta) {
    for (var vLN02121 = 0; vLN02121 < game.streaks.length; vLN02121++) {
      if (game.streaks[vLN02121].update) {
        game.streaks[vLN02121].update(game, serverIO, delta);
      }
    }
  };
  this.updateBomb = function (delta) {
    if (this.map.manager.sites.length && this.mode && this.mode.site && this.activeBomb && !this.endTimer) {
      this.activeBomb.tick -= delta;
      this.activeBomb.time -= delta;
      if (this.activeBomb.time <= 0) {
        this.broadcast("n", 1);
        for (var vLN02122 = 0; vLN02122 < this.players.list.length; ++vLN02122) {
          v12286 = this.players.list[vLN02122];
          if (v12286.active && this.activeBomb.team != v12286.team) {
            this.players.kill(v12286, null, null, false, true);
          }
        }
        this.activeBomb = null;
      } else if (this.activeBomb.tick <= 0) {
        var vLN2000 = 2000;
        if (this.activeBomb.time <= 2000) {
          vLN2000 = 150;
        } else if (this.activeBomb.time <= 5000) {
          vLN2000 = 200;
        } else if (this.activeBomb.time <= 10000) {
          vLN2000 = 500;
        } else if (this.activeBomb.time <= 20000) {
          vLN2000 = 1000;
        }
        this.activeBomb.tick = vLN2000;
        this.broadcast("so", "beep_0", 1, 0, this.activeBomb.x || 0, this.activeBomb.y || 0, this.activeBomb.z || 0);
      }
    }
  };
  this.updateEvents = function () {
    this.endTimer;
  };
  this.initEvents = function () {};
  this.updatePowerupTime = function (index, time) {
    powerUpHolder.children[index].children[0].textContent = UTILS.getChargedTime(time);
  };
  this.updatePowerups = function (isServer, delta) {
    if (game.instaKillTimer) {
      game.instaKillTimer -= delta;
      if (!isServer) {
        game.updatePowerupTime(0, game.instaKillTimer);
      }
      if (game.instaKillTimer <= 0) {
        game.instaKillTimer = 0;
        if (isServer) {
          game.broadcast("pwup", 0, game.instaKillTimer);
        }
      }
    }
    if (game.fireSaleTimer) {
      game.fireSaleTimer -= delta;
      if (!isServer) {
        game.updatePowerupTime(1, game.fireSaleTimer);
      }
      if (game.fireSaleTimer <= 0) {
        game.fireSaleTimer = 0;
        if (isServer) {
          game.broadcast("pwup", 1, game.fireSaleTimer);
          game.switchMysteryBox(game.getActiveMysteryBox());
        }
      }
    }
    if (game.doublePointsTimer) {
      game.doublePointsTimer -= delta;
      if (!isServer) {
        game.updatePowerupTime(2, game.doublePointsTimer);
      }
      if (game.doublePointsTimer <= 0) {
        game.doublePointsTimer = 0;
        if (isServer) {
          game.broadcast("pwup", 2, game.doublePointsTimer);
        }
      }
    }
  };
  this.refillPlayer = function (player) {
    if (player) {
      player.refillKnife();
      player.send("rfl");
    }
  };
  this.findTriggers = function (eventName, player) {
    for (var vLN02123 = 0; vLN02123 < this.map.manager.objects.length; ++vLN02123) {
      v12286 = this.map.manager.objects[vLN02123];
      if (v12286 && v12286.active && v12286[eventName]) {
        this.onTrigger(player, v12286);
      }
    }
  };
  var vA672 = [];
  this.infectRandom = function () {
    vA672.length = 0;
    for (var vLN02125 = 0; vLN02125 < this.players.list.length; ++vLN02125) {
      if (this.players.list[vLN02125].active) {
        vA672.push(vLN02125);
      }
    }
    var vLN1161 = 1;
    if (vA672.length >= 14) {
      vLN1161 = 3;
    } else if (vA672.length >= 8) {
      vLN1161 = 2;
    }
    var v12374;
    for (var vLN02125 = 0; vLN02125 < vLN1161; ++vLN02125) {
      v12374 = UTILS.randInt(0, vA672.length - 1);
      v12286 = this.players.list[vA672[v12374]];
      if (v12286) {
        this.updateTeam(v12286, 2);
        this.players.kill(v12286, null, null, true);
        this.broadcast("ac", v12286.sid, null, "got infected");
      }
      vA672.splice(v12374, 1);
    }
  };
  this.pickSimon = function () {
    vA672.length = 0;
    var v12375 = null;
    for (var vLN02126 = 0; vLN02126 < this.players.list.length; ++vLN02126) {
      if (this.players.list[vLN02126].active) {
        if (this.host == this.players.list[vLN02126].id) {
          v12375 = this.players.list[vLN02126];
          break;
        } else {
          vA672.push(vLN02126);
        }
      }
    }
    if (!v12375) {
      v12375 = this.players.list[vA672[UTILS.randInt(0, vA672.length - 1)]];
    }
    if (v12375) {
      this.updateTeam(v12375, 2);
      v12375.maxHealth = 5000;
      v12375.health = v12375.maxHealth;
      v12375.send("h", v12375.health);
    }
  };
  this.pickTraitors = function () {
    vA672.length = 0;
    for (var vLN02128 = 0; vLN02128 < this.players.list.length; ++vLN02128) {
      if (this.players.list[vLN02128].active) {
        vA672.push(vLN02128);
      }
    }
    var vLN1162 = 1;
    if (vA672.length >= 12) {
      vLN1162 = 3;
    } else if (vA672.length >= 6) {
      vLN1162 = 2;
    }
    var v12376;
    for (var vLN02128 = 0; vLN02128 < vLN1162; ++vLN02128) {
      v12376 = UTILS.randInt(0, vA672.length - 1);
      v12286 = this.players.list[vA672[v12376]];
      if (v12286) {
        this.updateTeam(v12286, 2);
      }
      vA672.splice(v12376, 1);
    }
  };
  this.pickStalker = function () {
    vA672.length = 0;
    for (var vLN02129 = 0; vLN02129 < this.players.list.length; ++vLN02129) {
      if (this.players.list[vLN02129].active) {
        vA672.push(vLN02129);
      }
    }
    v12286 = this.players.list[vA672[UTILS.randInt(0, vA672.length - 1)]];
    if (v12286) {
      this.updateTeam(v12286, 2);
      v12286.maxHealth = 400;
      v12286.health = v12286.maxHealth;
      v12286.regen = 0;
      v12286.send("h", v12286.health);
      v12286.updateLoadout(this, 0, true, [12]);
      this.broadcast("inat", v12286.sid, [12], 0, undefined, undefined, false);
    }
  };
  this.pickBoss = function () {
    vA672.length = 0;
    for (var vLN02130 = 0; vLN02130 < this.players.list.length; ++vLN02130) {
      if (this.players.list[vLN02130].active) {
        vA672.push(vLN02130);
      }
    }
    v12286 = this.players.list[vA672[UTILS.randInt(0, vA672.length - 1)]];
    if (v12286) {
      this.updateTeam(v12286, 2);
      v12286.maxHealth = 10000;
      v12286.health = v12286.maxHealth;
      v12286.regen = 0;
      v12286.send("h", v12286.health);
    }
  };
  this.lockSeekers = function () {
    for (var vLN02131 = 0; vLN02131 < this.players.list.length; ++vLN02131) {
      if (this.players.list[vLN02131].active && this.players.list[vLN02131].team == 2) {
        this.lockPlayer(this.players.list[vLN02131], true);
      }
    }
  };
  this.pickSeeker = function () {
    vA672.length = 0;
    for (var vLN02132 = 0; vLN02132 < this.players.list.length; ++vLN02132) {
      if (this.players.list[vLN02132].active) {
        vA672.push(vLN02132);
      }
    }
    v12286 = this.players.list[vA672[UTILS.randInt(0, vA672.length - 1)]];
    if (v12286) {
      this.updateTeam(v12286, 2);
      this.lockPlayer(v12286, true);
    }
  };
  this.releaseSeeker = function () {
    for (var vLN02133 = 0; vLN02133 < this.players.list.length; ++vLN02133) {
      v12286 = this.players.list[vLN02133];
      if (v12286.team == 2) {
        this.lockPlayer(v12286, false);
      }
    }
  };
  this.setBusy = function (player, busy) {
    if (player) {
      player.isBusy = busy;
      if (serverIO) {
        game.broadcast("busy", player.sid, busy);
      }
    }
  };
  this.setJuggernaut = function (player, juggernaut) {
    if (player) {
      player.isJuggernaut = juggernaut;
      if (serverIO) {
        game.broadcast("jg", player.sid, juggernaut);
        if (juggernaut) {
          game.addPlayerSound(player.sid, "jug_0", {
            vol: 0.5,
            rate: 1,
            loop: 1
          });
          player.maxHealth = 2000;
          player.health = 2000;
          game.broadcast("h", player.health, player.sid, null, null, true, true);
          game.players.giveWeapon(player, 25);
        } else {
          game.removePlayerSound(player.sid, "jug_0");
          if (player.active) {
            player.maxHealth = player.startHealth;
            player.health = player.startHealth;
            game.broadcast("h", player.health, player.sid, null, null, true, true);
            game.players.removeWeapon(player, 25);
          }
        }
      }
    }
  };
  this.respawnObj = function (uid) {
    for (var vLN02134 = 0; vLN02134 < game.map.manager.objects.length; ++vLN02134) {
      v12286 = game.map.manager.objects[vLN02134];
      if (v12286.uid == uid) {
        game.map.manager.destObjs.splice(game.map.manager.destObjs.indexOf(v12286.uid), 1);
        v12286.active = true;
        v12286.destroyed = false;
        if (v12286.health != null) {
          v12286.health = v12286.startHealth;
        }
        if (RENDER && v12286.meshRef != null) {
          v12286.meshRef.visible = true;
        }
        if (RENDER) {
          RENDER.updateShadowMap();
        }
        break;
      }
    }
  };
  this.resetSites = function () {
    for (var vLN02135 = 0; vLN02135 < game.map.manager.sites.length; ++vLN02135) {
      v12286 = game.map.manager.sites[vLN02135];
      if (v12286.meshRef) {
        var v12377 = !!game.mode && !!game.mode.site;
        v12286.meshRef.visible = v12377;
      }
    }
  };
  this.resetDomZones = function () {
    for (var vLN02136 = 0; vLN02136 < game.map.manager.domzones.length; ++vLN02136) {
      v12286 = game.map.manager.domzones[vLN02136];
      v12286.capturedBy = null;
      v12286.captureT = 0;
      v12286.lastTeamOn = null;
      v12286.onPoint.length = 0;
      v12286.teamsOn.length = 0;
      v12286.mlt = 1;
      if (v12286.meshRef) {
        var v12378 = !!game.mode && !!game.mode.dom;
        v12286.meshRef.visible = v12378;
      }
    }
  };
  this.updateDomZone = function (uid, capturedBy, captureT, lastTeamOn, teamsOn, mlt) {
    for (var vLN02137 = 0; vLN02137 < game.map.manager.domzones.length; ++vLN02137) {
      v12286 = game.map.manager.domzones[vLN02137];
      if (v12286.uid == uid) {
        v12286.capturedBy = capturedBy;
        v12286.captureT = captureT || 0;
        v12286.lastTeamOn = lastTeamOn || null;
        v12286.teamsOn = teamsOn || [];
        v12286.mlt = mlt || 1;
        break;
      }
    }
  };
  this.hasAllZones = function () {
    var v12379;
    var v12380 = null;
    var vLN02138 = 0;
    for (var vLN02139 = 0; vLN02139 < game.map.manager.domzones.length; ++vLN02139) {
      v12379 = game.map.manager.domzones[vLN02139].capturedBy;
      if (!v12379) {
        return false;
      }
      if (v12380 && v12380 != v12379) {
        return false;
      }
      v12380 = v12379;
      vLN02138++;
    }
    return vLN02138 == game.map.manager.domzones.length && v12380;
  };
  this.updateDomZones = function (delta) {
    if (game && game.mode && game.mode.dom && (!game.isServer || !game.waitTimers || game.waitTimers[0] && game.waitTimers[0].contTime)) {
      if (game.isServer) {
        var v12381 = false;
        game.objectiveTimer -= delta;
        if (game.objectiveTimer <= 0) {
          game.objectiveTimer = 1500;
          v12381 = true;
        }
      }
      var vA673 = [];
      for (var vLN02140 = 0; vLN02140 < game.map.manager.domzones.length; ++vLN02140) {
        v12286 = game.map.manager.domzones[vLN02140];
        var v12382 = v12286.teamsOn.length;
        if (game.isServer) {
          if (v12286.capturedBy && v12381) {
            game.giveTeamScore(v12286.capturedBy, 10);
            game.players.syncLeaders();
          }
          v12286.onPoint.length = 0;
          v12286.teamsOn.length = 0;
          for (var vLN02141 = 0; vLN02141 < game.players.list.length; ++vLN02141) {
            v12287 = game.players.list[vLN02141];
            if (v12287.active && v12287.collides(v12286)) {
              if (v12286.teamsOn.indexOf(v12287.team) == -1 && (v12286.teamsOn.push(v12287.team), v12286.teamsOn.length > 1)) {
                break;
              }
              v12286.onPoint.push(v12287);
            }
          }
        }
        var v12383 = v12382 != v12286.teamsOn.length;
        if (v12286.teamsOn.length != 1) {
          if (!v12286.teamsOn.length) {
            v12286.captureT = 0;
            v12286.lastTeamOn = null;
          }
        } else {
          v12286.teamsOn[0] = parseInt(v12286.teamsOn[0]);
          if (!v12286.capturedBy || v12286.capturedBy != v12286.teamsOn[0]) {
            if (v12286.lastTeamOn != v12286.teamsOn[0]) {
              v12286.captureT = 0;
              v12383 = true;
            }
            v12286.captureT == 0;
            if (game.isServer) {
              var v12387 = !!serverIO && game.hasAllZones();
              var v12385 = v12286.mlt;
              v12286.lastTeamOn = v12286.teamsOn[0];
              v12286.mlt = 1 + (v12286.onPoint.length - 1) * game.mode.perPlayerMlt;
              if (v12387 && v12387 != v12286.teamsOn[0]) {
                v12286.mlt *= game.mode.lockoutMlt;
              }
              if (v12385 != v12286.mlt) {
                v12383 = true;
              }
            }
            v12286.captureT += delta * v12286.mlt;
            if (game.isServer) {
              var v12386 = false;
              if (v12286.captureT >= game.mode.captureTime) {
                v12383 = true;
                v12386 = true;
                v12286.captureT = 0;
                v12286.capturedBy;
                v12286.capturedBy = v12286.teamsOn[0];
                game.players.syncLeaders();
                game.broadcast("cct", v12286.uid, v12286.capturedBy);
                var v12387 = game.hasAllZones();
                if (v12387) {
                  game.giveTeamScore(v12387, 250);
                  game.players.syncLeaders();
                }
              }
              for (var vLN02142 = 0; vLN02142 < v12286.onPoint.length; ++vLN02142) {
                v12287 = v12286.onPoint[vLN02142];
                if (v12287 && v12286.capturedBy && v12287.team == v12286.capturedBy && v12386) {
                  v12287.caps++;
                  game.players.score(v12287, 200);
                  game.incMedal("Secured", v12287);
                  v12287.send("am", [20, 200, 0, 1]);
                  if (v12286.onPoint.length > 2) {
                    game.players.score(v12287, 25);
                    game.incMedal("Team Work", v12287);
                    v12287.send("am", [21, 25, 0, 1]);
                    game.challenges.update(game, "twm", 1, null, v12287);
                  }
                }
              }
            }
          } else {
            v12286.captureT = 0;
            v12286.lastTeamOn = null;
          }
        }
        if (game.isServer && v12383) {
          vA673.push(v12286.uid, v12286.capturedBy, v12286.captureT, v12286.lastTeamOn, v12286.teamsOn, v12286.mlt);
        }
      }
      if (game.isServer && vA673.length) {
        game.broadcast("uct", vA673);
      }
    }
  };
  this.capFlag = function (player, flag) {
    if (game.isServer && (player.caps++, player.flag = null, game.players.teamScore(player, 1), game.mode.rush || game.broadcast("ac", player.sid, null, "captured the Flag"), game.incMedal("Capture", player), player.send("am", [22, 150, 0, 1]), game.players.score(player, 150, 2), game.resetFlag(flag), game.mode && game.mode.rush)) {
      var v12388 = game.getSpawnPoint(player.team, player);
      game.players.changePosition(player, v12388.x, v12388.y, v12388.z, true, false, undefined, true);
    }
  };
  this.updateFlagCol = function (flag, player) {
    if (player && player.team && flag.teamCol != player.team && flag.meshRef) {
      flag.teamCol = player.team;
      flag.meshRef.material = RENDER.getMat("crystal_0", game.map.manager.getFlagDat(flag.team, player));
      flag.meshRef.zoneMesh.material = RENDER.getMat("zone_r", game.map.manager.getZoneDat(flag.team, player));
    }
  };
  this.updateFlags = function (isServer, player, delta) {
    if (game.mode && (game.mode.flags || game.mode.oneflag)) {
      var v12389 = false;
      var v12390 = false;
      for (var vLN02143 = 0; vLN02143 < game.map.manager.flags.length; ++vLN02143) {
        v12286 = game.map.manager.flags[vLN02143];
        if ((!game.mode.oneflag || v12286.neutral) && (game.mode.oneflag || !v12286.neutral)) {
          if (!isServer && v12286.meshRef) {
            if (player) {
              game.updateFlagCol(v12286, player);
            }
            if (v12286.carrier) {
              if (player && v12286.team == player.team) {
                v12390 = true;
              }
              if (player && v12286.carrier == player.sid) {
                v12389 = true;
              }
              v12287 = game.players.findBySid(v12286.carrier);
              if (v12287) {
                if (v12287.isYou) {
                  RENDER.moveMesh(v12286.meshRef, v12287.x, v12287.y + config.flagHOff, v12287.z);
                } else {
                  RENDER.moveMesh(v12286.meshRef, v12287.x, v12287.y + config.flagHOff, v12287.z);
                }
                if (v12287.objInstances && v12286.meshRef.visible != v12287.objInstances.visible) {
                  v12286.meshRef.visible = v12287.objInstances.visible;
                }
              }
            } else {
              if (!v12286.meshRef.visible) {
                v12286.meshRef.visible = true;
              }
              RENDER.moveMesh(v12286.meshRef, v12286.x, v12286.y, v12286.z);
            }
            v12286.bobAnimY = (v12286.bobAnimY || 0) + delta * 0.003;
            v12286.meshRef.position.y += Math.cos(v12286.bobAnimY);
            v12286.meshRef.rotation.y += delta * 0.002;
          } else if (isServer) {
            if (!v12286.carrier && v12286.idleTimer) {
              v12286.idleTimer -= delta;
              if (v12286.idleTimer <= 0) {
                game.resetFlag(v12286);
              }
            }
            if (v12286.carrier) {
              if (v12286.flagTimer == null) {
                v12286.flagTimer = 0;
              }
              v12286.flagTimer -= delta;
              if (v12286.flagTimer <= 0) {
                v12287 = game.players.findBySid(v12286.carrier);
                if (v12287) {
                  v12286.img.x = v12287.x;
                  v12286.img.y = v12287.y + config.flagHOff;
                  v12286.img.z = v12287.z;
                  v12286.flagTimer = config.flagUpdate;
                  game.broadcast("ufp", v12286.uid, v12286.img.x.round(1), v12286.img.y.round(1), v12286.img.z.round(1));
                }
              }
            } else {
              v12286.img.x = v12286.x;
              v12286.img.y = v12286.y;
              v12286.img.z = v12286.z;
            }
          }
        }
      }
      if (!isServer && !game.mode.rush) {
        if (v12390 && v12389) {
          if (gameMessage.textContent != config.flagMsgRC) {
            gameMessage.textContent = config.flagMsgRC;
          }
        } else if (v12390) {
          if (gameMessage.textContent != config.flagMsgE) {
            gameMessage.textContent = config.flagMsgE;
          }
        } else if (v12389) {
          if (gameMessage.textContent != config.flagMsg) {
            gameMessage.textContent = config.flagMsg;
          }
        } else if (gameMessage.textContent != "") {
          gameMessage.textContent = "";
        }
        if (specGMessage.textContent != gameMessage.textContent) {
          specGMessage.textContent = gameMessage.textContent;
        }
      }
    }
  };
  this.updateFlag = function (uid, x, y, z, carrier) {
    for (var vLN02144 = 0; vLN02144 < game.map.manager.flags.length; ++vLN02144) {
      v12286 = game.map.manager.flags[vLN02144];
      if (v12286.uid == uid) {
        v12286.carrier = carrier;
        v12286.img.x = x;
        v12286.img.y = y;
        v12286.img.z = z;
        game.moveObj(v12286, x, y, z);
        break;
      }
    }
  };
  this.dropFlag = function (flag) {
    if (game.isServer && flag && flag.carrier) {
      var v12391 = game.players.findBySid(flag.carrier);
      game.updateCarrier(flag);
      if (v12391) {
        if (!game.mode.rush) {
          game.broadcast("ac", v12391.sid, null, "dropped the Flag");
        }
        if (!game.mode.oneflag) {
          game.updateFlagInfo(flag, "AWAY");
        }
        v12391.flag = null;
        game.updateObjPos(flag, v12391.x, v12391.y + config.flagOff, v12391.z);
        flag.idleTimer = config.flagIdle;
      } else {
        game.updateObjPos(flag, flag.orgX, flag.orgY, flag.orgZ);
      }
    }
  };
  this.pickupFlag = function (player, flag) {
    if (game.isServer && game.mode && (game.mode.flags || game.mode.oneflag) && !flag.carrier) {
      if (player.team != flag.team || game.mode.oneflag) {
        if (!player.flag) {
          game.incMedal("Pickup", player);
          player.send("am", [24, 20, 0, 1]);
          game.players.score(player, 20, 2);
          game.updateCarrier(flag, player);
          if (!game.mode.oneflag) {
            game.updateFlagInfo(flag, player.fakeName || player.alias);
          }
          if (!game.mode.rush) {
            game.broadcast("ac", player.sid, null, "got the Flag");
          }
        }
      } else if (flag.x != flag.orgX || flag.y != flag.orgY || flag.z != flag.orgZ) {
        if (!game.mode.rush) {
          game.broadcast("ac", player.sid, null, "returned the Flag");
        }
        game.incMedal("Return", player);
        player.send("am", [23, 50, 0, 1]);
        game.players.score(player, 50, 2);
        game.resetFlag(flag);
      }
    }
  };
  this.syncFlag = function (flag) {
    game.broadcast("ufl", flag.uid, flag.x.round(1), flag.y.round(1), flag.z.round(1), flag.carrier || 0);
  };
  this.updateCarrier = function (flag, player) {
    flag.carrier = player ? player.sid : 0;
    if (player) {
      player.flag = flag;
      flag.flagTimer = config.flagUpdate;
      game.flagTeam = player.team;
      game.flagCarrier = player.sid;
    } else {
      game.flagTeam = null;
      game.flagCarrier = null;
    }
    game.syncFlag(flag);
  };
  this.resetFlags = function () {
    for (var vLN02145 = 0; vLN02145 < game.map.manager.flags.length; ++vLN02145) {
      v12286 = game.map.manager.flags[vLN02145];
      v12286.carrier = null;
      v12286.x = v12286.orgX;
      v12286.y = v12286.orgY;
      v12286.z = v12286.orgZ;
      v12286.idleTimer = null;
      if (v12286.meshRef) {
        var v12392 = !!game.mode && (!!game.mode.flags || !!game.mode.oneflag);
        if (game.mode && game.mode.oneflag && !v12286.neutral) {
          v12392 = false;
        } else if ((!game.mode || !game.mode.oneflag) && v12286.neutral) {
          v12392 = false;
        }
        v12286.meshRef.visible = v12392;
        v12286.meshRef.zoneMesh.visible = v12392;
      }
      v12286.active = (!game.mode || !game.mode.oneflag || !!v12286.neutral) && (game.mode && game.mode.oneflag || !v12286.neutral);
    }
  };
  this.resetFlag = function (flag) {
    game.updateObjPos(flag, flag.orgX, flag.orgY, flag.orgZ);
    game.updateCarrier(flag);
    if (!game.mode.oneflag) {
      game.updateFlagInfo(flag, "AT BASE");
    }
    flag.idleTimer = null;
  };
  this.updateFlagInfo = function (flag, info) {
    game.teamFlags[flag.team] = info;
    this.broadcast("ufi", flag.team, game.teamFlags[flag.team]);
  };
  this.updateFlagPing = function (uid, x, y, z) {
    for (var vLN02146 = 0; vLN02146 < game.map.manager.flags.length; ++vLN02146) {
      v12286 = game.map.manager.flags[vLN02146];
      if (v12286.uid == uid) {
        v12286.img.x = x;
        v12286.img.y = y;
        v12286.img.z = z;
        break;
      }
    }
  };
  this.dropSpawnable = function (typeInd, owner, data, pos) {
    if (game.isServer) {
      var v12393 = medals[typeInd];
      if (v12393.playerSpecific && (!owner || !owner.isPlayer)) {
        return;
      }
      var v12394 = v12393.getScale ? v12393.getScale(data) : v12393.scale;
      var v12395 = owner ? owner.team : 0;
      var v12396 = medals.getData(typeInd, null, pos && pos.x != null ? pos.x : owner ? owner.x : 0, (pos && pos.y != null ? pos.y : owner ? owner.y : 0) + (v12393.yOff || 0), pos && pos.z != null ? pos.z : owner ? owner.z : 0, v12394 * (v12393.padMlt || 1), v12395, v12393.timer, data, v12393.aiOnly, v12393.canShoot, v12393.playerSpecific ? owner.id : undefined);
      v12396.active = true;
      if (v12393.playerSpecific) {
        if (owner && owner.send) {
          owner.send("crsp", typeInd, v12396.sid, v12396.x.round(1), v12396.y.round(1), v12396.z.round(1), v12396.team, data);
        }
      } else {
        game.broadcast("crsp", typeInd, v12396.sid, v12396.x.round(1), v12396.y.round(1), v12396.z.round(1), v12396.team, data);
      }
      game.map.manager.spawnables[v12396.sid] = v12396;
    }
  };
  this.pickupSpawnable = function (player, spawnable) {
    var v12397 = medals[spawnable.i];
    if (spawnable && spawnable.active) {
      if (v12397.aiOnly && (!player || !player.isAI)) {
        return;
      }
      if (v12397.playerSpecific && (!player || !player.isPlayer || player.id !== spawnable.pid)) {
        return;
      }
      var v12398 = !!v12397.stopInteract && v12397.stopInteract(game, serverIO, player, spawnable);
      if (v12398) {
        return !!UTILS.isString(v12398) && v12398;
      }
      if (game.isServer && !v12397.alwaysActive) {
        spawnable.active = false;
      }
      if (game.isServer && player && v12397.onPickup) {
        v12397.onPickup(game, serverIO, player, spawnable);
      }
      if (player && v12397.onCollision) {
        v12397.onCollision(game, serverIO, player, spawnable);
      }
      if (!!game.isServer && !spawnable.dontDestroy && !v12397.alwaysActive) {
        if (v12397.onDestroy) {
          v12397.onDestroy(game, serverIO, player, spawnable);
        }
        game.broadcast("dsp", spawnable.sid);
        delete game.map.manager.spawnables[spawnable.sid];
      }
    }
  };
  this.shootSpawnable = function (player, spawnable) {
    var v12399 = medals[spawnable.i];
    if (spawnable && spawnable.active) {
      if (v12399.aiOnly && (!player || !player.isAI)) {
        return;
      }
      if (v12399.playerSpecific && (!player || !player.isPlayer || player.id !== spawnable.pid)) {
        return;
      }
      var v12400 = !!v12399.stopInteract && v12399.stopInteract(game, serverIO, player, spawnable);
      if (v12400) {
        return !!UTILS.isString(v12400) && v12400;
      }
      if (game.isServer && !v12399.alwaysActive) {
        spawnable.active = false;
      }
      if (game.isServer && player && v12399.onShoot) {
        v12399.onShoot(game, serverIO, player, spawnable);
      }
      if (!!game.isServer && !spawnable.dontDestroy && !v12399.alwaysActive) {
        if (v12399.onDestroy) {
          v12399.onDestroy(game, serverIO, player, spawnable);
        }
        game.broadcast("dsp", spawnable.sid);
        delete game.map.manager.spawnables[spawnable.sid];
      }
    }
  };
  this.createSpawnable = function (medalInd, sid, x, y, z, team, data, item) {
    var v12401 = medals[medalInd];
    var v12402 = v12401.model;
    if (v12401.texRange) {
      var v12403 = UTILS.randInt(0, v12401.texRange);
      v12402 = v12401.model + (v12403 > 0 ? "_" + v12403 : "");
    } else if (v12401.texSrc) {
      v12402 = v12401.texSrc;
    }
    var v12404 = v12401.getScale ? v12401.getScale(data) : v12401.scale;
    var v12405 = v12401.getRotation ? v12401.getRotation(data) : v12401.rotation || 0;
    var v12406 = RENDER[v12401.fileExt ? "loadAnimMesh" : "loadMesh"]({
      isMdl: true,
      fileExt: v12401.fileExt || null,
      src: v12401.model,
      texSrc: v12402,
      noGroup: true,
      noShadow: true,
      noFog: true,
      emissive: v12401.emissive ? v12401.emissive(item, team) : null,
      noEmisTex: !v12401.emisTex,
      outlineMesh: v12401.outline == null ? undefined : v12401.outline,
      outlineScale: v12401.outlineScale ? v12401.outlineScale : undefined
    }, x, y + (v12401.yOff || 0), z, v12405, v12404, RENDER.scene);
    var v12407 = medals.getData(medalInd, sid, x, y, z, v12404 * (v12401.padMlt || 1), team, undefined, data, v12401.aiOnly, v12401.canShoot);
    v12407.meshRef = v12406;
    v12407.active = true;
    if (v12401.onSpawn) {
      v12401.onSpawn(v12407, x, y, z);
    }
    game.map.manager.spawnables[sid] = v12407;
  };
  this.disposeSpawnable = function (sid) {
    for (var v12408 in game.map.manager.spawnables) {
      v12286 = game.map.manager.spawnables[v12408];
      if (v12286.sid == sid) {
        var v12409 = medals[v12286.i];
        if (v12409 && v12409.onDestroy) {
          v12409.onDestroy(game, null, null, v12286);
        }
        if (v12286.meshRef && v12286.meshRef.outlineMesh) {
          v12286.meshRef.remove(v12286.meshRef.outlineMesh);
        }
        RENDER.remove(v12286.meshRef);
        v12286.meshRef = null;
        delete game.map.manager.spawnables[sid];
        break;
      }
    }
  };
  this.updateSpawnables = function (isServer, playerPos, delta) {
    for (var v12410 in game.map.manager.spawnables) {
      v12286 = game.map.manager.spawnables[v12410];
      if (isServer || !v12286.meshRef || medals[v12286.i].noAnim) {
        if (isServer && v12286.active && !medals[v12286.i].noDespawn && v12286.timer) {
          v12286.timer -= delta;
          if (v12286.timer <= 0) {
            v12286.active = false;
            if (medals[v12286.i].onDestroy) {
              medals[v12286.i].onDestroy(game, serverIO, v12286);
            }
            game.broadcast("dsp", v12286.sid);
            delete game.map.manager.spawnables[v12286.sid];
          }
        }
      } else {
        RENDER.moveMesh(v12286.meshRef, v12286.x, v12286.y, v12286.z);
        v12286.bobAnimY = (v12286.bobAnimY || 0) + delta * 0.003;
        v12286.meshRef.position.y += Math.cos(v12286.bobAnimY);
        v12286.meshRef.rotation[medals[v12286.i].rotAxis || "y"] += delta * 0.002;
      }
    }
  };
  this.resetSpawnables = function () {
    for (var v12411 in game.map.manager.spawnables) {
      v12286 = game.map.manager.spawnables[v12411];
      if (v12286.meshRef) {
        RENDER.remove(v12286.meshRef);
      }
    }
    game.map.manager.spawnables = [];
  };
  this.getReserveMags = function (weapon) {
    if (weapon.magReserve == null) {
      return 1;
    } else {
      return weapon.magReserve;
    }
  };
  this.chooseMysteryBox = function () {
    var v12412 = game.map.manager.mysteryBoxes;
    if (v12412.length > 1) {
      var v12413 = game.getActiveMysteryBox();
      v12412 = v12412.filter(box => box != v12413);
    }
    return UTILS.getRandom(v12412);
  };
  this.getMysteryBoxWeapon = function (teddyChance) {
    var v12414 = teddyChance && UTILS.randInt(0, 100) <= teddyChance && !game.fireSaleTimer;
    if (v12414) {
      return -1;
    }
    var v12415 = UTILS.randFloat(0, 100).round(2);
    if (game.weapons.mysteryBoxRarities[0] == 0) {
      v12415 = Math.max(v12415, 0.01);
    }
    var v12416;
    var vLN02147 = 0;
    var vLN02148 = 0;
    for (var vLN02149 = 0; vLN02149 < game.weapons.mysteryBoxRarities.length; ++vLN02149) {
      v12416 = game.weapons.mysteryBoxRarities[vLN02149];
      vLN02148 += v12416;
      if (v12415 <= vLN02148) {
        vLN02147 = vLN02149;
        break;
      }
    }
    var v12417 = game.weaponConfig.filter(weapon => weapon && weapon.mysteryBoxR == vLN02147);
    if (!v12417.length) {
      return -1;
    }
    var v12418 = UTILS.getRandom(v12417);
    return v12418.id;
  };
  this.changeMysteryWeapon = function (box, stage, force) {
    var v12419 = box.pendingWeapon;
    var v12420 = force || v12419 == -1 ? v12419 : UTILS.getRandom(game.weapons.onlyWeapons);
    if ((!box.wepMesh || box.wepMesh.stage != stage || force) && (!box.wepMesh || box.wepMesh.weaponId != v12420)) {
      if (box.wepMesh) {
        RENDER.scene.remove(box.wepMesh);
      }
      if (v12420 == -1) {
        box.wepMesh = RENDER.loadMesh({
          isMdl: true,
          src: "teddy_0",
          shadows: false,
          shadowsR: false,
          vertexColors: true,
          color: "#ffffff"
        }, box.meshRef.position.x, box.meshRef.position.y, box.meshRef.position.z, [box.xR, box.yR, box.zR], 9, RENDER.scene);
      } else {
        var v12421 = game.weapons[v12420];
        var v12422 = v12421.altSkin || {};
        box.wepMesh = RENDER.loadMesh({
          src: "weapons/" + v12421.src + (v12422.mid == null ? "" : "_" + v12422.mid),
          texSrc: v12422.mid == null ? v12422.tex ? v12422.tex : v12422 && v12422.id != null ? "weapons/skins/" + v12421.src + "_" + v12422.id : null : UTILS.getReModel(game.store, v12422),
          tFilter: THREE.LinearFilter,
          noGroup: true,
          uv2: true,
          shininess: v12421.shine || 60,
          specular: 2697513,
          shadowsR: true,
          transparent: v12422.opac != null || v12421.seeThrough || v12422.trans,
          sameGlow: v12422.sameGlow,
          glowText: v12422.glow || v12422.sameGlow,
          emissive: (v12421.transp || v12422.glow || v12422.sameGlow) && !v12422.noEmis ? v12422.emiss || "#ffffff" : null
        }, box.meshRef.position.x, box.meshRef.position.y, box.meshRef.position.z, [box.xR, box.yR + Math.PI / 2, box.zR], (v12422.mScl || v12421.scale) * 1.5, RENDER.scene);
      }
      box.wepMesh.visible = true;
      box.wepMesh.stage = stage;
      box.wepMesh.weaponId = v12420;
    }
  };
  this.updateMysteryBoxes = function (isServer, playerPos, delta) {
    for (var vLN02150 = 0; vLN02150 < game.map.manager.mysteryBoxes.length; ++vLN02150) {
      v12286 = game.map.manager.objects[game.map.manager.mysteryBoxes[vLN02150]];
      if (v12286) {
        if (!isServer && v12286.meshRef) {
          if (v12286.state >= 1) {
            v12286.timer -= delta;
            if (v12286.state == 1) {
              var v12423 = 1 - v12286.timer / config.mysteryBoxAnim;
              var v12424 = (config.mysteryBoxOffset - v12286.height) * v12423;
              var v12425 = v12423 >= 0.8;
              var v12426 = Math.floor(v12286.timer / 250);
              game.changeMysteryWeapon(v12286, v12426, v12425);
              RENDER.moveMesh(v12286.wepMesh, v12286.meshRef.position.x, v12286.meshRef.position.y + v12286.height + v12424, v12286.meshRef.position.z);
            }
            if (v12286.timer <= 0 && (v12286.state++, v12286.timer = v12286.state == 2 ? v12286.pendingWeapon == -1 ? config.mysteryBoxDespawnTeddy : config.mysteryBoxDespawn : config.mysteryBoxAnim, v12286.state >= 3)) {
              v12286.state = 0;
              v12286.purchasedBy = undefined;
              var v12428 = v12286.pendingWeapon == -1;
              v12286.pendingWeapon == null;
              if (v12286.wepMesh && (!v12428 || !game.fireSaleTimer)) {
                v12286.wepMesh.visible = false;
              }
            }
          }
        } else if (isServer && (v12286.active || game.fireSaleTimer) && v12286.state >= 1 && (v12286.timer -= delta, v12286.timer <= 0)) {
          v12286.state++;
          v12286.timer = v12286.state == 2 ? v12286.pendingWeapon == -1 ? config.mysteryBoxDespawnTeddy : config.mysteryBoxDespawn : config.mysteryBoxAnim;
          if (v12286.state >= 3) {
            v12286.state = 0;
            v12286.timer = 0;
            v12286.purchasedBy = undefined;
            var v12428 = v12286.pendingWeapon == -1;
            v12286.pendingWeapon == null;
            if (v12428) {
              if (game.fireSaleTimer) {
                game.switchMysteryBox(game.chooseMysteryBox(), true);
              } else {
                game.switchMysteryBox();
              }
            }
          }
          game.syncMysteryBox(v12286);
        }
      }
    }
  };
  this.getActiveMysteryBox = function () {
    for (var vLN02151 = 0; vLN02151 < game.map.manager.mysteryBoxes.length; ++vLN02151) {
      v12286 = game.map.manager.objects[game.map.manager.mysteryBoxes[vLN02151]];
      if (v12286 && v12286.active) {
        return v12286.uid;
      }
    }
    return null;
  };
  this.switchMysteryBox = function (uid, enable) {
    if (game.map.manager.mysteryBoxes && game.map.manager.mysteryBoxes.length) {
      var v12429 = false;
      if (uid == null || uid == null) {
        v12429 = true;
        uid = game.chooseMysteryBox();
      }
      for (var vLN02152 = 0; vLN02152 < game.map.manager.mysteryBoxes.length; ++vLN02152) {
        v12286 = game.map.manager.objects[game.map.manager.mysteryBoxes[vLN02152]];
        if (v12286) {
          v12286.active = v12286.uid == uid || !!enable;
          if (v12286.uid != uid && enable || v12429) {
            v12286.purchasedBy = undefined;
            v12286.pendingWeapon = undefined;
            v12286.timer = 0;
            v12286.state = 0;
          }
          if (RENDER && v12286.meshRef != null) {
            v12286.meshRef.visible = !!v12286.active;
          }
          if (RENDER && v12286.wepMesh != null) {
            v12286.wepMesh.visible = !!v12286.active && !!(v12286.state >= 1);
          }
          if (RENDER && v12286.beamMesh != null) {
            v12286.beamMesh.visible = !!v12286.active;
          }
        }
      }
      if (game.isServer) {
        game.broadcast("smybx", uid, enable);
      }
    }
  };
  this.updateMysteryBox = function (uid, active, state, timer, pendingWeapon, purchasedBy) {
    for (var vLN02153 = 0; vLN02153 < game.map.manager.mysteryBoxes.length; ++vLN02153) {
      v12286 = game.map.manager.objects[game.map.manager.mysteryBoxes[vLN02153]];
      if (v12286 && v12286.uid == uid) {
        v12286.active = !!active;
        v12286.purchasedBy = purchasedBy;
        v12286.pendingWeapon = pendingWeapon;
        v12286.timer = timer;
        v12286.state = state;
        if (RENDER && v12286.meshRef != null) {
          v12286.meshRef.visible = !!v12286.active;
        }
        if (RENDER && v12286.wepMesh != null) {
          v12286.wepMesh.visible = !!v12286.active && !!(state >= 1);
        }
        if (RENDER && v12286.beamMesh != null) {
          v12286.beamMesh.visible = !!v12286.active;
        }
        if (RENDER && v12286.state == 1) {
          var v12430 = 1 - v12286.timer / config.mysteryBoxAnim;
          var v12431 = (config.mysteryBoxOffset - v12286.height) * v12430;
          var v12432 = v12430 >= 0.8;
          var v12433 = Math.floor(v12286.timer / 250);
          game.changeMysteryWeapon(v12286, v12433, v12432);
          RENDER.moveMesh(v12286.wepMesh, v12286.meshRef.position.x, v12286.meshRef.position.y + v12286.height + v12431, v12286.meshRef.position.z);
        }
        return;
      }
    }
  };
  this.syncMysteryBox = function (box) {
    game.broadcast("mybx", box.uid, box.active, box.state, box.timer, box.pendingWeapon, box.purchasedBy);
  };
  this.resetMysteryBoxes = function () {
    if (game.map.manager.mysteryBoxes && game.map.manager.mysteryBoxes.length) {
      for (var vLN02154 = 0; vLN02154 < game.map.manager.mysteryBoxes.length; ++vLN02154) {
        v12286 = game.map.manager.objects[game.map.manager.mysteryBoxes[vLN02154]];
        if (v12286) {
          v12286.active = false;
          v12286.purchasedBy = undefined;
          v12286.pendingWeapon = undefined;
          v12286.timer = 0;
          v12286.state = 0;
          if (RENDER && v12286.meshRef != null) {
            v12286.meshRef.visible = !!v12286.active;
          }
          if (RENDER && v12286.wepMesh != null) {
            v12286.wepMesh.visible = false;
          }
          if (RENDER && v12286.beamMesh != null) {
            v12286.beamMesh.visible = !!v12286.active;
          }
        }
      }
    }
  };
  this.changeKrumWeapon = function (machine, stage, progress) {
    var v12434 = machine.pendingWeapon;
    if (!machine.wepMesh || machine.wepMesh.weaponId != v12434 || machine.wepMesh.stage != stage) {
      if (machine.wepMesh) {
        RENDER.scene.remove(machine.wepMesh);
      }
      var v12435 = stage ? game.upgradeWeapons[v12434] : game.weapons[v12434];
      var v12436 = v12435.altSkin || {};
      machine.wepMesh = RENDER.loadMesh({
        fileExt: v12436.fileExt,
        animS: v12436.animS,
        hasAnim: v12436.hasAnim,
        inspectAnim: v12436.inspectAnim,
        local: v12435.local || v12436.local,
        localM: v12435.localM || v12436.localM,
        src: "weapons/" + v12435.src + (v12436.mid == null ? "" : "_" + v12436.mid),
        texSrc: v12436.mid == null ? v12436.tex ? v12436.tex : v12436 && v12436.id != null ? "weapons/skins/" + v12435.src + "_" + v12436.id : null : UTILS.getReModel(game.store, v12436),
        tFilter: THREE.LinearFilter,
        frames: v12436.frames,
        frameT: v12436.frameT,
        pulsT: v12436.pulsT,
        minGlo: v12436.minGlo,
        rotT: v12436.rotT,
        movT: v12436.movT,
        movE: v12436.movE,
        movD: v12436.movD,
        repeatY: v12436.tileS || 0,
        repeatX: v12436.tileS || 0,
        sameEnv: v12436.sameEnv,
        env: v12436.env || v12436.sameEnv ? v12436.env || 3 : undefined,
        noGroup: true,
        uv2: true,
        shininess: v12435.shine || 60,
        specular: 2697513,
        shadowsR: true,
        transparent: v12436.opac != null || v12435.seeThrough || v12436.trans,
        sameGlow: v12436.sameGlow,
        glowText: v12436.glow || v12436.sameGlow,
        emissive: (v12435.transp || v12436.glow || v12436.sameGlow) && !v12436.noEmis ? v12436.emiss || "#ffffff" : null,
        emissInt: v12436.glowInt,
        rgb: v12436.rgb,
        rgbS: v12436.rgbS,
        rgbT: v12436.rgbT,
        useWireframe: v12436.wire,
        side: v12435.side || v12436.side || 0,
        opacity: v12436.opac || 1,
        shaderNum: v12436.shaderNum,
        video: v12436.video,
        projection: v12436.projection,
        color: v12436.color || null,
        alphaTest: v12436.alpha || 0,
        normal: v12436.normal || null,
        spec: v12436.spec || null,
        metalness: v12436.metalness || null,
        roughness: v12436.roughness || null,
        displacement: v12436.displacement || null,
        bump: v12436.bump || null,
        outlineMesh: v12436.outline == null ? undefined : v12436.outline,
        outlineScale: v12436.outlineS ? v12436.outlineS : undefined
      }, machine.meshRef.position.x, machine.meshRef.position.y, machine.meshRef.position.z, [machine.xR, machine.yR + Math.PI / 2, machine.zR], (v12436.mScl || v12435.scale) * 1.5, RENDER.scene);
      machine.wepMesh.visible = true;
      machine.wepMesh.weaponId = v12434;
      machine.wepMesh.stage = stage;
    }
    if (machine.wepMesh) {
      machine.wepMesh.visible = progress >= 0.7 || progress <= 0.3;
    }
  };
  this.updateKrumMachines = function (isServer, playerPos, delta) {
    for (var vLN02155 = 0; vLN02155 < game.map.manager.krumMachines.length; ++vLN02155) {
      v12286 = game.map.manager.krumMachines[vLN02155];
      if (v12286) {
        if (isServer || !v12286.meshRef) {
          if (isServer && v12286.active && v12286.state >= 1) {
            v12286.timer -= delta;
            if (v12286.timer <= 0) {
              v12286.state++;
              v12286.timer = v12286.state == 2 ? config.krumMachineDespawn : config.krumMachineAnim;
              if (v12286.state >= 3) {
                v12286.state = 0;
                v12286.timer = 0;
                v12286.purchasedBy = undefined;
                v12286.pendingWeapon == null;
              }
              game.syncKrumMachine(v12286);
            }
          }
        } else if (v12286.state >= 1) {
          v12286.timer -= delta;
          if (v12286.state == 1) {
            var v12437 = v12286.timer / config.krumMachineAnim;
            var v12438 = config.krumMachineOffset * (v12437 <= 0.5 ? 1 - v12437 : v12437);
            var v12439 = v12438 * Math.sin(-v12286.yR + Math.PI / 2);
            var v12440 = v12438 * Math.cos(-v12286.yR + Math.PI / 2);
            game.changeKrumWeapon(v12286, v12437 <= 0.5 ? 1 : 0, v12437);
            RENDER.moveMesh(v12286.wepMesh, v12286.meshRef.position.x - v12439, v12286.meshRef.position.y - v12286.height / 4, v12286.meshRef.position.z - v12440);
          }
          if (v12286.timer <= 0) {
            v12286.state++;
            v12286.timer = v12286.state == 2 ? config.krumMachineDespawn : config.krumMachineAnim;
            if (v12286.state >= 3) {
              v12286.state = 0;
              v12286.purchasedBy = undefined;
              v12286.pendingWeapon == null;
              if (v12286.wepMesh) {
                v12286.wepMesh.visible = false;
              }
            }
          }
        }
      }
    }
  };
  this.updateKrumMachine = function (uid, active, state, timer, pendingWeapon, purchasedBy) {
    for (var vLN02156 = 0; vLN02156 < game.map.manager.krumMachines.length; ++vLN02156) {
      v12286 = game.map.manager.krumMachines[vLN02156];
      if (v12286 && v12286.uid == uid) {
        v12286.active = !!active;
        v12286.purchasedBy = purchasedBy;
        v12286.pendingWeapon = pendingWeapon;
        v12286.timer = timer;
        v12286.state = state;
        if (RENDER && v12286.meshRef != null) {
          v12286.meshRef.visible = !!v12286.active;
        }
        if (RENDER && v12286.wepMesh != null) {
          v12286.wepMesh.visible = !!v12286.active && !!(state >= 1);
        }
        if (RENDER && v12286.beamMesh != null) {
          v12286.beamMesh.visible = !!v12286.active;
        }
        if (RENDER && v12286.state == 1) {
          var v12441 = v12286.timer / config.krumMachineAnim;
          var v12442 = config.krumMachineOffset * (v12441 <= 0.5 ? 1 - v12441 : v12441);
          var v12443 = v12442 * Math.sin(-v12286.yR + Math.PI / 2);
          var v12444 = v12442 * Math.cos(-v12286.yR + Math.PI / 2);
          game.changeKrumWeapon(v12286, v12441 <= 0.5 ? 1 : 0, v12441);
          RENDER.moveMesh(v12286.wepMesh, v12286.meshRef.position.x - v12443, v12286.meshRef.position.y - v12286.height / 4, v12286.meshRef.position.z - v12444);
        }
        return;
      }
    }
  };
  this.syncKrumMachine = function (machine) {
    game.broadcast("krm", machine.uid, machine.active, machine.state, machine.timer, machine.pendingWeapon, machine.purchasedBy);
  };
  this.resetKrumMachines = function () {
    if (game.map.manager.krumMachines && game.map.manager.krumMachines.length) {
      for (var vLN02157 = 0; vLN02157 < game.map.manager.krumMachines.length; ++vLN02157) {
        v12286 = game.map.manager.krumMachines[vLN02157];
        if (v12286) {
          v12286.active = true;
          v12286.purchasedBy = undefined;
          v12286.pendingWeapon = undefined;
          v12286.timer = 0;
          v12286.state = 0;
          if (RENDER && v12286.meshRef != null) {
            v12286.meshRef.visible = !!v12286.active;
          }
          if (RENDER && v12286.wepMesh != null) {
            v12286.wepMesh.visible = false;
          }
          if (RENDER && v12286.beamMesh != null) {
            v12286.beamMesh.visible = !!v12286.active;
          }
        }
      }
    }
  };
  this.updatePickup = function (uid, pickup, orgPickup, active, pos, pickupAmmo) {
    var v12445 = !!this.mode && !!this.mode.site;
    v12286 = this.map.manager.findByUid(uid, this.map.manager.pickups);
    if (v12286) {
      if (RENDER) {
        v12287 = v12286.meshRef;
        var v12446 = pos ? pos : [v12287.position.x, v12287.position.y, v12287.position.z];
        RENDER.scene.remove(v12286.meshRef);
        var v12447 = this.weaponConfig[pickup || 0];
        var v12448 = v12447.altSkin || {};
        let v12449 = this.map.manager.genWeaponMeshData(v12447, this.store, v12448);
        if (v12286.noTex) {
          v12449.noTex = true;
        }
        v12286.meshRef = RENDER.loadMesh(v12449, ...v12446, 0, (v12448.mScl || v12447.scale) * (v12447.equipment ? 2 : 1), RENDER.scene);
        v12286.meshRef.rotation.copy(v12287.rotation.clone());
        v12286.meshRef.visible = (!v12447 || !v12447.bomb || !!v12445) && pickup != null;
      }
      var v12450 = UTILS.isNumber(orgPickup);
      v12286.pickupAmmo = UTILS.isNumber(pickupAmmo) ? pickupAmmo : this.weaponConfig[pickup || 0].ammo;
      if (pos || v12450) {
        v12286.x = pos ? pos[0] : v12286.orgX;
        v12286.y = pos ? pos[1] : v12286.orgY;
        v12286.z = pos ? pos[2] : v12286.orgZ;
      }
      if (v12450) {
        v12286.orgPickup = orgPickup;
      }
      v12286.pickup = pickup;
      v12286.active = active;
    }
  };
  this.resetPickups = function () {
    var vO392 = {};
    var v12451 = !!game.mode && !!game.mode.site;
    for (var vLN02158 = 0; vLN02158 < game.map.manager.pickups.length; ++vLN02158) {
      v12286 = game.map.manager.pickups[vLN02158];
      if (game.isServer && v12286.pickupRand) {
        var v12452 = UTILS.getRandom(game.weapons.onlyWeapons);
        if (v12286.pickupRandGroup) {
          if (vO392[v12286.pickupRandGroup] == null) {
            vO392[v12286.pickupRandGroup] = v12452;
          } else {
            v12452 = vO392[v12286.pickupRandGroup];
          }
        }
        v12286.orgPickup = v12452;
      }
      v12286.pickup = v12286.orgPickup;
      v12286.pickupAmmo = game.weaponConfig[v12286.pickup || 0].ammo;
      v12286.x = v12286.orgX;
      v12286.y = v12286.orgY;
      v12286.z = v12286.orgZ;
      v12286.active = !game.weaponConfig[v12286.pickup] || !game.weaponConfig[v12286.pickup].bomb || !!v12451;
      if (RENDER) {
        v12287 = v12286.meshRef;
        RENDER.scene.remove(v12286.meshRef);
        var v12453 = game.weaponConfig[v12286.pickup];
        var v12454 = v12453.altSkin || {};
        let v12455 = game.map.manager.genWeaponMeshData(v12453, this.store, v12454);
        if (v12286.noTex) {
          v12455.noTex = true;
        }
        v12286.meshRef = RENDER.loadMesh(v12455, v12286.x, v12286.y - config.pickupZoneH / 2 + config.pickupOff, v12286.z, 0, v12454.mScl || v12453.scale, RENDER.scene);
        v12286.meshRef.rotation.copy(v12287.rotation.clone());
        v12286.meshRef.visible = !v12453 || !v12453.bomb || !!v12451;
      }
    }
  };
  this.activeAIs = function (team) {
    var v12456;
    var vLN02159 = 0;
    for (var vLN02160 = 0; vLN02160 < this.AI.ais.length; ++vLN02160) {
      v12456 = this.AI.ais[vLN02160];
      if (v12456 && v12456.active && (!team || team == v12456.team || v12456.forceTeamTimer)) {
        vLN02159++;
      }
    }
    return vLN02159;
  };
  this.findFurthestFrom = function (from, x, y, z, team, maxDist, ignoreCanSee, includeAIs, includePlayers) {
    var v12457;
    var v12458 = null;
    for (var v12459 = includePlayers ? this.players.list.length : 0, vLN02161 = 0; vLN02161 < v12459 + (includeAIs ? this.AI.ais.length : 0); ++vLN02161) {
      v12457 = vLN02161 < v12459 ? this.players.list[vLN02161] : this.AI.ais[vLN02161 - v12459];
      if (v12457.active && v12457 != from) {
        var v12460 = UTILS.getD3D(x, y, z, v12457.x, v12457.y, v12457.z);
        if (!!(v12460 <= maxDist) && (!v12458 || !!(v12458.ds < v12460)) && (!!ignoreCanSee || !this.canSee(v12457, x, y, z, 0, 0, true)) && (!team || team != v12457.team)) {
          v12458 = {
            obj: v12457,
            ds: v12460
          };
        }
      }
    }
    if (v12458) {
      return v12458.obj;
    } else {
      return null;
    }
  };
  this.findNearestTo = function (from, x, y, z, team, maxDist, ignoreCanSee, includeAIs, includePlayers, noBots, exclude) {
    var v12461;
    var v12462 = null;
    for (var v12463 = includePlayers ? this.players.list.length : 0, vLN02162 = 0; vLN02162 < v12463 + (includeAIs ? this.AI.ais.length : 0); ++vLN02162) {
      v12461 = vLN02162 < v12463 ? this.players.list[vLN02162] : this.AI.ais[vLN02162 - v12463];
      if (v12461.active && v12461 != from && (!noBots || !v12461.isBot) && (!exclude || !v12461.isPlayer || !exclude[v12461.id])) {
        var v12464 = UTILS.getD3D(x, y, z, v12461.x, v12461.y, v12461.z);
        if (!!(v12464 <= maxDist) && (!v12462 || !!(v12462.ds > v12464)) && (!!ignoreCanSee || !this.canSee(v12461, x, y, z, 0, 0, true)) && (!team || team != v12461.team)) {
          v12462 = {
            obj: v12461,
            ds: v12464
          };
        }
      }
    }
    if (v12462) {
      return v12462.obj;
    } else {
      return null;
    }
  };
  this.canSee = function (from, x, y, z, pad, vPad, includeTrans, returnNearest, includeRamp) {
    if (!from) {
      return false;
    }
    pad = pad || 0;
    var v12465;
    var v12466 = null;
    var v12467 = UTILS.getD3D(from.x, from.y, from.z, x, y, z);
    var v12468 = UTILS.getDir(from.z, from.x, z, x);
    var v12469 = UTILS.getDir(UTILS.getDistance(from.x, from.z, x, z), y, 0, from.y);
    var v12470 = 1 / (v12467 * Math.sin(v12468 - Math.PI) * Math.cos(v12469));
    var v12471 = 1 / (v12467 * Math.cos(v12468 - Math.PI) * Math.cos(v12469));
    var v12472 = 1 / (v12467 * Math.sin(v12469));
    var v12473 = from.y + (from.height || 0) - config.cameraHeight;
    var v12474 = vPad ? 0 : pad;
    for (var vLN02163 = 0; vLN02163 < this.map.manager.objects.length; ++vLN02163) {
      v12465 = this.map.manager.objects[vLN02163];
      if ((!v12465.noShoot || includeRamp && v12465.ramp) && !v12465.complexColl && v12465.active && (!v12465.transparent || includeTrans)) {
        var v12481 = 0;
        if (v12465.ramp) {
          var v12475 = Math.max(0, Math.min(1, UTILS.progressOnLine(v12465.ramp.sX, v12465.ramp.sZ, v12465.ramp.eX, v12465.ramp.eZ, from.x + from.scale * Math.cos(v12465.dir), from.z + from.scale * Math.sin(v12465.dir))));
          var v12476 = v12465.height;
          var v12477 = (v12465.height + 0.01) * v12475;
          var v12478 = v12465.y - v12476 + v12477;
          v12481 = UTILS.lineInRect(from.x, from.z, v12473, v12470, v12471, v12472, v12465.x - Math.max(0, v12465.width - pad), v12465.z - Math.max(0, v12465.length - pad), v12478 - Math.max(0, v12477 - v12474), v12465.x + Math.max(0, v12465.width - pad), v12465.z + Math.max(0, v12465.length - pad), v12478 + Math.max(0, v12477 - pad));
        } else {
          v12481 = UTILS.lineInRect(from.x, from.z, v12473, v12470, v12471, v12472, v12465.x - Math.max(0, v12465.width - pad), v12465.z - Math.max(0, v12465.length - pad), v12465.y - Math.max(0, v12465.height - v12474), v12465.x + Math.max(0, v12465.width - pad), v12465.z + Math.max(0, v12465.length - pad), v12465.y + Math.max(0, v12465.height - pad));
        }
        if (v12481 && v12481 < 1) {
          if (returnNearest) {
            if (v12466 == null || v12466 > v12481) {
              v12466 = v12481;
            }
          } else {
            return v12481;
          }
        }
      }
    }
    var v12479 = this.map.terrain;
    if (v12479) {
      var v12480 = v12479.raycast(from.x, -from.z, v12473, 1 / v12470, -1 / v12471, 1 / v12472);
      if (v12480) {
        var v12481 = UTILS.getD3D(from.x, from.y, from.z, v12480.x, v12480.z, -v12480.y);
        if (returnNearest) {
          if (v12466 == null || v12466 > v12481) {
            v12466 = v12481;
          }
        } else {
          return v12481;
        }
      }
    }
    return v12466;
  };
  this.increaseWeapon = function (player, opts) {
    v12286 = opts.wId == null ? [...player.loadout] : [opts.wId];
    v12286.length = 1;
    var v12482 = this.mode.weaponOrder.indexOf(v12286[0]);
    if (v12482 > -1) {
      if (v12286[0] == this.mode.weaponOrder[v12482 + 1]) {
        return;
      }
      v12286[0] = this.mode.weaponOrder[v12482 + 1] == null ? this.mode.weaponOrder[this.mode.weaponOrder.length - 1] : this.mode.weaponOrder[v12482 + 1];
      player.weaponTier = v12482 + 1;
    } else {
      v12286[0] = this.mode.weaponOrder[0];
      player.weaponTier = 0;
    }
    this.broadcast("inat", player.sid, v12286, 0, undefined, undefined, false);
    player.updateLoadout(this, 0, true, v12286);
  };
  this.decreaseWeapon = function (player) {
    v12286 = [...player.loadout];
    v12286.length = 1;
    player.weaponTier--;
    if (player.weaponTier < 0) {
      player.weaponTier = 0;
    } else {
      player.setbacks++;
    }
    v12286[0] = this.mode.weaponOrder[player.weaponTier];
    this.broadcast("inat", player.sid, v12286, 0, undefined, undefined, false);
    player.updateLoadout(this, 0, true, v12286);
  };
  this.resetGates = function () {
    for (var vLN02165 = 0; vLN02165 < game.map.manager.gates.length; ++vLN02165) {
      v12286 = game.map.manager.gates[vLN02165];
      v12286.active = !v12286.startClosed;
      if (RENDER && v12286.meshRef != null) {
        v12286.meshRef.visible = v12286.active;
      }
    }
  };
  this.updateBank = function (uid, deposited) {
    for (var vLN02166 = 0; vLN02166 < game.map.manager.banks.length; ++vLN02166) {
      v12286 = game.map.manager.banks[vLN02166];
      if (v12286.uid == uid) {
        v12286.deposited = deposited || 0;
        break;
      }
    }
  };
  this.resetBanks = function () {
    for (var vLN02167 = 0; vLN02167 < game.map.manager.banks.length; ++vLN02167) {
      v12286 = game.map.manager.banks[vLN02167];
      v12286.deposited = 0;
    }
  };
  this.updateGate = function (uid, active) {
    for (var vLN02168 = 0; vLN02168 < game.map.manager.gates.length; ++vLN02168) {
      v12286 = game.map.manager.gates[vLN02168];
      if (v12286.uid == uid) {
        v12286.active = active;
        if (RENDER && v12286.meshRef != null) {
          v12286.meshRef.visible = active;
        }
        if (RENDER) {
          RENDER.updateShadowMap();
        }
        break;
      }
    }
  };
  this.updateObjPos = function (obj, x, y, z) {
    obj.x = x;
    obj.y = y;
    obj.z = z;
    obj.img.x = x;
    obj.img.y = y;
    obj.img.z = z;
    game.syncFlag(obj);
  };
  this.updateZone = function (val) {
    game.map.zone.update(0, val);
  };
  this.resetZone = function () {
    if (game.map.zone) {
      game.map.zone.reset();
    }
  };
  this.setObjective = function (uid, time) {
    try {
      game.activeObjective = uid;
      game.objtvTime = time;
      for (var vLN02169 = 0; vLN02169 < game.map.manager.objectives.length; ++vLN02169) {
        game.map.manager.objectives[vLN02169].mesh.visible = uid == game.map.manager.objectives[vLN02169].uid;
        game.map.manager.objectives[vLN02169].mesh.material.depthTest = true;
        game.map.manager.objectives[vLN02169].onZone = 0;
      }
    } catch (e165) {}
  };
  this.randObjective = function (time, push) {
    var v12483 = UTILS.getRandom(this.map.manager.objectives);
    var v12484 = v12483 ? v12483.uid : 0;
    game.nextObjective(time, push, v12484);
  };
  this.getNextObjective = function (forceUid) {
    var v12485 = this.activeObjective;
    var v12486 = this.map.manager.objectives.find(o => o && o.uid == (forceUid == null ? v12485 + 1 : forceUid));
    var v12487 = v12486 ? v12486.uid : 0;
    return v12487;
  };
  this.nextObjective = function (time, push, forceUid) {
    this.activeObjective = this.getNextObjective(forceUid);
    this.objtvTime = Math.max(1, (game.config.objtvTime || 1) * 60000 - (time || 0));
    this.broadcast("obj", this.activeObjective, this.objtvTime, time == null);
    if (this.map.manager.objectives.length > 1) {
      var vO393 = {
        time: Math.max(1, (game.config.objtvTime || 1) * 60000 - (time || 0)),
        contTime: true,
        canDMG: true,
        msg: "next objective ",
        trigger: function (game, time) {
          if (forceUid == null) {
            game.nextObjective(time);
          } else {
            game.randObjective(time);
          }
        }
      };
      if (push && this.waitTimers) {
        this.waitTimers.push(vO393);
      } else {
        this.waitTimers = [vO393];
      }
    }
    this.multiObjectTrigger("onObjectiveSwitch");
  };
  this.updateObjective = function (uid, onZone) {
    for (var vLN02170 = 0; vLN02170 < game.map.manager.objectives.length; ++vLN02170) {
      if (game.map.manager.objectives[vLN02170].uid == uid) {
        game.map.manager.objectives[vLN02170].onZone = onZone;
      }
    }
  };
  this.updateObjectiveTime = function (delta) {
    game.objtvTime -= delta;
    if (game.objtvTime <= 0) {
      game.objtvTime = 0;
    }
    return;
  };
  this.setWeapon = function (weapon) {
    try {
      game.activeObjective = weapon;
    } catch (e166) {}
  };
  this.nextWeapon = function (time, push) {
    this.activeObjective = UTILS.getRandom(this.weapons.onlyGoodWeapons);
    for (var vLN02171 = 0; vLN02171 < this.players.list.length; ++vLN02171) {
      if (!this.players.list[vLN02171].spectating) {
        this.players.list[vLN02171].updateLoadout(this, 0, true, [this.activeObjective]);
      }
    }
    this.broadcast("inatA", [this.activeObjective], 0);
    this.broadcast("wep", this.activeObjective);
    var vO394 = {
      time: 20000 - (time || 0),
      contTime: true,
      canDMG: true,
      msg: "next weapon in ",
      trigger: function (game, time) {
        game.nextWeapon(time);
      }
    };
    if (push && this.waitTimers) {
      this.waitTimers.push(vO394);
    } else {
      this.waitTimers = [vO394];
    }
  };
  this.nextTaunt = function (time, push, noTaunt) {
    if (!noTaunt) {
      for (var vLN02172 = 0; vLN02172 < this.players.list.length; ++vLN02172) {
        if (this.players.list[vLN02172].active && this.mode.teamOptions && this.mode.teamOptions[this.players.list[vLN02172].team - 1] == "Prop") {
          this.players.taunt(this.players.list[vLN02172], UTILS.randInt(0, config.taunts.length - 1), true);
        }
      }
    }
    var vO395 = {
      time: 20000 - (time || 0),
      contTime: true,
      canDMG: true,
      msg: "next taunt in ",
      trigger: function (game, time) {
        game.nextTaunt(time);
      }
    };
    if (push && this.waitTimers) {
      this.waitTimers.push(vO395);
    } else {
      this.waitTimers = [vO395];
    }
  };
  this.logTime = function (time, zoneIndex) {
    if (game.doLogTime) {
      var v12488 = document.getElementById("spdRunIVal" + zoneIndex);
      if (v12488) {
        v12488.innerHTML = UTILS.getTime(time, true, parseInt(time) >= 3600000, 1000, parseInt(time) >= 86400000, 2);
      }
      v12488 = document.getElementById("spdrnZC");
      if (v12488) {
        v12488.innerHTML = zoneIndex;
      }
      if (zoneIndex >= config.maxSpdRChck) {
        var v12489 = zoneIndex + 1;
        if (v12489 < game.map.manager.scorezones.length) {
          var v12490 = Math.max(0, zoneIndex - config.maxSpdRChck) + 1;
          v12488 = document.getElementById("spdRunI" + v12490);
          if (v12488) {
            speedRunList.removeChild(v12488);
          }
          speedRunList.innerHTML += "<div class='speedRunItem' id='spdRunI" + v12489 + "'>Point " + v12489 + "<span class='speedRunITim' id='spdRunIVal" + v12489 + "'>0:00</span></div>";
        }
      }
      v12488 = document.getElementById("spdRunI" + (zoneIndex + 1));
      if (v12488) {
        v12488.className = "speedRunItem sriAct";
        v12488 = document.getElementById("spdRunI" + zoneIndex);
        if (v12488) {
          v12488.className = "speedRunItem";
        }
      }
    }
  };
  this.setCheckPoint = function (player, obj) {
    if ((!player.checkPoint || player.checkPoint != obj.uid) && game.teamCheck(obj, player)) {
      if (obj.singleUse) {
        if (player.checkPointList.indexOf(obj.uid) > -1) {
          return;
        }
        player.checkPointList.push(obj.uid);
      }
      player.checkPoint = obj.uid;
      player.checkPointData = [player.timeLog, player.gameTime];
      if (game.isServer) {
        player.send("chp");
      }
    }
  };
  this.checkTeleport = function (player, obj) {
    if (obj.node != 1 && !(obj.telCooldown > 0) && game.teamCheck(obj, player)) {
      if (obj.telCheckPoint) {
        v12286 = game.map.manager.objects[player.checkPoint];
        if (player.checkPoint != null && v12286) {
          game.players.changePosition(player, v12286.x, v12286.y - v12286.height + 0.01, v12286.z, false, obj.telStopMo, obj.forceDir ? v12286.dir : undefined);
        }
        return;
      }
      for (var vLN02173 = 0; vLN02173 < this.map.manager.teleporters.length; ++vLN02173) {
        v12286 = this.map.manager.teleporters[vLN02173];
        if (v12286.channel == obj.channel && v12286.node > 0 && obj.uid != v12286.uid && game.teamCheck(v12286, player)) {
          if (v12286.node == 2) {
            v12286.telCooldown = 2000;
          }
          game.players.changePosition(player, v12286.x, v12286.y - v12286.height, v12286.z, false, v12286.telStopMo, v12286.forceDir ? v12286.dir : undefined);
          break;
        }
      }
    }
  };
  this.updateTeleporters = function (delta) {
    if (game.map.manager.teleporters.length) {
      for (var vLN02174 = 0; vLN02174 < game.map.manager.teleporters.length; ++vLN02174) {
        v12286 = game.map.manager.teleporters[vLN02174];
        v12286.telCooldown -= delta;
        if (v12286.telCooldown <= 0) {
          v12286.telCooldown = 0;
        }
      }
    }
  };
  this.updateSpinner = function (uid, randNum, itemID) {
    if (game.map.manager.spinners.length) {
      for (var vLN02175 = 0; vLN02175 < game.map.manager.spinners.length; ++vLN02175) {
        v12286 = game.map.manager.spinners[vLN02175];
        if (v12286.uid == uid) {
          if (!serverIO && v12286.meshPrev) {
            v12286.meshPrev.remove(...v12286.meshPrev.children);
            RENDER.scene.remove(v12286.meshPrev);
            v12286.meshPrev = null;
          }
          v12286.spinInfo.endAnimTarget = 0;
          v12286.spinInfo.endAnimVal = 0;
          v12286.spinInfo.spinVal = Math.PI * 2 * (randNum / 100 + 13) + Math.PI / 2;
          v12286.spinInfo.tickCounter = 0;
          v12286.spinInfo.spinRotation = 0;
          v12286.spinInfo.bobAnim = 0;
          v12286.spinInfo.unObtainHue = 0;
          v12286.spinInfo.randNum = randNum;
          v12286.spinInfo.itemID = itemID;
          v12286.spinInfo.needsUpdate = true;
          break;
        }
      }
    }
  };
  var vLN06101 = 0.6;
  this.updateSpinners = function (delta) {
    if (game.map.manager.spinners.length) {
      for (var vLN02176 = 0; vLN02176 < game.map.manager.spinners.length; ++vLN02176) {
        v12287 = game.map.manager.spinners[vLN02176];
        if (serverIO || v12287 && v12287.meshRef && v12287.meshRef.canvas) {
          if (!v12287.spinInfo) {
            v12287.spinInfo = {
              endAnimTarget: 0,
              endAnimVal: 0,
              spinWhlMlt: 0,
              spinVal: 0,
              tickCounter: 0,
              spinRotation: 0,
              bobAnim: 0,
              unObtainHue: 0,
              randNum: 0,
              itemID: -1,
              needsUpdate: true
            };
          }
          var v12491 = game.store.skins[v12287.spinInfo.itemID];
          if (!serverIO) {
            var v12492 = game.store.wheels[v12287.wheel];
            var v12493 = v12287.meshRef.canvas;
            var v12494 = v12493.getContext("2d");
          }
          if (!serverIO && v12287.spinInfo.spinWhlMlt < 1) {
            v12287.spinInfo.spinWhlMlt += delta * 0.008;
            if (v12287.spinInfo.spinWhlMlt >= 1) {
              v12287.spinInfo.spinWhlMlt = 1;
            }
          }
          if (!serverIO && v12287.spinInfo.endAnimVal < v12287.spinInfo.endAnimTarget) {
            v12287.spinInfo.endAnimVal += delta * 0.4;
            if (v12287.spinInfo.endAnimVal >= v12287.spinInfo.endAnimTarget) {
              v12287.spinInfo.endAnimVal = v12287.spinInfo.endAnimTarget;
            }
          }
          if (v12287.spinInfo.spinRotation != v12287.spinInfo.spinVal && (v12287.spinInfo.spinRotation += (v12287.spinInfo.spinVal - v12287.spinInfo.spinRotation) * 0.05, v12287.spinInfo.tickCounter -= (v12287.spinInfo.spinVal - v12287.spinInfo.spinRotation) * 0.05, !serverIO && v12287.spinInfo.tickCounter <= 0 && (v12287.spinInfo.tickCounter += Math.PI / 1.5, SOUND.play3D("tick_0", v12287.meshRef.position.x, v12287.meshRef.position.y, v12287.meshRef.position.z, 0.2)), v12287.spinInfo.spinVal - v12287.spinInfo.spinRotation <= 0.002)) {
            if (serverIO) {
              if (v12491 && v12491.rarity >= rarities.EPIC) {
                game.broadcast("unbS", v12287.spinOwner, v12287.spinInfo.itemID, false);
              } else if (v12491) {
                serverIO.send(v12287.spinOwner, "unbS", v12287.spinOwner, v12287.spinInfo.itemID, false);
              }
            }
            v12287.spinInfo.spinRotation = v12287.spinInfo.spinVal;
            if (serverIO) {
              continue;
            }
            v12287.spinInfo.endAnimTarget = 100 - v12492.rarities[v12491.rarity];
            SOUND.play3D("reward", v12287.meshRef.position.x, v12287.meshRef.position.y, v12287.meshRef.position.z, 0.3);
            if (v12491.rarity >= rarities.RELIC) {
              SOUND.play3D("cheer_1", v12287.meshRef.position.x, v12287.meshRef.position.y, v12287.meshRef.position.z, 0.1);
            } else if (v12491.rarity >= rarities.RARE) {
              SOUND.play3D("cheer_0", v12287.meshRef.position.x, v12287.meshRef.position.y, v12287.meshRef.position.z, 0.1);
            }
            var v12495 = v12491.type ? v12491 : game.store.previews[v12491.weapon] || {};
            var v12496 = game.weapons[v12491.weapon - 1] || {};
            var v12497 = RENDER.genObj3D(0, 0, 0);
            v12497.position.copy(v12287.meshRef.position);
            v12497.rotateY(Math.PI - v12287.dir * Math.PI / 4);
            v12287.meshPrev = RENDER.genObj3D(0, 0, 0);
            v12497.add(v12287.meshPrev);
            v12287.meshPrev.scale.setScalar(v12287.width / 4);
            v12287.meshPrev.position.x = v12287.width / 8 * -5;
            v12287.meshPrev.position.y = 1 + (v12495.yOff || 0);
            v12287.meshPrev.position.z = v12495.xOff || 0;
            v12287.meshPrev.rotateX(v12491.type ? 0 : Math.PI / 11);
            v12287.meshPrev.rotateY(v12491 && (v12491.type == itemTypes.DYE || v12491.type == itemTypes.SPRAY) ? Math.PI / 2 : 0);
            v12287.meshPrev.orgXR = v12287.meshPrev.rotation.x;
            v12287.meshPrev.orgYP = v12287.meshPrev.position.y;
            if (v12491.type && v12491.type == itemTypes.DYE) {
              var v12498 = new Player(-1, this, game);
              v12498.sid = -1;
              v12498.init(0, 0, -6, "preview", false);
              v12498.skins = [-1, -1];
              v12498.dyeIndex = parseInt(v12287.spinInfo.itemID);
              v12498.setClass(game, 9, 2, true);
              game.players.swapWeapon(v12498, 0, true);
              game.players.generateMeshes(v12498, false, true);
              v12287.meshPrev.add(v12498.objInstances);
              v12498.swapTime = 0;
              v12498.weaponMeshes[0].visible = true;
              v12498.weaponGeos[0].visible = false;
              game.players.updateMshClient(v12498, true);
            } else if (v12491.type && v12491.type == itemTypes.SPRAY) {
              var v12499 = RENDER.createSpray(v12491);
              v12287.meshPrev.add(v12499);
              v12499.rotation.y = Math.PI;
            } else {
              RENDER[v12491.hasAnim ? "loadAnimMesh" : "loadMesh"]({
                fileExt: v12491.fileExt,
                hasAnim: v12491.hasAnim,
                animS: v12491.animS,
                inspectAnim: v12491.inspectAnim,
                local: v12491.local,
                localM: v12491.localM,
                src: game.store.types[v12491.assetType || v12491.type || 0] + (v12491.assetType || v12491.type ? v12491.id : v12491.weapon) + (v12491.mid == null ? "" : "_" + v12491.mid),
                texSrc: v12491.mid == null ? v12491.type && v12491.type == itemTypes.MELEE ? v12491.pat ? v12491.tex : "melee/melee_" + (v12491.id || 0) + (v12491.tex ? "_" + v12491.tex : "") : v12491.type ? v12491.tex ? game.store.types[v12491.assetType || v12491.type || 0] + v12491.id + "_" + v12491.tex : null : v12491.tex ? v12491.tex : "weapons/skins/weapon_" + v12491.weapon + "_" + v12491.id : UTILS.getReModel(game.store, v12491),
                rotT: v12491.rotT,
                movT: v12491.movT,
                movE: v12491.movE,
                pulsT: v12491.pulsT,
                repeatY: v12491.tileS || 0,
                repeatX: v12491.tileS || 0,
                frames: v12491.frames,
                frameT: v12491.frameT,
                sameEnv: v12491.sameEnv,
                env: v12491.env || v12491.sameEnv ? v12491.env || 3 : undefined,
                sameGlow: v12491.sameGlow,
                glowText: v12491.glow || v12491.sameGlow,
                emissive: v12491.glow || v12491.sameGlow ? "#ffffff" : null,
                rgb: v12491.rgb,
                rgbS: v12491.rgbS,
                rAnim: v12491.rAnim,
                rAnimA: v12491.rAnimA,
                rAnimT: v12491.rAnimT,
                rAnimM: v12491.rAnimM,
                useWireframe: v12491.wire,
                side: v12491.side || 0,
                opacity: v12491.opac || 1,
                shaderNum: v12491.shaderNum,
                video: v12491.video,
                projection: v12491.projection,
                itemID: v12287.spinInfo.itemID || 0,
                shininess: v12496.shine || 60,
                specular: 2697513,
                shadowsR: true,
                transparent: v12491.opac != null || v12491.trans || v12496.seeThrough || false,
                alphaTest: v12491.alpha || 0
              }, 0, 0, 0, v12491.type && v12491.type != itemTypes.MELEE ? Math.PI : Math.PI / 2, (v12491.spnScl || v12495.scl || 1) * 2, v12287.meshPrev);
            }
            RENDER.scene.add(v12497);
            if (v12491.rarity > rarities.CONTRABAND) {
              var vLN1163 = 1;
              RENDER.shake(vLN1163 * 0.14);
              var v12500 = new THREE.Vector3();
              var v12501 = v12287.meshPrev.getWorldPosition(v12500);
              SOUND.play3D("explosion", v12501.x, v12501.y, v12501.z, 1);
              PARTICLES.ExplosionManager.explodeAt(v12501.x, v12501.y, v12501.z, 80);
            }
          }
          if (!serverIO && (v12287.meshPrev && (v12287.spinInfo.bobAnim += delta * 0.0018, v12287.meshPrev.position.y = v12287.meshPrev.orgYP + Math.sin(v12287.spinInfo.bobAnim) * 0.55), v12287.spinInfo.needsUpdate)) {
            var v12502 = 1 - (v12287.spinInfo.endAnimTarget ? v12287.spinInfo.endAnimVal / v12287.spinInfo.endAnimTarget : 0);
            var v12503 = v12493.width / 2 * 0.95 * v12287.spinInfo.spinWhlMlt;
            v12494.fillStyle = "#fff";
            v12494.beginPath();
            v12494.arc(v12493.width / 2, v12493.height / 2, v12503, 0, Math.PI * 2);
            v12494.closePath();
            v12494.fill();
            var vLN02177 = 0;
            v12494.save(1);
            v12494.translate(v12493.width / 2, v12493.height / 2);
            if (v12287.spinInfo.endAnimTarget) {
              var vLN02178 = 0;
              for (var vLN02180 = 0; vLN02180 < game.store.rarities.length; vLN02180++) {
                if (v12491.rarity == vLN02180) {
                  vLN02178 += v12492.rarities[vLN02180] / 2;
                  break;
                } else {
                  vLN02178 += v12492.rarities[vLN02180];
                }
              }
              vLN02178 /= 100;
              vLN02178 = Math.PI * 2 * vLN02178 * (v12287.spinInfo.endAnimVal / v12287.spinInfo.endAnimTarget) % (Math.PI * 2);
              v12494.rotate(vLN02178 - Math.PI * (v12287.spinInfo.endAnimVal / v12287.spinInfo.endAnimTarget));
            }
            for (var vLN02180 = 0; vLN02180 < game.store.rarities.length; vLN02180++) {
              v12286 = game.store.rarities[vLN02180];
              v12494.fillStyle = v12286.color;
              v12494.beginPath();
              var v12504 = v12492.rarities[vLN02180];
              if (v12287.spinInfo.endAnimTarget) {
                if (v12491.rarity == vLN02180) {
                  v12504 += v12287.spinInfo.endAnimVal;
                } else {
                  v12504 -= v12287.spinInfo.endAnimVal * (v12492.rarities[vLN02180] / v12287.spinInfo.endAnimTarget);
                }
              }
              if (v12504 > 0) {
                v12494.moveTo(0, 0);
                v12494.arc(0, 0, v12503 * 0.95, vLN02177, vLN02177 + Math.PI * 2 * (v12504 / 100), false);
                v12494.lineTo(0, 0);
                v12494.fill();
              }
              vLN02177 += Math.PI * 2 * (v12504 / 100);
            }
            v12494.restore(-1);
            v12494.fillStyle = "#F44336";
            v12494.shadowColor = "black";
            v12494.shadowBlur = 20;
            v12494.save(1);
            v12494.translate(v12493.width / 2, v12493.height / 2);
            v12494.rotate(v12287.spinInfo.spinRotation);
            v12494.beginPath();
            var v12505 = v12503 * vLN06101 * 0 * 0.3;
            v12494.moveTo(0, (v12503 * vLN06101 * -1.2 - v12505) * v12502);
            v12494.lineTo(v12503 * vLN06101 * v12502, 0);
            v12494.lineTo(-(v12503 * vLN06101) * v12502, 0);
            v12494.closePath();
            v12494.fill();
            v12494.restore(-1);
            v12494.fillStyle = "#fff";
            v12494.beginPath();
            v12494.arc(v12493.width / 2, v12493.height / 2, v12503 * vLN06101, 0, Math.PI * 2);
            v12494.closePath();
            v12494.fill();
            if (!v12287.meshPrev) {
              v12494.save(1);
              v12494.fillStyle = "#F44336";
              v12494.beginPath();
              v12494.arc(v12493.width / 2, v12493.height / 2, v12503 * vLN06101 * 0.85, 0, Math.PI * 2);
              v12494.closePath();
              v12494.fill();
              v12494.restore(-1);
              v12494.save(1);
              v12494.translate(v12493.width / 2, v12493.height / 2);
              v12494.font = v12503 * vLN06101 * 0.3 + "px GameFont";
              v12494.textBaseline = "bottom";
              v12494.textAlign = "center";
              v12494.fillStyle = "#fff";
              v12494.fillText("SPIN", 0, 0 + v12503 * vLN06101 * 0.1);
              v12494.restore(-1);
              v12494.save(1);
              v12494.translate(v12493.width / 2, v12493.height / 2);
              v12494.globalAlpha = 0.7;
              v12494.font = v12503 * vLN06101 * 0.15 + "px GameFont";
              v12494.textBaseline = "top";
              v12494.textAlign = "center";
              v12494.fillStyle = "#fff";
              v12494.fillText("-" + v12492.price + " KR", 0, 0 + v12503 * vLN06101 * 0.25);
              v12494.restore(-1);
            }
            v12287.meshRef.material.map.needsUpdate = true;
            if (v12287.meshPrev && v12287.spinInfo.endAnimVal == v12287.spinInfo.endAnimTarget) {
              v12287.spinInfo.needsUpdate = false;
            }
            if (!v12287.meshPrev && v12287.spinInfo.itemID == -1 && v12287.spinInfo.spinWhlMlt == 1) {
              v12287.spinInfo.needsUpdate = false;
            }
          }
        }
      }
    }
  };
  this.updateDestructables = function (delta) {
    if (this.isServer && this.map.manager.destObjs.length) {
      for (var v12506 = this.map.manager.destObjs.length - 1; v12506 >= 0; --v12506) {
        v12286 = this.map.manager.objects[this.map.manager.destObjs[v12506]];
        if (v12286 && v12286.canRespawn) {
          if (!v12286.respawnT && v12286.respawnR) {
            v12286.respawnT = UTILS.randInt(1, 5000);
          }
          v12286.respawnT -= delta;
          if (v12286.respawnT <= 0) {
            this.map.manager.destObjs.splice(v12506, 1);
            v12286.active = true;
            v12286.destroyed = false;
            v12286.respawnT = v12286.respawnR ? 0 : v12286.respawnTStart;
            if (v12286.health != null) {
              v12286.health = v12286.startHealth;
            }
            this.broadcast("ro", v12286.uid);
            if (v12286 && v12286.onRespawn) {
              this.onTrigger(v12286.destroyedBy, v12286);
            }
            v12286.destroyedBy = null;
          }
        }
      }
    }
  };
  this.addSpray = function (id, sprayId, x, y, z, dir, rotX, rotY, dyeId) {
    var v12507 = game.store.skins[2482];
    if (game.store.skins[sprayId] && game.store.skins[sprayId].type == itemTypes.SPRAY) {
      v12507 = game.store.skins[sprayId];
    }
    RENDER.addSpray(id, sprayId, x, y, z, dir, rotX, rotY, v12507, game.store.skins[dyeId]);
  };
  this.voteMatch = function (id, voteId, type) {
    voteId += "";
    if (this.endData.vo) {
      this.endData.vo[id] = this.endData.vo[id] && this.endData.vo[id][0] == voteId ? null : [voteId, type];
      this.broadcast("mv", this.endData.vo, this.endData.mts);
    }
  };
  this.updateEventIndex = function () {
    if (serverIO) {
      this.eventIndex = 0;
      if (!this.hasHost() && !this.isCustom && !this.isOfficial && !this.isComp) {
        let now = Date.now();
        for (let vLN02181 = 0; vLN02181 < config.events.length; vLN02181++) {
          let v12509 = new Date(config.events[vLN02181].start).getTime();
          let v12510 = new Date(config.events[vLN02181].end).getTime();
          if (now >= v12509 && now <= v12510) {
            this.eventIndex = config.events[vLN02181].id;
            break;
          }
        }
      }
      if (this.forceEvent) {
        this.eventIndex = this.forceEvent;
        this.forceEvent = null;
      }
    }
  };
  var vA674 = [];
  this.init = function (mapIndex, modeIndex, eventIndex, mapDataExt, async) {
    this.initInProgress = true;
    this.players.clear();
    this.AI.reset();
    if (this.bots) {
      this.bots.reset();
    }
    this.airDrop.reset();
    this.teamFlags = [];
    this.teamScores = {};
    this.inOvertime = false;
    this.isEmptyLobby = true;
    this.teamRoundWins = null;
    this.teamRoundWinsF = null;
    this.forfeited = null;
    this.notWinnable = false;
    this.eventIndex = eventIndex;
    if (serverIO) {
      this.roundId = UTILS.generateUUID();
    }
    this.updateEventIndex();
    vA674.length = 0;
    var v12511 = null;
    if (this.endData.mts.length) {
      for (var vLN02184 = 0; vLN02184 < this.endData.mts.length; ++vLN02184) {
        vA674[vLN02184] = 0;
        if (this.endData.vo) {
          for (var v12512 in this.endData.vo) {
            if (this.endData.vo.hasOwnProperty(v12512) && this.endData.vo[v12512] && this.endData.mts[vLN02184] == this.endData.vo[v12512][0]) {
              vA674[vLN02184] += this.endData.vo[v12512][1];
            }
          }
        }
      }
      var vLN02183 = 0;
      var vA675 = [];
      for (var vLN02184 = 0; vLN02184 < vA674.length; ++vLN02184) {
        if (vA674[vLN02184] > vLN02183) {
          vLN02183 = vA674[vLN02184];
          vA675.length = 0;
          vA675.push(this.endData.mts[vLN02184]);
        } else if (vA674[vLN02184] == vLN02183) {
          vA675.push(this.endData.mts[vLN02184]);
        }
      }
      v12511 = vLN02183 == 0 ? UTILS.getRandom(this.endData.mts) : vA675[0] || null;
    }
    if (v12511 != null) {
      var v12513 = v12511.split(",");
      this.modeIndex = parseInt(v12513[0]);
      this.mapIndex = parseInt(v12513[1]);
    } else {
      this.modeIndex = modeIndex == null ? this.config.modes ? this.config.modes[UTILS.randInt(0, this.config.modes.length - 1)] : UTILS.randInt(0, 3) : modeIndex;
      this.mapIndex = mapIndex == null ? this.config.maps[UTILS.randInt(0, this.config.maps.length - 1)] : mapIndex;
    }
    this.mode = gameModes[this.modeIndex];
    if (serverIO) {
      var vO396 = {};
      if (this.mode && this.mode.sendR) {
        vO396.snf = this.mode.sendR;
      }
      if (this.sendRateOvr) {
        vO396.snf = this.sendRateOvr;
      }
      if (this.tickRateOvr) {
        vO396.tf = this.tickRateOvr;
      }
      this.applyNetworking(vO396);
    }
    this.isDoubleClassXP = !!this.isPubType() && UTILS.isDoubleClassXP();
    this.isDoubleXP = !!this.isPubType() && !!this.mode.doubleXP;
    if (this.map.maps && this.map.maps[this.mapIndex] && this.map.maps[this.mapIndex].gui && this.map.maps[this.mapIndex].gui.length) {
      this.customGUIs = UTILS.parseGUIs(this.map.maps[this.mapIndex].gui, true);
      this.customGUIs = this.customGUIs.sort((a, b) => (a.z || 0) - (b.z || 0));
      if (overlay) {
        overlay.generateUIS(this.customGUIs, this);
      }
    }
    if (async) {
      return this.map.asyncGenerate(this.mapIndex, this.modeIndex, this.eventIndex, mapDataExt, this.isCustom, this.isComp, !!serverIO).then(this.finishInit.bind(this, arguments));
    } else {
      this.map.generate(this.mapIndex, this.modeIndex, this.eventIndex, mapDataExt, this.isCustom, this.isComp, !!serverIO);
      this.finishInit();
      return Promise.resolve();
    }
  };
  this.finishInit = function () {
    if (!this.isDestroyed && this.map) {
      var v12514 = this.connectedClients <= 2 && this.isPubType() || this.isComp;
      this.map.manager.resetAll(v12514);
      this.removeBuilds();
      this.resetFlags();
      this.resetSpawnables();
      this.resetPickups();
      this.resetGates();
      this.resetMysteryBoxes();
      this.resetKrumMachines();
      this.resetBanks();
      this.resetZone();
      this.resetSites();
      this.resetDomZones();
      this.resetStreaks();
      this.activeBomb = null;
      this.eventTimer = 0;
      this.eventTriggered = false;
      this.oldGameTimer = 0;
      this.loadedSprays = {};
      this.triggerQueue.length = 0;
      this.playerSounds.length = 0;
      this.globalVals = {};
      this.flagTeam = null;
      this.flagCarrier = null;
      this.fireSaleTimer = 0;
      this.instaKillTimer = 0;
      this.doublePointsTimer = 0;
      this.map.manager.addPendingAIs(this.AI, v12514);
      if (serverIO && this.bots && (this.isSandbox || !config.isProd || this.isPubType())) {
        this.map.manager.addPendingBots(this.bots);
      }
      if (this.bots && this.isSandbox) {
        this.bots.spawnPersistent();
      }
      if (serverIO) {
        this.addPendingLeaderboards();
      }
      if (serverIO) {
        this.switchMysteryBox();
      }
      this.generateTriggerTypes();
      this.saveColls = this.triggerTypes.includes("onExitObject") || this.triggerTypes.includes("onEnterObject");
      this.forceSpawn = this.config.forceSpawn || this.mode.forceSpawn;
      this.flippedSpawns = false;
      this.minPlayers = this.config.minPlayers || this.mode.minPlayers;
      if (!this.minPlayers && (this.config.lives || this.mode.lives || 0)) {
        this.minPlayers = 2;
      }
      this.voteToKick = null;
      this.voteInitiators.length = 0;
      this.voteToForfeit = null;
      this.forfeitInitiators.length = 0;
      this.needAllTimer = this.afkTimeout || 300000;
      this.zoneTimer = 0;
      this.carpetBombTimer = 0;
      this.objectiveTimer = 0;
      this.objtvTime = 0;
      this.activeObjective = null;
      this.startTime = Date.now();
      this.gameTimer = this.mode.gameTime == null ? this.config.gameTime * 60000 : this.mode.gameTime;
      this.startedTimer = this.gameTimer;
      this.gameTimerP = this.mode.gameTime == null ? this.config.gameTime * 60000 : this.mode.gameTime;
      this.canOwnTime = !this.gameTimer;
      this.doLogTime = this.mode.logTime && this.config.logTim;
      this.lastTimer = 0;
      this.lastTimerW = 0;
      this.lastTimerNA = 0;
      this.roundCount = this.config.gamRounds - 1;
      this.bestOf = !!this.config.bstOfR;
      this.needWinner = !!this.config.noDraws;
      this.lockoutTimer = 0;
      this.waitTimers = null;
      if (this.mode.waitTimers) {
        this.waitTimers = [];
        for (var vLN02185 = 0; vLN02185 < this.mode.waitTimers.length; ++vLN02185) {
          this.waitTimers.push({
            time: this.mode.waitTimers[vLN02185].time,
            trigger: this.mode.waitTimers[vLN02185].trigger,
            noJoin: this.mode.waitTimers[vLN02185].noJoin,
            msg: this.mode.waitTimers[vLN02185].msg,
            noClear: this.mode.waitTimers[vLN02185].noClear,
            comp: this.mode.waitTimers[vLN02185].comp
          });
        }
      } else if ((this.config.lives || this.mode.lives || 0) && !this.config.warmupTime && !this.mode.warmupTime) {
        this.waitTimers = [{
          time: 12000,
          msg: "match starts in ",
          trigger: function (game) {
            for (var vLN02186 = 0; vLN02186 < game.players.list.length; ++vLN02186) {
              if (game.players.list[vLN02186].spectating) {
                game.players.list[vLN02186].lives = 0;
              }
            }
          }
        }];
      }
      if (this.config.warmupTime || this.mode.warmupTime) {
        if (!this.waitTimers) {
          this.waitTimers = [];
        }
        this.waitTimers.unshift({
          time: 5000,
          comp: !!game.isComp,
          getPop: function (time) {
            return time == "00:00" && !!game.mode && [game.mode.name, game.mode.sub || "Destroy the Enemy"];
          },
          getSnd: function (time) {
            for (var vLN55 = 5; vLN55 > 0; vLN55--) {
              if (time == "00:0" + vLN55) {
                return vLN55;
              }
            }
            return false;
          },
          msg: "match starting in ",
          trigger: function (game) {
            for (var vLN02187 = 0; vLN02187 < game.players.list.length; ++vLN02187) {
              if (game.players.list[vLN02187].spectating) {
                game.players.list[vLN02187].lives = 0;
              }
            }
            game.unlockMove();
          }
        });
        this.waitTimers.unshift({
          time: (this.config.warmupTime || this.mode.warmupTime) * 60000,
          msg: "warmup ends ",
          comp: !!game.isComp,
          trigger: function (game) {
            game.warmupReset();
            game.lockMove();
          }
        });
      }
      this.condition = this.mode.condition ? [...this.mode.condition] : null;
      if (this.config.lives || this.mode.lives || 0) {
        if (!this.condition) {
          this.condition = [];
          if (this.mode.teamOptions || !this.mode.teams) {
            this.condition.push(function (game) {
              var vLN02188 = 0;
              for (var vLN02189 = 0; vLN02189 < game.players.list.length; ++vLN02189) {
                if (game.players.list[vLN02189].lives > 0) {
                  vLN02188++;
                }
              }
              return vLN02188 > 1;
            });
          } else if (this.mode.multiTeam) {
            this.condition.push(function (game) {
              let vO397 = {};
              for (var vLN02190 = 0; vLN02190 < game.players.list.length; ++vLN02190) {
                if (game.players.list[vLN02190].lives > 0 && game.players.list[vLN02190].team) {
                  if (vO397[game.players.list[vLN02190].team] == null) {
                    vO397[game.players.list[vLN02190].team] = 0;
                  }
                  vO397[game.players.list[vLN02190].team]++;
                }
              }
              return Object.keys(vO397).length > 1;
            });
          } else {
            this.condition.push(function (game) {
              var vLN02191 = 0;
              var vLN02192 = 0;
              for (var vLN02193 = 0; vLN02193 < game.players.list.length; ++vLN02193) {
                if (game.players.list[vLN02193].lives > 0) {
                  if (game.players.list[vLN02193].team == 1) {
                    vLN02191++;
                  } else {
                    vLN02192++;
                  }
                }
              }
              return vLN02191 >= 1 && vLN02192 >= 1;
            });
          }
        }
        if (!this.winCondition) {
          if (this.mode.teamOptions || !this.mode.teams) {
            this.winCondition = function (game) {
              for (var vLN02194 = 0; vLN02194 < game.players.list.length; ++vLN02194) {
                if (game.players.list[vLN02194].lives > 0) {
                  return game.players.list[vLN02194];
                }
              }
              return null;
            };
          } else {
            this.winCondition = function (game) {
              for (var vLN02195 = 0; vLN02195 < game.players.list.length; ++vLN02195) {
                if (game.players.list[vLN02195].team && game.players.list[vLN02195].lives > 0) {
                  return game.players.list[vLN02195].team;
                }
              }
              return 1;
            };
          }
        }
      }
      this.scoreLimit = this.config.scoreLimit || this.mode.scoreLimit || 0;
      if (this.scoreLimit) {
        if (!this.condition) {
          this.condition = [];
        }
        if (this.mode.teamOptions || !this.mode.teams) {
          this.condition.push(function (game) {
            for (var vLN02196 = 0; vLN02196 < game.players.list.length; ++vLN02196) {
              if (game.players.list[vLN02196].score >= game.scoreLimit) {
                return 0;
              }
            }
            return 1;
          });
        } else {
          this.condition.push(function (game) {
            for (var v12515 in game.teamScores) {
              if (game.teamScores.hasOwnProperty(v12515) && game.teamScores[v12515] >= game.scoreLimit) {
                return 0;
              }
            }
            return 1;
          });
        }
      }
      this.kills = 0;
      if (game.isServer && this.mode.gameStart) {
        this.mode.gameStart(this);
      }
      this.multiObjectTrigger("onGameStart");
      if (SOUND) {
        SOUND.rate = 1;
        var v12516;
        var v12517 = this.mode.ambInd || this.map.maps[this.mapIndex].ambInd || 1;
        if (this.map.maps[this.mapIndex].ambIndC) {
          v12517 = this.map.maps[this.mapIndex].ambIndC;
          v12516 = true;
        }
        v12517 = parseInt(v12517);
        if (v12517 != this.lastAmbS) {
          if (this.lastAmbS != null) {
            SOUND.stop(this.lastAmbSC ? this.lastAmbS : "ambient_" + this.lastAmbS);
          }
          this.lastAmbS = v12517;
          this.lastAmbSC = v12516;
          SOUND.play(v12516 ? v12517 : "ambient_" + v12517, config.amvVols[v12517] || 0.12, true, 1, v12516);
        }
      }
      var v12518 = this.customMapData ? this.customMapData.id : 0;
      if (serverManager) {
        var vO398 = {};
        var vO399 = {
          data: vO398
        };
        vO399[mmProps.MAX_PLAYERS] = this.maxPlayers;
        vO399[mmProps.IS_PRIVATE] = this.private;
        vO399[mmProps.AUTO_SEEK] = !this.isCustom;
        vO398[serverProps.IS_CUSTOM] = this.isCustom ? 1 : 0;
        vO398[serverProps.MAP_ID] = v12518;
        vO398[serverProps.MODE_INDEX] = this.modeIndex || 0;
        vO398[serverProps.MAP_INDEX] = this.mapIndex || 0;
        vO398[serverProps.INFO] = this.getInfo();
        vO398[serverProps.VERSION] = version;
        if (this.config.promServ) {
          vO398[serverProps.PROMOTED_SERVER] = 1;
        }
        if (this.krRewards) {
          vO398[serverProps.KR_REWARDS] = 1;
        }
        if (this.passCode) {
          vO398[serverProps.PASSWORD] = 1;
        }
        if (this.isOfficial) {
          vO398[serverProps.OFFICIAL] = 1;
          vO398[serverProps.IS_CUSTOM] = 1;
          if (!this.isOfficial.canSeek) {
            vO399[mmProps.AUTO_SEEK] = false;
          }
          if (this.isOfficial.header) {
            vO398[serverProps.HEADER] = this.isOfficial.header + " - " + vO398[serverProps.INFO];
          }
          if (this.isOfficial.promo) {
            vO398[serverProps.PROMO] = 1;
          }
        }
        if (this.isDedicated) {
          vO398[serverProps.IS_DEDICATED] = 1;
          if (this.isDedicated.header) {
            vO398[serverProps.HEADER] = this.isDedicated.header;
          }
          if (this.isDedicated.promo) {
            vO398[serverProps.PROMO] = 1;
          }
        }
        vO399.gt = this.isCustom ? 0 : this.gameTimer / 1000;
        if (this.gameInstance) {
          this.gameInstance.update(vO399, true);
        } else {
          this.gameInstance = serverManager.createGame(serverPort, vO399);
          this.gameInstance.initiationPromise.then(() => {
            if (!this.isDestroyed) {
              this.updatedGameInstance = true;
              this.broadcast("inst-id", this.gameInstance.id);
            }
          });
          if (serverIO && !config.isProd) {
            var path = require("path");
            var fs = require("fs");
            var v12519 = path.join(process.cwd(), "dynamic/version.json");
            fs.watchFile(path.join(process.cwd(), "dynamic/version.json"), {
              interval: 100
            }, () => {
              try {
                vO398[serverProps.VERSION] = version = JSON.parse(fs.readFileSync(v12519, "utf-8"));
                if (this.gameInstance) {
                  this.gameInstance.update(vO399);
                }
              } catch (e167) {}
            });
          }
        }
      }
      if (this.mainScript && this.mainScript.start) {
        this.mainScript.start();
      }
      this.initInProgress = false;
      for (var v12520 of this.initQueue) {
        v12520();
      }
      this.initQueue.length = 0;
    }
  };
  this.addPendingLeaderboards = function () {
    if (this.customMapData && this.customMapData.n) {
      for (var vLN02197 = 0; vLN02197 < this.map.manager.pendingLeaders.length; vLN02197++) {
        v12286 = this.map.manager.pendingLeaders[vLN02197];
        this.leaderboard.generate(this.customMapData.n, v12286.data.leaderType, null, v12286.data.leaderOrder, vLN02197, v12286.data.leaderResults);
      }
    }
  };
  this.generateTriggerTypes = function () {
    this.triggerTypes.length = 0;
    let v12521 = triggers.events.map(ev => ev.name);
    for (var vLN02198 = 0; vLN02198 < this.map.manager.objects.length; ++vLN02198) {
      v12286 = this.map.manager.objects[vLN02198];
      if (v12286) {
        for (var vLN02199 = 0; vLN02199 < v12521.length; vLN02199++) {
          if (v12286[v12521[vLN02199]] && !this.triggerTypes.includes(v12521[vLN02199])) {
            this.triggerTypes.push(v12521[vLN02199]);
          }
        }
      }
    }
  };
  this.giveTeamScore = function (team, score) {
    if (game.teamScores[team]) {
      game.teamScores[team] += score;
    } else {
      game.teamScores[team] = score;
    }
    if (game.teamScoreUpd.indexOf(team) < 0) {
      game.teamScoreUpd.push(team);
    }
  };
  this.getTeamScores = function (roundWins) {
    var v12522 = null;
    if (this.mode && this.mode.teams && this.teamScores) {
      var v12523 = roundWins && this.teamRoundWins ? this.teamRoundWins : this.teamScores;
      v12522 = [];
      for (var v12524 in v12523) {
        v12522.push([parseInt(v12524), v12523[v12524] || 0, this.teamFlags[v12524] || null]);
      }
    }
    return v12522;
  };
  this.getSyncData = function () {
    var vO400 = {
      gor: 1,
      lockT: this.lockoutTimer,
      roundC: this.roundCount,
      zone: this.map.zone ? this.map.zone.getData() : 0,
      lck: this.moveLock ? 1 : 0,
      obj: [this.activeObjective, this.objtvTime],
      pwup: [this.instaKillTimer, this.fireSaleTimer, this.doublePointsTimer]
    };
    var vA676 = [];
    for (var vLN02208 = 0; vLN02208 < this.map.manager.flags.length; ++vLN02208) {
      v12286 = this.map.manager.flags[vLN02208];
      vA676.push([v12286.uid, v12286.x.round(1), v12286.y.round(1), v12286.z.round(1), v12286.carrier || 0, v12286.flagTimer]);
    }
    if (vA676.length) {
      vO400.flg = vA676;
    }
    var vA677 = [];
    for (var v12525 in this.map.manager.spawnables) {
      v12286 = this.map.manager.spawnables[v12525];
      vA677.push([v12286.i, v12286.sid, v12286.x.round(1), v12286.y.round(1), v12286.z.round(1), v12286.team, v12286.data]);
    }
    if (vA677.length) {
      vO400.spwns = vA677;
    }
    var vA678 = [];
    for (var v12526 in this.globalVals) {
      vA678.push(v12526, this.globalVals[v12526]);
    }
    if (vA678.length) {
      vO400.gbl = vA678;
    }
    var vA679 = [];
    for (var vLN02208 = 0; vLN02208 < this.map.manager.domzones.length; ++vLN02208) {
      v12286 = this.map.manager.domzones[vLN02208];
      vA679.push(v12286.uid, v12286.capturedBy);
    }
    if (vA679.length) {
      vO400.doms = vA679;
    }
    var vA680 = [];
    for (var vLN02208 = 0; vLN02208 < this.map.manager.pickups.length; ++vLN02208) {
      v12286 = this.map.manager.pickups[vLN02208];
      vA680.push([v12286.uid, v12286.pickup, v12286.orgPickup || 0, v12286.active, [v12286.x, v12286.y, v12286.z]]);
    }
    if (vA680.length) {
      vO400.pkups = vA680;
    }
    var vA681 = [];
    for (var vLN02208 = 0; vLN02208 < this.map.manager.mysteryBoxes.length; ++vLN02208) {
      v12286 = this.map.manager.objects[this.map.manager.mysteryBoxes[vLN02208]];
      if (v12286) {
        vA681.push(v12286.uid, ~~v12286.active, v12286.state, v12286.timer, v12286.pendingWeapon, v12286.purchasedBy);
      }
    }
    if (vA681.length) {
      vO400.mybx = vA681;
    }
    var vA682 = [];
    for (var vLN02208 = 0; vLN02208 < this.map.manager.krumMachines.length; ++vLN02208) {
      v12286 = this.map.manager.krumMachines[vLN02208];
      if (v12286) {
        vA682.push(v12286.uid, ~~v12286.active, v12286.state, v12286.timer, v12286.pendingWeapon, v12286.purchasedBy);
      }
    }
    if (vA682.length) {
      vO400.krm = vA682;
    }
    var vA683 = [];
    for (var vLN02208 = 0; vLN02208 < this.map.manager.gates.length; ++vLN02208) {
      v12286 = this.map.manager.gates[vLN02208];
      vA683.push(v12286.uid, ~~v12286.active);
    }
    if (vA683.length) {
      vO400.gates = vA683;
    }
    var vA684 = [];
    for (var vLN02208 = 0; vLN02208 < this.map.manager.banks.length; ++vLN02208) {
      v12286 = this.map.manager.banks[vLN02208];
      vA684.push(v12286.uid, v12286.deposited);
    }
    if (vA684.length) {
      vO400.banks = vA684;
    }
    var vA685 = [];
    for (var vLN02208 = 0; vLN02208 < this.map.manager.objects.length; ++vLN02208) {
      v12286 = this.map.manager.objects[vLN02208];
      if (v12286.dynamic && v12286.active) {
        vA685.push([v12286.typeInd, v12286.x, v12286.y, v12286.z, (v12286.width || 0) * 2, (v12286.height || 0) * 2, (v12286.length || 0) * 2, 0, v12286.uid]);
      }
    }
    if (vA685.length) {
      vO400.dyno = vA685;
    }
    if (this.map.manager.destObjs.length) {
      vO400.dest = this.map.manager.destObjs;
    }
    if (this.map.manager.movedObjs.length) {
      vO400.mov = this.map.manager.movedObjs;
    }
    if (this.experimentalFeatures) {
      vO400.exf = true;
    }
    var vA686 = [];
    for (var vLN02208 = 0; vLN02208 < this.playerSounds.length; ++vLN02208) {
      vA686.push(this.playerSounds[vLN02208].sid, this.playerSounds[vLN02208].val, this.playerSounds[vLN02208].data);
    }
    if (vA686.length) {
      vO400.asnd = vA686;
    }
    return vO400;
  };
  this.addPlayerSound = function (sid, name, data) {
    var vO401 = {
      sid: sid,
      val: name,
      data: data
    };
    game.playerSounds.push(vO401);
    if (!serverIO) {
      var v12527 = game.players.findBySid(sid);
      vO401.obj = SOUND[data.loop ? "play3DL" : "play3D"](name, v12527 ? v12527.x : 0, v12527 ? v12527.y : 0, v12527 ? v12527.z : 0, data.vol, data.rate, undefined, undefined, undefined, undefined, true);
    } else {
      game.broadcast("asnd", sid, name, data);
    }
  };
  this.removePlayerSound = function (sid, name, force) {
    for (var v12528 = game.playerSounds.length - 1; v12528 >= 0; v12528--) {
      if ((force || game.playerSounds[v12528].val == name) && game.playerSounds[v12528].sid == sid) {
        var v12529 = game.playerSounds[v12528].obj;
        game.playerSounds.splice(v12528, 1);
        if (!serverIO) {
          if (v12529) {
            v12529[0].isPlaying = false;
            v12529[0].stopped = true;
            v12529[0].stop(v12529[1]);
          }
        } else {
          game.broadcast("rsnd", sid, name, force);
          if (!force) {
            return;
          }
        }
      }
    }
  };
  this.updatePlayerSounds = function () {
    if (!serverIO) {
      for (var vLN02209 = 0; vLN02209 < game.playerSounds.length; ++vLN02209) {
        var v12530 = game.playerSounds[vLN02209].obj;
        var v12531 = game.players.findBySid(game.playerSounds[vLN02209].sid);
        if (v12531 && v12530) {
          v12530[0].pos(v12531.x, v12531.y + v12531.height / 2, v12531.z, v12530[1]);
        }
      }
    }
  };
  this.triggerChains = {};
  this.onTrigger = function (player, obj, chain) {
    if (game.isServer && (obj.isAI || game.teamCheck(obj, player))) {
      var v12532 = obj.trigActions;
      if (!v12532 || !v12532.length) {
        return;
      }
      if (this.triggerChains[chain] <= 0) {
        return;
      }
      if (obj.singleUse && obj.triggered) {
        return;
      }
      if (obj.trigChance && !(UTILS.randInt(0, 100) <= obj.trigChance)) {
        return;
      }
      if (obj.singleUseP && player) {
        if (obj.uses.indexOf(player.id) > -1) {
          return;
        }
        obj.uses.push(player.id);
      }
      obj.triggered = true;
      if (chain == null) {
        chain = obj.uid;
        this.triggerChains[chain] = config.triggerLimit;
      }
      this.triggerChains[chain]--;
      if (!obj.trigActCost && !((obj.trigActM || 0) > 3)) {
        if (v12532 && v12532.length) {
          for (var vLN02212 = 0; vLN02212 < v12532.length; vLN02212++) {
            var v12537 = v12532[vLN02212];
            var v12538 = game.triggers && game.triggers.conditions[v12537.trigCond ? v12537.trigCond[0] || 0 : 0].check(game, serverIO, player, obj, v12537);
            if (v12538 && game.triggers && game.triggers.actions[v12537.trigAct || 0]) {
              if (v12537.trigDelay > 0) {
                game.triggerQueue.push({
                  action: v12537,
                  player: player,
                  obj: obj,
                  chain: chain,
                  timer: (v12537.trigDelay || 0) * 1000
                });
              } else {
                game.triggers.actions[v12537.trigAct || 0].execute(game, serverIO, player, obj, v12537, chain);
              }
            }
          }
        }
        if (obj.selfDestruct && game.triggers) {
          game.triggers.actions[24].execute(game, serverIO, player, obj, v12537, chain);
        }
      } else if ((obj.trigActM || 0) == 0) {
        if (!serverIO || !dbClient) {
          return;
        }
        if (!player.account) {
          return;
        }
        if (player.account.hack) {
          return;
        }
        if (!game.isCustom) {
          return;
        }
        if (!game.customMapData || !game.customMapData.id) {
          return;
        }
        if (!player.account.canUseKRTrigger) {
          player.send("ch", -1, null, "KR Triggers require more playtime", 2);
          return;
        }
        dbClient.call(138, [player.account.id, game.customMapData.id, obj.trigActCost || 0], function (err, result) {
          if (!err && (result = result && result[0] ? result[0][0] : null, err = result ? result.rsp : "Error occured.", result && result.rsp == "Success" && result.fds != null && result.fds != null && player && player.account)) {
            player.account.funds = result.fds || 0;
            player.send("uf", player.account.funds);
            player.send("am", ["Spent", "-" + (obj.trigActCost || 0) + " KR", 0, 1]);
            if (v12532 && v12532.length) {
              var v12535;
              for (var vLN02211 = 0; vLN02211 < v12532.length; vLN02211++) {
                v12535 = v12532[vLN02211];
                if (game.triggers && game.triggers.actions[v12535.trigAct || 0]) {
                  if (v12535.trigDelay > 0) {
                    game.triggerQueue.push({
                      action: v12535,
                      player: player,
                      obj: obj,
                      chain: chain,
                      timer: (v12535.trigDelay || 0) * 1000
                    });
                  } else {
                    game.triggers.actions[v12535.trigAct || 0].execute(game, serverIO, player, obj, v12535, chain);
                  }
                }
              }
            }
            if (obj.selfDestruct && game.triggers) {
              game.triggers.actions[24].execute(game, serverIO, player, obj, v12535, chain);
            }
          }
        });
      } else {
        var v12536 = obj.trigActM || 0;
        if (v12536 < 3 && player.score >= (obj.trigActCost || 0) || v12536 == 3 && player.kills >= (obj.trigActCost || 0) || v12536 == 4 && player.account || v12536 == 5 && player.account && player.account.featured || v12536 == 6 && player.account && player.account.premiumT || v12536 == 7 && player.account && player.account.partnerApp >= 2 || v12536 == 8 && player.account && (player.account.level || 0) >= (obj.trigActCost || 0)) {
          if ((obj.trigActCost || 0) != 0) {
            if (player) {
              player.send("am", [v12536 > 1 ? "Unlocked" : "Purchased", v12536 > 1 ? null : -(obj.trigActCost || 0), 0, 1]);
            }
            if (v12536 < 2) {
              this.players.score(player, -(obj.trigActCost || 0));
            }
          }
          if (v12532 && v12532.length) {
            for (var vLN02212 = 0; vLN02212 < v12532.length; vLN02212++) {
              var v12537 = v12532[vLN02212];
              var v12538 = game.triggers.conditions[v12537.trigCond ? v12537.trigCond[0] || 0 : 0].check(game, serverIO, player, obj, v12537);
              if (v12538 && game.triggers && game.triggers.actions[v12537.trigAct || 0]) {
                if (v12537.trigDelay > 0) {
                  game.triggerQueue.push({
                    action: v12537,
                    player: player,
                    obj: obj,
                    chain: chain,
                    timer: (v12537.trigDelay || 0) * 1000
                  });
                } else {
                  game.triggers.actions[v12537.trigAct || 0].execute(game, serverIO, player, obj, v12537, chain);
                }
              }
            }
          }
          if (obj.selfDestruct && game.triggers) {
            game.triggers.actions[24].execute(game, serverIO, player, obj, v12537, chain);
          }
        }
      }
    }
  };
  this.playerTrigger = function (eventName, player) {
    for (var vLN02213 = 0; vLN02213 < this.map.manager.playerObjs.length; ++vLN02213) {
      v12286 = this.map.manager.objects[this.map.manager.playerObjs[vLN02213]];
      if (v12286 && v12286.active && v12286[eventName]) {
        this.onTrigger(player, v12286);
      }
    }
  };
  this.objectTrigger = function (eventName, sid, player) {
    v12286 = this.map.manager.findBySid(sid);
    if (v12286 && v12286.active) {
      if (v12286[eventName]) {
        this.onTrigger(player, v12286);
      }
    }
  };
  this.multiObjectTrigger = function (eventName, player) {
    if (this.triggerTypes.includes(eventName)) {
      for (var vLN02214 = 0; vLN02214 < this.map.manager.objects.length; ++vLN02214) {
        v12286 = this.map.manager.objects[vLN02214];
        if (v12286 && v12286.active && v12286[eventName]) {
          this.onTrigger(player, v12286);
        }
      }
    }
  };
  this.getActionValue = function (player, obj, action, type, defaultVal) {
    if ((action.trigConstT || 0) == 0) {
      return defaultVal;
    }
    if (UTILS.isString(action.trigConstC) && action.trigConstC.length) {
      var v12539;
      if ((action.trigConstT || 0) == 1) {
        if (!obj) {
          return;
        }
        if (!obj.custVals) {
          return;
        }
        if (obj.custVals[action.trigConstC] == null) {
          return;
        }
        v12539 = obj.custVals[action.trigConstC];
      } else if ((action.trigConstT || 0) == 2) {
        if (!player) {
          return;
        }
        if (config.playerVals.indexOf(action.trigConstC) > -1) {
          if (player[action.trigConstC] == null) {
            return;
          }
          v12539 = player[action.trigConstC];
        } else {
          if (!player.custVals) {
            return;
          }
          if (player.custVals[action.trigConstC] == null) {
            return;
          }
          v12539 = player.custVals[action.trigConstC];
        }
      } else if ((action.trigConstT || 0) == 3) {
        if (!this.globalVals) {
          return;
        }
        if (this.globalVals[action.trigConstC] == null) {
          return;
        }
        v12539 = this.globalVals[action.trigConstC];
      }
      if (v12539 == null) {
        return undefined;
      } else if (type == "number") {
        return parseInt(v12539) || undefined;
      } else if (type == "float") {
        return parseFloat(v12539) || undefined;
      } else if (type == "string") {
        return v12539 + "";
      } else {
        return v12539;
      }
    }
  };
  this.foundEventItem = function (player, obj) {
    if (game.eventIndex == 3 && player && (this.isPubType() || player.account && player.account.isDev)) {
      var v12540 = obj.rare;
      if (!v12540) {
        player.send("4");
      }
      var v12541 = game.mapIndex + "-" + obj.uid;
      if (!player.account || player.tempEggs.indexOf(v12541) >= 0) {
        return;
      }
      player.tempEggs.push(v12541);
      dbClient.call(68, [1, player.account.id, v12541, 0, config.easterEggs], function (err, result) {
        if (!result || !result[0] || !result[0][0]) {
          player.send("chi", 0, null, ["event.easter.found.old"], 2, UTILS.getRandom(colors.easterPalette));
          return;
        }
        if (result[0][0].re == "success") {
          game.broadcast("chi", 0, null, ["event.easter.completed", player.fakeName || player.alias], 2, UTILS.getRandom(colors.easterPalette));
          game.challenges.update(game, "eggs", 10, null, player);
        } else if (result[0][0].cnt) {
          game.broadcast("chi", 0, null, ["event.easter.found.new", player.fakeName || player.alias, result[0][0].cnt, config.easterEggs], 2, UTILS.getRandom(colors.easterPalette));
          game.challenges.update(game, "eggs", 1, null, player);
        } else {
          player.send("chi", 0, null, ["event.easter.found.old"], 2, UTILS.getRandom(colors.easterPalette));
          return;
        }
      });
    }
  };
  this.getItemByChance = function (items) {
    var vA687 = [];
    var v12542 = UTILS.randFloat(0.0001, 100);
    var vLN02215 = 0;
    var vLN02216 = 0;
    for (var vLN02218 = 0; vLN02218 < game.store.rarities.length; ++vLN02218) {
      vLN02216 += game.store.lootRars[vLN02218] || 0;
      if (v12542 < vLN02216) {
        vLN02215 = vLN02218;
        break;
      }
    }
    for (var vLN02218 = 0; vLN02218 < items.length; ++vLN02218) {
      var vParseInt44 = parseInt(items[vLN02218]);
      var v12543 = game.store.skins[vParseInt44];
      if (vParseInt44 < 0) {
        for (var vLN02219 = 0; vLN02219 < -vParseInt44; ++vLN02219) {
          vA687.push(-1);
        }
      } else if (v12543 && v12543.rarity == vLN02215) {
        vA687.push(vParseInt44);
      }
    }
    var vParseInt45 = parseInt(vA687[UTILS.randInt(0, vA687.length - 1)]);
    return vParseInt45;
  };
  this.giveSkin = function (player, skinId, reason) {
    if (serverIO && game.store.skins[skinId] && player.account && !player.account.hack) {
      var v12544 = this.hasHost() || this.isDedicated || this.isCustom || this.isOfficial && !this.isOfficial.hasRewards;
      if (this.isOfficial && this.isOfficial.hasRewards) {
        v12544 = false;
      }
      if (!v12544 || !!this.mimicPubs) {
        this.sendUserSkin(reason || "raid", player, skinId);
      }
    }
  };
  this.dropSkin = function (player, skinId, reason, x, y, z) {
    if (serverIO && game.store.skins[skinId] && player.account && !player.account.hack) {
      var v12545 = this.hasHost() || this.isDedicated || this.isCustom || this.isOfficial && !this.isOfficial.hasRewards;
      if (this.isOfficial && this.isOfficial.hasRewards) {
        v12545 = false;
      }
      if (!v12545 || !!this.mimicPubs) {
        this.dropSpawnable(24, player, {
          itemId: skinId,
          reason: reason,
          xD: UTILS.toRad(UTILS.randInt(0, 360))
        }, {
          x: x + UTILS.randInt2(3, 8),
          y: y,
          z: z + UTILS.randInt2(3, 8)
        });
      }
    }
  };
  this.sendUserSkin = function (reason, player, skinId) {
    if (serverIO && player && player.account && !player.account.hack) {
      dbClient.call(176, [reason, player.account.id, 0, 0, skinId, config.currentBattlepass, 0], function (err, result) {
        result = result && result[0] && result[0][0] ? result[0][0] : null;
        if (player && player.account) {
          var v12546 = result && result.ski != null && result.ski != null ? result.ski.split(",") : [];
          if (v12546 && v12546.length) {
            for (var vLN02220 = 0; vLN02220 < v12546.length; vLN02220++) {
              v12546[vLN02220] = parseInt(v12546[vLN02220]);
              player.account.addSkin(v12546[vLN02220]);
              game.challenges.update(game, "find", 1, {
                item: v12546[vLN02220]
              }, player);
              game.broadcastEx(player.id, "skinF", player.id, v12546[vLN02220], false);
              player.send("skin", v12546[vLN02220]);
            }
          }
        }
      });
    }
  };
  this.sendUserJunk = function (reason, player, junk) {
    if (serverIO && player.account) {
      dbClient.call(176, [reason, player.account.id, 0, junk, "", config.currentBattlepass, 0], function (err, result) {
        result = result && result[0] && result[0][0] ? result[0][0] : null;
        if (player && player.account) {
          var v12547 = false;
          if (result && result.jnk != null && result.jnk != null) {
            v12547 = true;
            player.account.junk = parseFloat(result.jnk);
            player.send("jnk", player.account.junk, junk);
          }
        }
      });
    }
  };
  this.rewardKR = function (player, amount) {
    if (serverIO && player && player.account && !player.account.hack && game.isCustom && game.customMapData && game.customMapData && game.customMapData.id && !player.waitRew && UTILS.isNumber(amount)) {
      amount = Math.abs(amount);
      if (amount > 0) {
        player.waitRew = true;
        dbClient.call(137, [player.account.id, amount, game.customMapData.id], function (err, result) {
          if (!err) {
            result = result && result[0] ? result[0][0] : null;
            err = result ? result.rsp : "Error occured.";
            if (result && result.rsp == "Success" && result.fds != null && result.fds != null && player && player.account) {
              player.account.funds = result.fds || 0;
              player.send("uf", player.account.funds);
              player.send("ch", -1, null, "Rewarded " + amount + " KR", 2);
              player.send("am", ["Reward", amount + " KR", 0, 1]);
            }
          }
          if (player) {
            player.waitRew = false;
          }
        });
      }
    }
  };
  this.checkPlayerLimit = function () {
    var vA688 = [];
    var vLN02221 = 0;
    for (var v12548 = 0; v12548 < game.players.list.length; ++v12548) {
      if (!!game.players.list[v12548] && (!game.players.list[v12548] || !game.players.list[v12548].kpdData && !game.players.list[v12548].isBot)) {
        vLN02221++;
        if (vLN02221 > game.maxPlayers) {
          vA688.push(game.players.list[v12548]);
        }
      }
    }
    for (var v12548 = vA688.length - 1; v12548 >= 0; --v12548) {
      if (vA688[v12548]) {
        vA688[v12548].kicked = true;
        vA688[v12548].send("error", "Over player limit");
        if (serverIO.sockets[vA688[v12548].id]) {
          serverIO.sockets[vA688[v12548].id].close();
        }
      }
    }
  };
  this.checkBadges = function (player) {
    if (serverIO && player && player.account && !player.account.hack && game.isPubType()) {
      var vA689 = [];
      for (var vLN02223 = 0; vLN02223 < game.badges.length; vLN02223++) {
        if (player && player.account && !player.account.badges.includes(vLN02223) && game.badges[vLN02223].claimable && game.badges[vLN02223].req(player.account)) {
          player.account.badges.push(vLN02223);
          vA689.push(vLN02223);
          dbClient.call(181, [player.account.name, vLN02223, 1]);
        }
      }
      if (vA689.length) {
        player.send("nbdgr", vA689);
      }
    }
  };
  this.inProgress = function () {
    var v12549 = true;
    if (game.waitTimers && !game.waitTimers[0].contTime) {
      v12549 = false;
    }
    return v12549;
  };
  this.getWinTeam = function (useScores) {
    if (this.mode.teams && this.teamScores) {
      var vLN02224 = 0;
      var v12550 = null;
      var v12551 = false;
      var v12552 = this.teamRoundWins || this.teamScores;
      if (useScores) {
        v12552 = this.teamScores;
      }
      for (var v12553 in v12552) {
        if (v12552.hasOwnProperty(v12553) && v12552[v12553] >= vLN02224) {
          if (v12552[v12553] > vLN02224) {
            v12551 = true;
          } else if (v12552[v12553] == vLN02224) {
            v12551 = false;
          }
          vLN02224 = v12552[v12553];
          v12550 = v12553;
        }
      }
      if (vLN02224 == 0 || !v12551 && this.needWinner) {
        return 0;
      } else {
        return v12550 || 0;
      }
    }
    return 0;
  };
  this.prepareForfeit = function (team) {
    let v12554 = Math.ceil((game.bestOf || 1) / 2);
    game.teamRoundWinsF = {
      ...game.teamRoundWins
    };
    game.forfeited = true;
    game.teamScores = {};
    game.teamScores[team] = v12554;
    game.teamRoundWins = {};
    game.teamRoundWins[team] = v12554;
    game.roundCount = 0;
    game.endGame();
  };
  this.endGame = function (endIndex, winner, fast) {
    var v12555 = false;
    if (this.bestOf && endIndex == null) {
      var v12557 = game.getWinTeam(true);
      this.teamScores = {};
      this.broadcast("ts");
      this.leadersUpdated = true;
      this.inOvertime = false;
      this.notWinnable = false;
      if (v12557) {
        if (!this.teamRoundWins) {
          this.teamRoundWins = {};
        }
        this.teamRoundWins[v12557] = (this.teamRoundWins[v12557] || 0) + 1;
      } else if (this.needWinner && !this.endIndex) {
        this.inOvertime = true;
        this.broadcast("tx", "Overtime", "+60 Seconds");
        this.gameTimer = 60000;
        return;
      }
      v12555 = this.teamRoundWins[v12557] >= this.config.gamRounds / 2;
    }
    if (endIndex == null && this.roundCount > 0 && !v12555) {
      this.moveLock = true;
      for (var vLN02232 = 0; vLN02232 < this.players.list.length; ++vLN02232) {
        v12286 = this.players.list[vLN02232];
        if (v12286) {
          v12286.active = false;
          v12286.deathInfo = null;
        }
      }
      var v12557 = game.getWinTeam();
      this.roundCount--;
      this.broadcast("rds", this.roundCount, false, v12557, this.teamRoundWins);
      this.flippedSpawns = !this.flippedSpawns;
      if (this.mode && this.mode.objective && !this.mode.dom) {
        this.activeObjective = -1;
        this.objtvTime = 0;
        this.nextObjective(null);
      }
      if (!this.waitTimers) {
        this.waitTimers = [];
      }
      this.waitTimers.unshift({
        time: (game.config.intermTmr || 10) * 1000,
        comp: true,
        dontWait: true,
        getPop: function (time) {
          return time == "00:00" && !!game.mode && [game.mode.name, game.mode.sub || "Destroy the Enemy"];
        },
        getSnd: function (time) {
          for (var vLN56 = 5; vLN56 > 0; vLN56--) {
            if (time == "00:0" + vLN56) {
              return vLN56;
            }
          }
          return false;
        },
        msg: "intermission ",
        trigger: function (game) {
          game.unlockMove();
        }
      });
      this.gameTimer = this.startedTimer;
      return;
    }
    if (this.mode.endSort) {
      this.players.list.sort(this.mode.endSort);
    } else {
      this.players.list.sort(UTILS.orderByScore);
    }
    this.endIndex = endIndex == null ? null : endIndex;
    if (this.endIndex == null) {
      this.winner = this.mode.winCondition ? this.mode.winCondition(this) : this.mode.teams && this.teamScores ? this.getWinTeam() : this.mode.multiWinner ? this.players.list.slice(0, this.mode.multiWinner) : this.players.list[0];
    } else if (this.endIndex != 3) {
      if (this.endIndex == 4) {
        this.winner = winner || -1;
      }
    } else if (this.mode.teams && this.teamScores) {
      var vLN02226 = 0;
      var vLN02227 = 0;
      for (var vLN02232 = 0; vLN02232 < this.players.list.length; ++vLN02232) {
        v12286 = this.players.list[vLN02232];
        if (v12286.team == 1) {
          vLN02226++;
        } else {
          vLN02227++;
        }
      }
      this.winner = vLN02226 == vLN02227 ? null : vLN02226 > vLN02227 ? 1 : 2;
    } else {
      this.winner = this.players.list[0];
    }
    if (this.isPubType() && this.isEmptyLobby && !this.isSandbox) {
      this.winner = -1;
    }
    if (this.needWinner && !this.winner && !this.endIndex) {
      this.broadcast("tx", "Overtime", "+60 Seconds");
      this.gameTimer = 60000;
      return;
    }
    if (this.mode.onPreEnd) {
      this.mode.onPreEnd(this, serverIO, dbClient);
    }
    var v12558 = this.mode.multiWinner && Array.isArray(this.winner);
    for (var vLN02232 = 0; vLN02232 < this.players.list.length; ++vLN02232) {
      v12286 = this.players.list[vLN02232];
      v12286.didWin = v12286.team && v12286.team == this.winner || v12286 == this.winner || v12558 && this.winner.includes(v12286);
      if (v12286.didWin) {
        this.challenges.update(this, "w", 1, null, v12286);
      }
      this.challenges.update(this, "gp", 1, null, v12286);
      v12286.affectStats = false;
    }
    var v12559 = this.store.skins.find(skin => skin && skin.mapReward == this.mapIndex && skin.seas == config.currentSeason);
    if (this.isPubType() && this.endIndex == null) {
      var v12560 = this.config.gamRounds;
      for (var vLN02232 = 0; vLN02232 < this.players.list.length; ++vLN02232) {
        v12286 = this.players.list[vLN02232];
        v12286.reward = 0;
        v12286.tmpBPData = {
          bpp: 0,
          cbp: 0,
          gn: 0
        };
        if (battlePass && battlePass.data) {
          v12286.tmpBPData.mx = battlePass.data.bpp_perlevel;
          v12286.tmpBPData.id = battlePass.data.id;
          v12286.tmpBPData.ml = battlePass.data.itemcount;
        }
        if (v12286.account && !v12286.account.hack && !v12286.kpdData) {
          if (v12559 && UTILS.randInt(1, 100) == 100) {
            v12286.skinReward = v12559.index;
            this.giveSkin(v12286, v12559.index, "mapreward");
          }
          var v12561 = v12286.score * (this.mode.rewardMlt || 1);
          v12286.reward = Math.min(v12286.account.premiumT ? 40 : 30, Math.floor(v12561 / 100));
          if (v12286.challMode) {
            v12286.reward = Math.floor(v12286.reward * 1.5);
          }
          if (this.isOfficial && this.isOfficial.reward && v12286.didWin) {
            v12286.reward += this.isOfficial.reward;
          }
          var v12562 = Math.min(20, Math.floor(v12561 * 0.01));
          const vV12562 = v12562;
          if (!this.isEmptyLobby) {
            let v12563 = (this.mode.gameTime == null ? this.config.gameTime * 60000 : this.mode.gameTime) - Math.max(0, this.gameTimerP || 0);
            if ((v12286.playTime || 0) >= v12563 / 2) {
              v12562 += 30;
            }
          }
          if (v12286.account.BP && battlePass && battlePass.data) {
            const vV125622 = v12562;
            const vParseInt46 = parseInt(v12286.account.BP.bpp);
            const {
              award: iIíiiìì,
              newAvailable: iÍiìïîî
            } = battlePass.validateProgress(vParseInt46, v12562);
            v12562 = iIíiiìì;
            var v12564 = Math.max(iIíiiìì - vV12562, 0);
            v12286.account.BP.bpp += v12562;
            var v12565 = vParseInt46 + v12562;
            v12286.tmpBPData.pbpp = vParseInt46;
            v12286.tmpBPData.bpp = v12565;
            v12286.tmpBPData.gn = v12562;
            v12286.tmpBPData.bbpp = v12564;
            v12286.tmpBPData.unbpp = vV125622;
            v12286.tmpBPData.rbpp = iÍiìïîî;
            v12286.tmpBPData.re = battlePass.getNextReward(v12565, v12286.account.BP.tier);
          }
          v12286.reward += v12286.additionalReward;
        }
        v12286.additionalReward = 0;
      }
    }
    this.endTimer = this.isComp || this.mode.infEndTimer ? "inf" : fast ? 1 : config.endTimer;
    this.waitTimers = null;
    var v12566 = this.mode.endStats || config.endStats;
    if (this.isOfficial && v12566.indexOf("reward") == -1) {
      v12566.push("reward");
    }
    this.endData.modeIndex = this.modeIndex || 0;
    this.endData.vo = {};
    this.endData.tms = this.getTeamScores(true);
    let v12567 = this.config ? this.config.modes || this.map.rotationModes : null;
    let v12568 = this.config.maps || this.map.rotationMaps;
    this.endData.mts.length = 0;
    var vLN02231 = 0;
    var v12569 = v12567.indexOf(0) > -1;
    var v12570 = v12569 && config.events.find(event => event.id == game.eventIndex && event.limitedTimeMode);
    if (this.forceRaid) {
      this.forceRaid = false;
      this.endData.mts = [,,,,].fill("23," + config.raidMapId);
    } else if (UTILS.isNumber(this.forceMap) || UTILS.isNumber(this.forceMode)) {
      this.endData.mts = [,,,,].fill((this.forceMode == null ? this.modeIndex : this.forceMode) + "," + (this.forceMap == null ? this.mapIndex : this.forceMap));
      this.forceMap = undefined;
      this.forceMode = undefined;
    } else if (!this.isCustom && !this.isOfficial) {
      this.endData.mts = this.genMatchList(v12568, v12569, v12570);
    } else {
      while (this.endData.mts.length < 4) {
        let v12571 = vLN02231 == 0 && v12569 ? 0 : v12567 ? v12567[UTILS.randInt(0, v12567.length - 1)] : UTILS.getRandom(this.map.rotationModes);
        let v12572 = v12568[UTILS.randInt(0, v12568.length - 1)];
        let vA690 = [v12571, v12572];
        vA690 = vA690.join();
        if (this.endData.mts.indexOf(vA690) < 0) {
          this.endData.mts.push(vA690);
        }
        vLN02231++;
        if (vLN02231 > 20) {
          break;
        }
      }
    }
    if (this.mode.onEnd) {
      this.mode.onEnd(this, serverIO, dbClient);
    }
    if (this && this.mainScript && this.mainScript.onGameEnd) {
      this.mainScript.onGameEnd();
    }
    var vA691 = [];
    for (var vLN02232 = 0; vLN02232 < this.players.list.length; ++vLN02232) {
      v12286 = this.players.list[vLN02232];
      if (!!v12286.account && !v12286.account.hack && !v12286.kpdData && this.endIndex != 3) {
        this.checkChallenges(v12286);
      }
      this.endData.ed.length = 0;
      this.endData.mdls.length = 0;
      var v12573 = v12286.account && v12286.account.isDev;
      var v12574 = null;
      for (var vLN02235 = 0; vLN02235 < this.players.list.length; ++vLN02235) {
        if (!this.players.list[vLN02235].kpdData && (!this.players.list[vLN02235].bypassUser || !!this.isSandbox)) {
          for (var vLN02236 = 0; vLN02236 < v12566.length; ++vLN02236) {
            if (v12566[vLN02236] == "name") {
              this.endData.ed.push([this.players.list[vLN02235].getName(v12286.account, false, v12573 || v12286.kpdData), this.players.list[vLN02235].getName(v12286.account, true, v12573 || v12286.kpdData)]);
            } else {
              v12574 = config.endForm[v12566[vLN02236]] ? config.endForm[v12566[vLN02236]](this.players.list[vLN02235][v12566[vLN02236]], this, this.players.list[vLN02235]) : this.players.list[vLN02235][v12566[vLN02236]];
              if (v12566[vLN02236] == "reward" && this.players.list[vLN02235].skinReward) {
                v12574 = [v12574, this.players.list[vLN02235].skinReward];
              }
              this.endData.ed.push(v12574);
            }
          }
        }
      }
      for (var v12575 in v12286.medals) {
        this.endData.mdls.push(v12575, v12286.medals[v12575]);
      }
      if (v12286.account) {
        v12286.account.lastScore = v12286.score;
      }
      v12286.send("end", fast ? 2 : 0, this.winner || this.endIndex == 3 ? v12286.didWin : -1, this.endData, this.mode.teams ? this.winner || this.endIndex == 3 ? this.winner : -1 : -1, this.endIndex, v12286.reward, v12286.tmpBPData);
      v12286.reset();
      vA691.push(v12286.id);
    }
    this.endData.ed.length = 0;
    this.endData.mdls.length = 0;
    for (var vLN02235 = 0; vLN02235 < this.players.list.length; ++vLN02235) {
      if (!this.players.list[vLN02235].kpdData && (!this.players.list[vLN02235].bypassUser || !!this.isSandbox)) {
        for (var vLN02236 = 0; vLN02236 < v12566.length; ++vLN02236) {
          if (v12566[vLN02236] == "name") {
            this.endData.ed.push([this.players.list[vLN02235].getName(1, true, false)]);
          } else {
            this.endData.ed.push(config.endForm[v12566[vLN02236]] ? config.endForm[v12566[vLN02236]](this.players.list[vLN02235][v12566[vLN02236]], this, this.players.list[vLN02235]) : this.players.list[vLN02235][v12566[vLN02236]]);
          }
        }
        this.players.list[vLN02235].skinReward = null;
      }
    }
    if (this.endIndex == 3) {
      this.broadcastEx(vA691, "end", fast ? 2 : 0, false, this.endData, this.mode.teams ? this.winner || this.endIndex == 3 ? this.winner : -1 : -1, this.endIndex, 0, null);
    }
    vA691.length = 0;
    if (!this.isSandbox) {
      this.updateAccounts();
    }
    this.players.clear();
  };
  this._lastUpdate = 0;
  this.updateIndex = 0;
  this.tick = function () {
    this.updateIndex++;
    let now = Date.now();
    const delta = now - this._lastUpdate;
    this._lastUpdate = now;
    this.updateBans(delta);
    this.update(delta, now);
    if (serverHooks && serverHooks.checkPlayers) {
      serverHooks.checkPlayers(this, delta);
    } else if (this.isServer) {
      this.players.resetFreq();
    }
    this.syncState();
    this.updateState();
  };
  this.update = function (delta, now, cameraPos) {
    this.now = now;
    this.fixedDelta = delta;
    if (!this.isDestroyed) {
      if (this.isServer) {
        if (this.initInProgress) {
          return;
        }
        var v12578 = true;
        var v12579 = false;
        if (this.endTimer > 0) {
          v12578 = false;
          this.endTimer -= delta;
          if (this.endTimer <= 0) {
            this.init(undefined, undefined, 0, undefined, !this.isSandbox).then(function () {
              if (!this.isDestroyed) {
                this.broadcast("init", this.mapIndex, this.modeIndex, this.eventIndex, this.getTeamScores(true), this.getTeamScores(), this.host, this.config, this.customData, 0, this.customMapData || null, this.getSyncData(), this.networkData, false, !!this.isOfficial, this.isComp, this.sessionId, this.roundId, this.gameTimer);
              }
            }.bind(this));
            this.endTimer = 0;
          } else {
            v12288 = UTILS.getTime(this.endTimer);
            if (v12288 != this.lastTimer) {
              this.lastTimer = v12288;
              this.broadcast("t", v12288, 1);
            }
          }
        } else if (this.lockoutTimer) {
          this.lockoutTimer -= delta;
          if (this.lockoutTimer <= 0) {
            this.lockoutTimer = 0;
          }
          v12288 = UTILS.getTime(this.lockoutTimer);
          if (!this.lockoutTimer || v12288 != this.lastTimer) {
            this.lastTimer = v12288;
            this.broadcast("lkt", this.lockoutTimer);
          }
        } else if (this.endTimer == "inf") {
          if (this.endTimer != this.lastTimer) {
            this.lastTimer = this.endTimer;
            this.broadcast("t", "inf", this.endIndex || 2);
          }
        } else if (this.waitTimers) {
          v12578 = false;
          if (!this.waitTimers[0].dontWait && !this.waitTimers[0].contTime && this.minPlayers && this.players.activeCount() < this.minPlayers) {
            v12578 = false;
            v12579 = true;
            if (this.mode.needAll) {
              this.needAllTimer -= delta;
              if (this.needAllTimer <= 0) {
                this.endGame(3);
              } else {
                v12288 = UTILS.getTime(this.needAllTimer);
                if (v12288 != this.lastTimerNA) {
                  this.lastTimerNA = v12288;
                  this.broadcast("gmsg", "wt", v12288);
                }
              }
            } else {
              this.broadcast("gmsg", "wt");
            }
          } else {
            this.pastTimers = true;
            this.waitTimers[0].time -= delta;
            if (this.waitTimers[0].time <= 0) {
              if (this.waitTimers[0].trigger) {
                this.waitTimers[0].trigger(this, -this.waitTimers[0].time, serverIO);
              }
              if (this.waitTimers[0].time <= 0) {
                var v12580 = !!this.waitTimers[0].noClear;
                this.waitTimers.splice(0, 1);
                if (!this.waitTimers.length) {
                  this.waitTimers = null;
                  if (!v12580) {
                    this.broadcast("gmsg");
                  }
                }
              }
            } else {
              v12288 = UTILS.getTime(this.waitTimers[0].time);
              if (v12288 != this.lastTimerW) {
                this.lastTimerW = v12288;
                var vLN02237 = 0;
                if (this.waitTimers[0].getSnd) {
                  vLN02237 = this.waitTimers[0].getSnd(v12288);
                }
                var vLN02238 = 0;
                if (this.waitTimers[0].getPop) {
                  vLN02238 = this.waitTimers[0].getPop(v12288);
                }
                this.broadcast("gmsg", this.waitTimers[0].msg, v12288, vLN02237, vLN02238, this.waitTimers[0].hideGameUI ? 1 : 0);
              }
            }
          }
        }
        if (!this.lockoutTimer && this.endTimer <= 0 && !v12579 && (v12578 || this.waitTimers && this.waitTimers[0].contTime)) {
          if (this.condition) {
            for (var vLN02245 = 0; vLN02245 < this.condition.length; vLN02245++) {
              if (!this.condition[vLN02245](this)) {
                this.gameTimer = "skip";
                break;
              }
            }
          }
          if (this.gameTimer != "skip" && this.mode && this.mode.timed) {
            this.gameTimer += delta;
            this.gameTimerP += delta;
            v12288 = UTILS.getTime(this.gameTimer, this.mode.showMS, this.mode.showHour);
            if (v12288 != this.lastTimer) {
              this.lastTimer = v12288;
              this.broadcast("t", v12288, 0, this.gameTimer);
            }
          } else if (this.gameTimer > 0 || this.gameTimer == "skip") {
            if (this.gameTimer != "skip") {
              this.gameTimer -= delta;
              this.gameTimerP -= delta;
            }
            if (this.gameTimer == "skip" || this.gameTimer <= 0) {
              this.gameTimer = 0;
              this.endGame();
            } else {
              v12288 = UTILS.getTime(this.gameTimer, this.mode.showMS);
              if (v12288 != this.lastTimer) {
                this.lastTimer = v12288;
                this.broadcast("t", v12288, 0, this.gameTimer);
              }
            }
          }
        }
        this.updateStreaks(delta);
        if (this.voteToKick) {
          this.voteToKick.timer -= delta;
          if (this.voteToKick.timer <= 0) {
            this.voteToKick = null;
            this.broadcast("vk", null);
          }
        }
        if (this.voteToForfeit) {
          this.voteToForfeit.timer -= delta;
          if (this.voteToForfeit.timer <= 0) {
            this.voteToForfeit = null;
            this.broadcast("vf", null);
          }
        }
        this.updateBomb(delta);
        this.updateEvents(delta);
        if (!this.waitTimers || this.waitTimers[0] && this.waitTimers[0].contTime) {
          for (var vLN02245 = 0; vLN02245 < this.map.manager.timerObjs.length; ++vLN02245) {
            v12286 = this.map.manager.objects[this.map.manager.timerObjs[vLN02245]];
            if (v12286 && !(v12286.trigT <= 0) && v12286.active) {
              v12286.trigT -= delta;
              if (v12286.trigT <= 0) {
                v12286.trigT = (v12286.trigConstE || 1) * 1000;
                this.onTrigger(null, v12286);
              }
            }
          }
          for (var vLN02245 = this.triggerQueue.length - 1; vLN02245 >= 0; vLN02245--) {
            v12286 = this.triggerQueue[vLN02245];
            v12286.timer -= delta;
            if (v12286.timer <= 0) {
              this.triggers.actions[v12286.action.trigAct || 0].execute(this, serverIO, v12286.player, v12286.obj, v12286.action, v12286.chain);
              this.triggerQueue.splice(vLN02245, 1);
            }
          }
          this.updateObjectiveTime(delta);
        }
      }
      this.updatePowerups(!!serverIO, delta * this.config.deltaMlt);
      if (this.bots) {
        this.bots.update(delta * this.config.deltaMlt);
      }
      this.players.update(delta * this.config.deltaMlt);
      this.updatePlayerSounds(delta * this.config.deltaMlt);
      this.AI.update(delta * this.config.deltaMlt);
      this.pets.update(delta * this.config.deltaMlt);
      this.airDrop.update(delta * this.config.deltaMlt);
      this.updateTeleporters(delta * this.config.deltaMlt);
      if (serverIO) {
        this.updateSpinners(delta * this.config.deltaMlt);
      }
      this.updateDestructables(delta * this.config.deltaMlt);
      this.updateFlags(!!serverIO, cameraPos, delta * this.config.deltaMlt);
      this.updateSpawnables(!!serverIO, cameraPos, delta * this.config.deltaMlt);
      this.updateDomZones(delta * this.config.deltaMlt);
      this.updateMysteryBoxes(!!serverIO, cameraPos, delta * this.config.deltaMlt);
      this.updateKrumMachines(!!serverIO, cameraPos, delta * this.config.deltaMlt);
      if (!this.isServer && this.objActive) {
        this.updateObjectiveTime(delta * this.config.deltaMlt);
      }
      if (this.isServer && this.mode && this.mode.update) {
        this.mode.update(this, serverIO, delta * this.config.deltaMlt);
      }
      if (this.map.zone) {
        if (!this.isServer || !!this.waitTimers && (!this.waitTimers[0] || !this.waitTimers[0].contTime)) {
          if (!serverIO) {
            this.map.zone.animate(delta * this.config.deltaMlt);
          }
        } else {
          this.zoneTimer -= delta * this.config.deltaMlt;
          this.map.zone.update(delta * this.config.deltaMlt / 1000, null, this);
          if (this.zoneTimer <= 0) {
            this.zoneTimer = 1000;
            this.broadcast("zn", this.map.zone.getData());
            for (var vLN02241 = 0; vLN02241 < this.players.list.length; ++vLN02241) {
              v12287 = this.players.list[vLN02241];
              if (v12287.active && (!this.mode.teamOptions || this.mode.teamOptions[v12287.team - 1] != "Infected") && this.map.zone.isOutside(v12287) && this.players.changeHealth(v12287, null, 10)) {
                this.players.kill(v12287);
              }
            }
          }
        }
      }
      this.projectiles.update(delta * this.config.deltaMlt);
      if (PARTICLES) {
        PARTICLES.update(delta * this.config.deltaMlt, window.spectating ? RENDER.fpsCamera.getWorldPosition(worldPos) : cameraPos);
      }
      if (this.mainScript && this.mainScript.update) {
        this.mainScript.update(delta * this.config.deltaMlt);
      }
      if (RENDER) {
        RENDER.render(delta * this.config.deltaMlt);
      }
      if (this.isServer) {
        for (var vLN02245 = 0; vLN02245 < this.players.list.length; ++vLN02245) {
          v12286 = this.players.list[vLN02245];
          if (v12286.active && v12286.lastProg != v12286.interProg) {
            v12286.lastProg = v12286.interProg;
            for (var vLN02244 = 0; vLN02244 < this.players.list.length; ++vLN02244) {
              if (this.players.list[vLN02244].specStream == v12286.sid) {
                this.players.list[vLN02244].send("p", (v12286.interProg || 0).round(3));
              }
            }
          }
          if (v12286.active && v12286.lastMProg != v12286.interMProg) {
            v12286.lastMProg = v12286.interMProg;
            for (var vLN02244 = 0; vLN02244 < this.players.list.length; ++vLN02244) {
              if (this.players.list[vLN02244].specStream == v12286.sid) {
                this.players.list[vLN02244].send("mp", (v12286.interMProg || 0).round(3));
              }
            }
          }
        }
        for (var vLN02245 = 0; vLN02245 < this.teamScoreUpd.length; ++vLN02245) {
          this.broadcast("ts", this.teamScoreUpd[vLN02245], this.teamScores[this.teamScoreUpd[vLN02245]]);
        }
        if (this.leadersUpdated) {
          this.players.syncLeaders(true);
        }
        this.teamScoreUpd.length = 0;
      }
    }
  };
  var player = null;
  var v12583 = null;
  var vA692 = [];
  this.updateState = function () {
    var now = Date.now();
    if (!this.isDestroyed && UTILS.shouldUpdate(this.updateIndex, config.serverTickFrequency, this.sendFrequency)) {
      for (var vLN02246 = 0; vLN02246 < this.players.list.length; ++vLN02246) {
        player = this.players.list[vLN02246];
        if ((player.active || player.spectating) && !player.locked) {
          this.players.storeState(player, now);
          if (this.noSync) {
            continue;
          }
          vA692.length = 0;
          for (var vLN02247 = 0; vLN02247 < this.players.list.length; ++vLN02247) {
            v12583 = this.players.list[vLN02247];
            if (player != v12583 && !!v12583.active && !v12583.isHidden && (!!player.spectating || !this.mode || !this.mode.viewDis || !(this.mode.viewDis <= UTILS.getD3D(v12583.x, v12583.y, v12583.z, player.x, player.y, player.z))) && !v12583.kpdData) {
              vA692.push(v12583.sid, v12583.x.round(2), v12583.y.round(2), v12583.z.round(2), Math.round(UTILS.toDeg(v12583.xDire)), Math.round(UTILS.toDeg(v12583.yDire)), v12583.stepVal, v12583.onGround ? 1 : 0, Math.round(v12583.crouchVal), v12583.loadoutIndex, v12583.aimVal ? 1 : 0, v12583.grapple ? [Math.round(v12583.grapple.x), Math.round(v12583.grapple.y), Math.round(v12583.grapple.z)] : 0, Math.round(v12583.ping));
            }
          }
          player.send("k", vA692 || null, this.sendFrequency, now - this.startTime);
        }
      }
      if (UTILS.shouldUpdate(this.updateIndex, this.tickFrequency, this.aiSyncT)) {
        this.AI.sync();
      }
      if (UTILS.shouldUpdate(this.updateIndex, this.leaderOSync, 1)) {
        this.leaderboard.sync();
      }
      if (UTILS.shouldUpdate(this.updateIndex, this.airDSyncT, 1)) {
        this.airDrop.sync();
      }
    }
  };
  this.syncState = function () {
    var now = Date.now();
    if (!this.isDestroyed && UTILS.shouldUpdate(this.updateIndex, config.serverTickFrequency, this.syncFrequency)) {
      for (var vLN02248 = 0; vLN02248 < this.players.list.length; ++vLN02248) {
        player = this.players.list[vLN02248];
        player.pingTime = now;
        vA692.length = 0;
        if (player.active && !this.noSync) {
          vA692.push(player.inputSN, Math.round(player.ping), player.x, player.y, player.z, player.velocity.y, player.velocity.x, player.velocity.z, player.xDire, player.onGround ? 1 : 0, player.didJump ? 1 : 0, player.didJumpW ? 1 : 0, player.wallJumpC, player.onWall ? 1 : 0, player.onLadder ? 1 : 0, player.aimVal, player.crouchVal, player.loadoutIndex, player.slideTimer, player.canSlide ? 1 : 0, player.onTerrain ? 1 : 0, player.xVelC, player.zVelC, player.grapple || 0, player.canSlideT);
          let vA693 = [];
          if (serverHooks && serverHooks.checkCustSync) {
            var v12586 = serverHooks.checkCustSync(player);
            if (v12586) {
              vA693.push(...v12586);
            }
          }
          vA692.push(vA693.length ? vA693 : 0);
          var v12587 = this.movement[player.config.movSch || 0];
          if (v12587 && v12587.sendVals && v12587.sendVals.length) {
            for (var vLN02249 = 0; vLN02249 < v12587.sendVals.length; ++vLN02249) {
              vA692.push(player[v12587.sendVals[vLN02249]]);
            }
          }
        }
        player.send("l", vA692.length ? vA692 : 0);
      }
    }
  };
  this.updateBans = function (delta) {
    if (this.banTempList) {
      for (var v12588 in this.banTempList) {
        this.banTempList[v12588] -= delta;
        if (this.banTempList[v12588] <= 0) {
          delete this.banTempList[v12588];
        }
      }
    }
  };
  this.getPossibleMatches = function (maps) {
    var vO402 = {
      party: [],
      normal: [],
      event: []
    };
    for (var vLN02250 = 0; vLN02250 < maps.length; vLN02250++) {
      var v12589;
      var v12590 = this.map.maps[maps[vLN02250]];
      for (var v12591 = v12590.config && v12590.config.modes ? v12590.config.modes : [0], vLN02251 = 0; vLN02251 < v12591.length; vLN02251++) {
        v12589 = v12591[vLN02251] + "," + maps[vLN02250];
        if (!gameModes[v12591[vLN02251]].preventCustomGames || gameModes[v12591[vLN02251]].event != null && this.eventIndex == gameModes[v12591[vLN02251]].event) {
          if (gameModes[v12591[vLN02251]].party) {
            if (vO402.party.indexOf(v12589) == -1) {
              vO402.party.push(v12589);
            }
          } else if (gameModes[v12591[vLN02251]].event) {
            if (vO402.event.indexOf(v12589) == -1) {
              vO402.event.push(v12589);
            }
          } else if (vO402.normal.indexOf(v12589) == -1) {
            vO402.normal.push(v12589);
          }
        }
      }
    }
    return vO402;
  };
  this.genMatchList = function (maps, includeFFA, hasEvent) {
    maps = maps || this.map.rotationMaps;
    var v12592 = this.getPossibleMatches(maps);
    var v12593 = v12592.normal;
    var v12594 = v12592.party;
    var v12595 = v12592.event;
    UTILS.yateShuffle(v12593);
    UTILS.yateShuffle(v12594);
    UTILS.yateShuffle(v12595);
    var v12596 = config.matchPicks;
    var vA694 = [];
    if (hasEvent && v12595[0]) {
      vA694.push(v12595[0]);
      v12595.splice(v12595[0], 1);
      v12596--;
    }
    if (includeFFA) {
      var v12597 = v12593.findIndex(item => item && item.startsWith("0"));
      if (v12597 >= 0) {
        vA694.push(v12593[v12597]);
        v12593.splice(v12597, 1);
        v12596--;
      }
    }
    if (v12593.length) {
      for (var vLN02253 = 0; vLN02253 < v12596 - 1; vLN02253++) {
        UTILS.yateShuffle(v12593);
        vA694.push(v12593[0]);
        v12593.shift();
      }
    }
    if (v12594.length && vA694.length < config.matchPicks) {
      UTILS.yateShuffle(v12594);
      vA694.push(v12594[0]);
      v12594.shift();
    }
    return vA694;
  };
  this.validateAccountName = function (name) {
    return !this.accountTeams || !!name && (!!this.isAccountSpec(name) || this.getAccountTeamIndex(name) != -1);
  };
  this.getAccountTeamIndex = function (name) {
    if (!this.accountTeams || !name) {
      return -1;
    }
    var v12598;
    for (var vLN02254 = 0; vLN02254 < this.accountTeams.length; vLN02254++) {
      v12598 = this.accountTeams[vLN02254];
      if (v12598.indexOf(name) >= 0) {
        return vLN02254;
      }
    }
    return -1;
  };
  this.isAccountSpec = function (name) {
    return !!this.accountSpecs && !!name && this.accountSpecs.indexOf(name) >= 0;
  };
  this.logPunishment = function (from, target, reason) {
    if (target && from && from.account && (from.account.isMod || from.account.isDeputy) && game.host != from.id) {
      dbClient.call(167, [target.account ? target.account.id : 0, from.account.id, game.gameInstance.id, reason], function () {});
    }
  };
  this.kick = function (player, reason) {
    return !!player && (player.kicked = true, player.send("error", reason || "Kicked by host"), serverIO.sockets[player.id] && serverIO.sockets[player.id].close(), true);
  };
  this.teamCheck = function (a, b) {
    return !a.team || !game.mode || !game.mode.teams || !!b && a.team == b.team;
  };
  this.getTime = time => UTILS.getTime(time);
  this.send = function () {
    (game.isSandbox ? game.sandbox : serverIO).send(...arguments);
  };
  this.broadcast = function () {
    (game.isSandbox ? game.sandbox : serverIO).broadcast("game" + game.sid, ...arguments);
  };
  this.broadcastEx = function () {
    (game.isSandbox ? game.sandbox : serverIO).broadcastEx("game" + game.sid, ...arguments);
  };
  this.setup = function () {
    this._lastUpdate = Date.now();
    this.tickInterval = setInterval(this.tick.bind(this), config.serverTickRate);
  };
  if (serverIO) {
    this.setup();
  }
};